// src/product-features.ts
var FEATURE_STATES = ["open", "locked", "gray", "off"];
var FEATURE_STATE_LABELS = {
  open: "\u043E\u0442\u043A\u0440\u044B\u0442\u043E",
  locked: "\u043F\u043E\u0434 \u0437\u0430\u043C\u043A\u043E\u043C",
  gray: "\u0441\u0435\u0440\u044B\u043C",
  off: "\u043D\u0435\u0442"
};
var PRODUCT_FEATURES = [
  "app",
  "diary",
  "nutrition",
  "lectures",
  "tfaLectures",
  "curator",
  "curatorNutrition",
  "photos",
  "measurements",
  "metrics",
  "fatsecret",
  "calcNorm",
  "technique",
  "character",
  "gamification",
  "shop",
  "challenges",
  "leaderboard",
  "ai",
  "programPause",
  "selfProgram"
];
var PRODUCT_FEATURE_LABELS = {
  app: "\u0414\u043E\u0441\u0442\u0443\u043F \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
  diary: "\u0414\u043D\u0435\u0432\u043D\u0438\u043A",
  nutrition: "\u041F\u0438\u0442\u0430\u043D\u0438\u0435",
  lectures: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u2014 \u0443\u0440\u043E\u043A\u0438 \u0442\u0430\u0440\u0438\u0444\u0430",
  tfaLectures: "\u041A\u0443\u0440\u0441 \u0422\u0424\u0410 \u0432 \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0438",
  curator: "\u041A\u0443\u0440\u0430\u0442\u043E\u0440",
  curatorNutrition: "\u041A\u0443\u0440\u0430\u0442\u043E\u0440 \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u0442 \u043F\u0438\u0442\u0430\u043D\u0438\u0435",
  photos: "\u0424\u043E\u0442\u043E \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0430",
  measurements: "\u0417\u0430\u043C\u0435\u0440\u044B \u0442\u0435\u043B\u0430",
  metrics: "\u0421\u043E\u043D, \u0448\u0430\u0433\u0438, \u0432\u0435\u0441",
  fatsecret: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0441 FatSecret",
  calcNorm: "\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440 \u043D\u043E\u0440\u043C\u044B \u041A\u0411\u0416\u0423",
  technique: "\u0412\u0438\u0434\u0435\u043E\u0440\u0430\u0437\u0431\u043E\u0440 \u0442\u0435\u0445\u043D\u0438\u043A\u0438",
  character: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u0436 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u0439",
  gamification: "\u0411\u0430\u043B\u043B\u044B, \u0443\u0440\u043E\u0432\u043D\u0438, \u0441\u0435\u0440\u0438\u044F, \u043C\u043E\u043D\u0435\u0442\u044B",
  shop: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
  challenges: "\u0427\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0438",
  leaderboard: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433 (\u043B\u0438\u0433\u0430)",
  ai: "\u0418\u0418-\u041F\u0430\u0432\u0435\u043B",
  programPause: "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u0430",
  selfProgram: "\u0412\u044B\u0431\u043E\u0440 \u0438 \u043F\u0440\u0430\u0432\u043A\u0430 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B"
};
var PRODUCTS_IN_MATRIX = ["TFA_STEP1", "TFA_STEP2", "CLUB", "TRAINING", "PROGRAM", "NONE"];
var all = (state) => Object.fromEntries(PRODUCT_FEATURES.map((f) => [f, state]));
var withDefaults = (base, patch) => ({ ...base, ...patch });
var TFA = withDefaults(all("open"), {
  // Норму КБЖУ задаёт куратор, программу составляет куратор.
  calcNorm: "off",
  selfProgram: "off"
});
var DEFAULT_PRODUCT_FEATURES = {
  TFA_STEP1: TFA,
  TFA_STEP2: TFA,
  CLUB: withDefaults(all("open"), {
    curator: "off",
    curatorNutrition: "off",
    photos: "off",
    programPause: "off",
    technique: "gray"
    // «только в ТФА»: не запись без проверки, а отсутствие функции
  }),
  // Тренинг (этап 5, #547–#549): куратор есть, но ведёт только тренировки —
  // составляет программу, смотрит видео и заметки. Питание клиент ведёт сам
  // (норма из калькулятора), куратору оно в задачи и сводки не попадает.
  TRAINING: withDefaults(all("off"), {
    app: "open",
    diary: "open",
    nutrition: "open",
    lectures: "open",
    tfaLectures: "gray",
    curator: "open",
    fatsecret: "gray",
    calcNorm: "open",
    technique: "open",
    character: "gray",
    shop: "locked",
    challenges: "locked",
    leaderboard: "locked",
    ai: "locked"
  }),
  PROGRAM: withDefaults(all("off"), {
    diary: "open",
    nutrition: "open",
    lectures: "open",
    tfaLectures: "gray",
    fatsecret: "gray",
    calcNorm: "open",
    technique: "gray",
    character: "gray",
    shop: "locked",
    challenges: "locked",
    leaderboard: "locked",
    ai: "locked",
    selfProgram: "open"
  }),
  NONE: all("off")
};
function effectiveProductFeatures(overrides = {}) {
  const out = {};
  for (const p of PRODUCTS_IN_MATRIX) out[p] = { ...DEFAULT_PRODUCT_FEATURES[p], ...overrides[p] ?? {} };
  return out;
}
function featureState(product, feature, access) {
  if (!product) return "off";
  const fromAccess = access?.[feature];
  if (fromAccess) return fromAccess;
  return DEFAULT_PRODUCT_FEATURES[product]?.[feature] ?? "off";
}
function isFeatureOpen(product, feature, access) {
  return featureState(product, feature, access) === "open";
}
function lectureModulesProductFor(product) {
  if (!product) return null;
  if (product === "CLUB") return "TFA_STEP1";
  return product;
}
function lecturesUnlockedAtOnce(product) {
  return product === "CLUB";
}
function ownLectureCourseFor(product) {
  switch (product) {
    case "TFA_STEP1":
    case "TFA_STEP2":
    case "CLUB":
      return "tfa";
    case "PROGRAM":
      return "program";
    case "TRAINING":
      return "training";
    default:
      return null;
  }
}
function tfaCourseRoleFor(product, access) {
  const st = featureState(product, "tfaLectures", access);
  return st === "open" ? "open" : st === "gray" ? "gray" : "off";
}

// src/kbju-calculator.ts
var CALC_ACTIVITY = {
  min: { factor: 1.2, label: "\u0421\u0438\u0434\u044F\u0447\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430, \u0431\u0435\u0437 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u043A" },
  light: { factor: 1.375, label: "1\u20133 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  medium: { factor: 1.55, label: "3\u20135 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u043A \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  high: { factor: 1.725, label: "6\u20137 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u043A \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  extreme: { factor: 1.9, label: "\u0422\u044F\u0436\u0451\u043B\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430 \u043F\u043B\u044E\u0441 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438" }
};
var CALC_GOAL = {
  lose: { factor: 0.85, label: "\u041F\u043E\u0445\u0443\u0434\u0435\u0442\u044C" },
  keep: { factor: 1, label: "\u0414\u0435\u0440\u0436\u0430\u0442\u044C \u0432\u0435\u0441" },
  gain: { factor: 1.1, label: "\u041D\u0430\u0431\u0440\u0430\u0442\u044C" }
};
var KBJU_INPUT_RANGES = {
  age: { min: 14, max: 90 },
  heightCm: { min: 120, max: 230 },
  weightKg: { min: 30, max: 300 }
};
function isValidKbjuInput(i) {
  const inRange = (v, r) => typeof v === "number" && Number.isFinite(v) && v >= r.min && v <= r.max;
  return (i.sex === "MALE" || i.sex === "FEMALE") && inRange(i.age, KBJU_INPUT_RANGES.age) && inRange(i.heightCm, KBJU_INPUT_RANGES.heightCm) && inRange(i.weightKg, KBJU_INPUT_RANGES.weightKg) && !!i.activity && i.activity in CALC_ACTIVITY && !!i.goal && i.goal in CALC_GOAL;
}
function calculateKbju(i) {
  const bmr = 10 * i.weightKg + 6.25 * i.heightCm - 5 * i.age + (i.sex === "MALE" ? 5 : -161);
  const tdee = bmr * CALC_ACTIVITY[i.activity].factor;
  const calories = Math.max(1200, Math.round(tdee * CALC_GOAL[i.goal].factor / 10) * 10);
  const protein = Math.round(i.weightKg * (i.goal === "lose" ? 2 : 1.8));
  const fat = Math.round(i.weightKg * (i.goal === "lose" ? 0.8 : 1));
  const carbs = Math.max(0, Math.round((calories - protein * 4 - fat * 9) / 4));
  return { bmr: Math.round(bmr), tdee: Math.round(tdee), calories, protein, fat, carbs };
}

// src/program-catalog.ts
var LEVEL_MATTERS = /* @__PURE__ */ new Set(["FULLBODY", "UPPERLOWER"]);
var KIND_RULES = [
  ["HOME", /дом(а|ашн)/i],
  ["MINIMAL", /минимализм/i],
  ["GLUTES", /ягодиц/i],
  ["ARMS", /(?<![а-яё])рук(и|ам)?(?![а-яё])/i],
  ["PUSHPULL", /push\s*\/?\s*pull|тяни\s*\/?\s*толкай/i],
  ["HYBRID", /hybr[iy]d/i],
  ["UPPERLOWER", /верх/i],
  ["FULLBODY", /full\s*-?\s*body|вс[её]\s+тело/i]
];
function programGenderFromName(name) {
  if (/мужчин|муж\b/i.test(name)) return "MALE";
  if (/девуш|женщин|жен\b/i.test(name)) return "FEMALE";
  return null;
}
function programKindFromName(name) {
  for (const [kind, re] of KIND_RULES) if (re.test(name)) return kind;
  return null;
}
function programLevelFromName(name) {
  const beginner = /новичк/i.test(name);
  const advanced = /опытн/i.test(name);
  if (beginner && advanced) return null;
  if (beginner) return "BEGINNER";
  if (advanced) return "ADVANCED";
  return null;
}
function programKeyFromName(name) {
  if (!name) return null;
  const gender = programGenderFromName(name);
  const kind = programKindFromName(name);
  if (!gender || !kind) return null;
  if (!LEVEL_MATTERS.has(kind)) return `${gender}:${kind}`;
  const level = programLevelFromName(name);
  return level ? `${gender}:${kind}:${level}` : `${gender}:${kind}`;
}
function programMatchesPurchase(name, purchased) {
  const key = programKeyFromName(name);
  return key != null && purchased.has(key);
}
function isPaidXlOrder(order) {
  if (!order) return false;
  return order.fullyPaid === true || String(order.status ?? "").toLowerCase() === "fulfilled";
}
function coursePlanIdsOf(product) {
  if (!product || !Array.isArray(product.contents)) return null;
  return product.contents.map((c) => c?.coursePlanId).filter((id) => !!id);
}
function resolvePurchasedPrograms(orders, tariffs) {
  const byPlan = new Map(tariffs.map((t) => [t.coursePlanId, t]));
  const templateIds = /* @__PURE__ */ new Set();
  const moduleXlIds = /* @__PURE__ */ new Set();
  let pending = false;
  for (const { order, product } of orders) {
    if (!isPaidXlOrder(order)) continue;
    const plans = coursePlanIdsOf(product);
    if (plans === null) {
      pending = true;
      continue;
    }
    for (const plan of plans) {
      const t = byPlan.get(plan);
      if (!t) continue;
      templateIds.add(t.templateId);
      if (t.moduleXlId) moduleXlIds.add(t.moduleXlId);
    }
  }
  return { templateIds, moduleXlIds, missing: templateIds.size === 0 && !pending, pending };
}
function isProgramSectionVisible(section, mine, allMapped) {
  if (mine.has(section.xlId)) return true;
  if (allMapped.has(section.xlId)) return false;
  return programKeyFromName(section.title) == null;
}
var PROGRAM_TARIFF_SEED = [
  { coursePlanId: "GG59ZdcXOE6jRUVjcWqRyQ", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 Full Body Hybryd. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E.", templateId: "e2a20f3f-242f-4392-816b-1a62c5fe982a", templateName: "Hybrid Fullbody \u0434\u0435\u0432\u0443\u0448\u043A\u0438 \u043E\u043F\u044B\u0442\u043D\u044B\u0435 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: "_3xvzl5he02Jr1tXZ3H2bA", moduleTitle: "Full Body Hybryd (\u0412\u0441\u0435 \u0442\u0435\u043B\u043E \u0433\u0438\u0431\u0440\u0438\u0434\u043D\u0430\u044F) \u0414\u0435\u0432\u0443\u0448\u043A\u0438. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E." },
  { coursePlanId: "yyRKSPiwZEmNZSOaxzYnkA", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 Full Body. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. 2 \u0438\u043B\u0438 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E.", templateId: "643f8124-6e7e-4c84-a8a2-15c426489623", templateName: "FULL BODY \u0434\u0435\u0432\u0443\u0448\u043A\u0438 \u043D\u043E\u0432\u0438\u0447\u043A\u0438 2-3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: "1vhVd41_YE-LlpR2-Wa1Rg", moduleTitle: "Full Body (\u0412\u0441\u0435 \u0442\u0435\u043B\u043E)\u0414\u0435\u0432\u0443\u0448\u043A\u0438. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 2 \u0438\u043B\u0438 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "TiPQDZRivECYSEwKOSu0tg", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 Full Body. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E.", templateId: "5693ec3a-48ea-45c3-952a-588de15dc1f4", templateName: "FULL BODY \u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u043E\u043F\u044B\u0442\u043D\u044B\u0435 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: "HjyDRJs600iWn4wUBpAG2Q", moduleTitle: "Full Body (\u0412\u0441\u0435 \u0442\u0435\u043B\u043E) \u0414\u0435\u0432\u0443\u0448\u043A\u0438. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "wz-EspBbt0uw7Lh-mmpihQ", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u0412\u0435\u0440\u0445 \u0442\u0435\u043B\u0430/\u043D\u0438\u0437 \u0442\u0435\u043B\u0430. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", templateId: "f4ecfe61-da02-42c0-ab85-f84f2e104c7e", templateName: "\u0412\u0435\u0440\u0445/\u041D\u0438\u0437 \u0434\u0435\u0432\u0443\u0448\u043A\u0438 \u043D\u043E\u0432\u0438\u0447\u043A\u0438 4 \u0440\u0430\u0437\u0430", moduleXlId: "Z4uPcvB75EKwnt7hySqetQ", moduleTitle: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u0412\u0435\u0440\u0445 \u0442\u0435\u043B\u0430/\u043D\u0438\u0437 \u0442\u0435\u043B\u0430. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "JQcOJ7uSMEWcHhSy9mCEFw", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u0412\u0435\u0440\u0445 \u0442\u0435\u043B\u0430/\u043D\u0438\u0437 \u0442\u0435\u043B\u0430. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", templateId: "ffc72d8f-9d31-4f6d-9493-502c46b2d91b", templateName: "\u0412\u0435\u0440\u0445/\u041D\u0438\u0437 \u0434\u0435\u0432\u0443\u0448\u043A\u0438 \u043E\u043F\u044B\u0442\u043D\u044B\u0435 4 \u0440\u0430\u0437\u0430", moduleXlId: "jvfINHL_R0yeTCeFscTFdQ", moduleTitle: "\u0412\u0415\u0420\u0425 \u0422\u0415\u041B\u0410/ \u041D\u0418\u0417 \u0422\u0415\u041B\u0410 \u0414\u0435\u0432\u0443\u0448\u043A\u0438. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E." },
  { coursePlanId: "bwiJ8wY0wUOIG6unlVPCOA", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u0414\u043E\u043C\u0430\u0448\u043D\u0438\u0435 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438", templateId: "41c121d6-043e-4320-8642-617bf5a18c31", templateName: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u043B\u044F \u0434\u043E\u043C\u0430. \u0414\u0435\u0432\u0443\u0448\u043A\u0438", moduleXlId: "Oca4wjOQHUKRu2UPEJCGSw", moduleTitle: "\u0414\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0430 FULL BODY \u0414\u0435\u0432\u0443\u0448\u043A\u0438. \u041D\u043E\u0432\u0438\u0447\u043A\u0438 \u0438 \u043E\u043F\u044B\u0442\u043D\u044B\u0435. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 2 \u0438\u043B\u0438 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E." },
  { coursePlanId: "1VAXKtozg0-_JzXBMQYrYg", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u0438\u0437\u043C 2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", templateId: "a01605c7-b103-4cb3-9e99-5fe16b08b7f7", templateName: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u0438\u0437\u043C 2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: null, moduleTitle: null },
  { coursePlanId: "uSk0_mtE7U6BYxEtv-yVsQ", title: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u043D\u0430 \u044F\u0433\u043E\u0434\u0438\u0446\u044B", templateId: "ac759b7a-a5cd-4043-9a51-a2a06bde464c", templateName: "\u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u0443\u0441\u0438\u043B\u0435\u043D\u043D\u044B\u0439 \u0440\u043E\u0441\u0442 \u044F\u0433\u043E\u0434\u0438\u0446", moduleXlId: null, moduleTitle: null },
  { coursePlanId: "eVQY5sbwoEabgXmJ-eHW-w", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B Full Body. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. 2/3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E.", templateId: "25ecfec4-e1ec-4a9e-b7e1-fcd2a3f8bc22", templateName: "FULL BODY \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043D\u043E\u0432\u0438\u0447\u043A\u0438 2-3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: "QdzzbOpyREKT2xajZPv2fA", moduleTitle: "\u0414\u043E\u0441\u0442\u0443\u043F Full Body (\u0412\u0441\u0435 \u0442\u0435\u043B\u043E) \u041C\u0443\u0436\u0447\u0438\u043D\u044B. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "cLgQmlPd1km18cKcMddWCQ", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B Full Body. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E.", templateId: "a532de1b-67b3-4da9-8926-d27db27eb1f3", templateName: "Full Body \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u043F\u044B\u0442\u043D\u044B\u0435 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: "4e-JMzMqJU6wshHYpQrV8Q", moduleTitle: "\u041E\u043A\u0430\u0437\u0430\u043D\u0438\u0435 \u0443\u0441\u043B\u0443\u0433 \u043F\u043E \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u044E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u043A Full Body \u041C\u0443\u0436\u0447\u0438\u043D\u044B. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E." },
  { coursePlanId: "eLo8xkG0pkuYJ7ORqdisbA", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B Push/Pull . \u041E\u043F\u044B\u0442\u043D\u044B\u0435. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E.", templateId: "2c7ed169-6a9e-453f-95d3-06b03ca11491", templateName: "PUSH/PULL \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u043F\u044B\u0442\u043D\u044B\u0435 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: "Nry6CFzpyE2Y3V8G1knKhQ", moduleTitle: "Push/Pull (\u0442\u043E\u043B\u043A\u0430\u044E\u0449\u0438\u0435/ \u0442\u044F\u043D\u0443\u044E\u0449\u0438\u0435 \u043C\u044B\u0448\u0446\u044B) \u041C\u0443\u0436\u0447\u0438\u043D\u044B. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "s23q_x0J-0Ok6zuXo1ipCg", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0412\u0435\u0440\u0445 \u0442\u0435\u043B\u0430/\u043D\u0438\u0437 \u0442\u0435\u043B\u0430. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", templateId: "bca39e3d-801f-4b46-9cf0-471396a6e62d", templateName: "\u0412\u0435\u0440\u0445/\u041D\u0438\u0437 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043D\u043E\u0432\u0438\u0447\u043A\u0438", moduleXlId: "fCyovFinq0-CyzcKtG1CJg", moduleTitle: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0412\u0435\u0440\u0445 \u0442\u0435\u043B\u0430/\u043D\u0438\u0437 \u0442\u0435\u043B\u0430. \u041D\u043E\u0432\u0438\u0447\u043A\u0438. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "JumPjYnA2E-dsxH3UtYZOg", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0412\u0435\u0440\u0445 \u0442\u0435\u043B\u0430/\u043D\u0438\u0437 \u0442\u0435\u043B\u0430. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", templateId: "e4003ea5-fb29-465b-aefd-23bf4063bcc8", templateName: "\u0412\u0435\u0440\u0445/\u041D\u0438\u0437 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u043F\u044B\u0442\u043D\u044B\u0435 4 \u0440\u0430\u0437\u0430", moduleXlId: "U8eQhrLEX0mMLeDrFgFqVQ", moduleTitle: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0412\u0435\u0440\u0445 \u0442\u0435\u043B\u0430/\u043D\u0438\u0437 \u0442\u0435\u043B\u0430. \u041E\u043F\u044B\u0442\u043D\u044B\u0435. 4 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "-jbINms8KUuRz_o9f6mGTg", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0414\u043E\u043C\u0430\u0448\u043D\u0438\u0435 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438", templateId: "5dff707c-66ac-44cd-a4fa-ed31306e1f44", templateName: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u043B\u044F \u0434\u043E\u043C\u0430. \u041C\u0443\u0436\u0447\u0438\u043D\u044B", moduleXlId: "-BSwbRymqUGouDi1dEgvrw", moduleTitle: "\u0414\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0430 FULL BODY \u041C\u0443\u0436\u0447\u0438\u043D\u044B. \u041D\u043E\u0432\u0438\u0447\u043A\u0438 \u0438 \u043E\u043F\u044B\u0442\u043D\u044B\u0435. \u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 2 \u0438\u043B\u0438 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { coursePlanId: "7xfCx3aqKkioqOtf_8fihg", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u0438\u0437\u043C 2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", templateId: "c2893c77-5568-4a95-8b6d-e8768d2e3f95", templateName: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u0438\u0437\u043C 2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E", moduleXlId: null, moduleTitle: null },
  { coursePlanId: "RPTO2ocOMk-jgiJrR01WFg", title: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u043D\u0430 \u0440\u0443\u043A\u0438", templateId: "0b690a6f-1dbc-4614-b49b-b64827c0d1e9", templateName: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0443\u0441\u0438\u043B\u0435\u043D\u043D\u044B\u0439 \u0440\u043E\u0441\u0442 \u043C\u044B\u0448\u0446 \u0440\u0443\u043A", moduleXlId: null, moduleTitle: null }
];
function isTemplateOpenToClient(template, client) {
  if (client.purchasedTemplateIds) return client.purchasedTemplateIds.has(template.id);
  if (client.product === "CLUB") return template.clubAvailable === true;
  return true;
}
function isTemplateListedForClient(template, client) {
  if (!isTemplateOpenToClient(template, client)) return false;
  if (client.purchasedTemplateIds) return true;
  return !client.gender || !template.gender || template.gender === client.gender;
}
var CLUB_PROGRAMS_SEED = [
  { templateId: "5693ec3a-48ea-45c3-952a-588de15dc1f4", templateName: "FULL BODY \u0414\u0435\u0432\u0443\u0448\u043A\u0438 \u043E\u043F\u044B\u0442\u043D\u044B\u0435 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { templateId: "ffc72d8f-9d31-4f6d-9493-502c46b2d91b", templateName: "\u0412\u0435\u0440\u0445/\u041D\u0438\u0437 \u0434\u0435\u0432\u0443\u0448\u043A\u0438 \u043E\u043F\u044B\u0442\u043D\u044B\u0435 4 \u0440\u0430\u0437\u0430" },
  { templateId: "a532de1b-67b3-4da9-8926-d27db27eb1f3", templateName: "Full Body \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u043F\u044B\u0442\u043D\u044B\u0435 3 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" },
  { templateId: "e4003ea5-fb29-465b-aefd-23bf4063bcc8", templateName: "\u0412\u0435\u0440\u0445/\u041D\u0438\u0437 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u043F\u044B\u0442\u043D\u044B\u0435 4 \u0440\u0430\u0437\u0430" }
];

// src/program-term.ts
var PROGRAM_TERM_CUTOFF = /* @__PURE__ */ new Date("2026-09-26T21:00:00.000Z");
var PROGRAM_DEFAULT_ACCESS_MONTHS = 4;
var PROGRAM_METHODICHKA_ACCESS_MONTHS = 6;
var PROGRAM_RENEWAL_WINDOW_DAYS = 7;
var METHODICHKA_RE = /методичк/i;
function addMonthsUtc(date, months) {
  const d = new Date(date.getTime());
  const day = d.getUTCDate();
  d.setUTCDate(1);
  d.setUTCMonth(d.getUTCMonth() + months);
  const lastDay = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
  d.setUTCDate(Math.min(day, lastDay));
  return d;
}
function programOrderMonths(input) {
  if (input.productMonths && input.productMonths > 0) return input.productMonths;
  const withMethodichka = (input.orderItemNames ?? []).some((n) => !!n && METHODICHKA_RE.test(n));
  return withMethodichka ? PROGRAM_METHODICHKA_ACCESS_MONTHS : PROGRAM_DEFAULT_ACCESS_MONTHS;
}
function programAccessEnd(orders) {
  if (orders.length === 0) return null;
  const dated = orders.map((o) => ({ at: o.paidAt ? new Date(o.paidAt) : null, months: o.months }));
  if (dated.some((o) => !o.at || Number.isNaN(o.at.getTime()) || o.at.getTime() < PROGRAM_TERM_CUTOFF.getTime())) {
    return null;
  }
  dated.sort((a, b) => a.at.getTime() - b.at.getTime());
  let end = null;
  for (const o of dated) {
    const paid = o.at;
    const from = end && end.getTime() > paid.getTime() ? end : paid;
    end = addMonthsUtc(from, o.months);
  }
  return end;
}
function boughtBeforeProgramTerms(dates) {
  return dates.some((d) => {
    if (!d) return false;
    const t = new Date(d).getTime();
    return !Number.isNaN(t) && t < PROGRAM_TERM_CUTOFF.getTime();
  });
}
function isRenewalWindow(accessEnd, now = /* @__PURE__ */ new Date()) {
  if (!accessEnd) return false;
  const end = new Date(accessEnd).getTime();
  if (Number.isNaN(end)) return false;
  return end - now.getTime() <= PROGRAM_RENEWAL_WINDOW_DAYS * 24 * 36e5;
}
var TFA_PURCHASE_HORIZON_MONTHS = 6;
function tfaEndByOrders(paidDates, now = /* @__PURE__ */ new Date()) {
  const times = paidDates.map((d) => d ? new Date(d).getTime() : NaN).filter((t) => !Number.isNaN(t));
  if (times.length === 0) return null;
  const end = addMonthsUtc(new Date(Math.max(...times)), TFA_PURCHASE_HORIZON_MONTHS);
  return end.getTime() <= now.getTime() ? end : null;
}

// src/league-shield.ts
var META_SHIELD_PRODUCTS = ["CLUB", "TFA_STEP1", "TFA_STEP2"];
var META_SHIELD_LEAGUES = ["GOLD", "ELITE"];
function hasMetaShieldProduct(product) {
  return !!product && META_SHIELD_PRODUCTS.includes(product);
}
function metaShieldStatus(input, now = /* @__PURE__ */ new Date()) {
  const eligible = hasMetaShieldProduct(input.product) && !!input.league && META_SHIELD_LEAGUES.includes(input.league);
  const used = input.usedAt ? new Date(input.usedAt) : null;
  const activeThisWeek = !!used && !!input.weekStart && used.getTime() >= new Date(input.weekStart).getTime();
  let availableAt = null;
  if (used) {
    const next = new Date(used.getTime());
    next.setMonth(next.getMonth() + 1);
    if (next.getTime() > now.getTime()) availableAt = next;
  }
  return { eligible, activeThisWeek, canActivate: eligible && !availableAt, availableAt: eligible ? availableAt : null };
}

// src/notification-cta.ts
var MINI_APP_SCREENS = [
  { key: "home", label: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F", path: "/" },
  { key: "diary", label: "\u0414\u043D\u0435\u0432\u043D\u0438\u043A", path: "/diary" },
  { key: "actions", label: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F", path: "/actions" },
  { key: "workout", label: "\u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438", path: "/workout" },
  { key: "shop", label: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D", path: "/shop" },
  { key: "lectures", label: "\u041B\u0435\u043A\u0446\u0438\u0438", path: "/lectures" },
  { key: "leaderboard", label: "\u041B\u0438\u0434\u0435\u0440\u0431\u043E\u0440\u0434", path: "/leaderboard" },
  { key: "challenges", label: "\u0427\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0438", path: "/challenges" },
  { key: "profile", label: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C", path: "/profile" }
];
var MINI_APP_SCREEN_KEYS = MINI_APP_SCREENS.map((s) => s.key);
function findMiniAppScreen(key) {
  return MINI_APP_SCREENS.find((s) => s.key === key);
}
var CtaType = /* @__PURE__ */ ((CtaType2) => {
  CtaType2["NONE"] = "NONE";
  CtaType2["URL"] = "URL";
  CtaType2["MINIAPP"] = "MINIAPP";
  return CtaType2;
})(CtaType || {});
function isBlankMessageTemplate(html) {
  if (!html) return true;
  return html.replace(/<[^>]*>/g, "").replace(/&nbsp;| /gi, " ").trim() === "";
}
function hasPushContent(html, mediaCount) {
  return mediaCount > 0 || !isBlankMessageTemplate(html);
}

// src/streak-timer.ts
function effectiveInactivityHours(hoursSinceLastAction, hoursSinceGlobalFreezeEnded) {
  if (hoursSinceGlobalFreezeEnded == null) return hoursSinceLastAction;
  return Math.min(hoursSinceLastAction, hoursSinceGlobalFreezeEnded);
}
function decideStreakTimerAction(input) {
  const { hoursSinceLastAction, freezeActive, globalFreezeActive, freezeAvailable, lives, hoursSinceLastLifeLost } = input;
  if (globalFreezeActive) return "NONE";
  if (freezeActive) return "NONE";
  if (hoursSinceLastAction >= STREAK_TIMERS.FREEZE_THRESHOLD_HOURS && freezeAvailable) {
    return "ACTIVATE_FREEZE";
  }
  const lifeLossThreshold = STREAK_TIMERS.FREEZE_THRESHOLD_HOURS + STREAK_TIMERS.LIFE_LOSS_INTERVAL_HOURS;
  if (hoursSinceLastAction >= lifeLossThreshold) {
    if (lives <= 0) return "START_LAST_CHANCE";
    if (hoursSinceLastLifeLost != null && hoursSinceLastLifeLost < STREAK_TIMERS.LIFE_LOSS_INTERVAL_HOURS) {
      return "NONE";
    }
    return "LOSE_LIFE";
  }
  return "NONE";
}
function graceGapDayKeys(actionTimes, now, tz, activeDays) {
  const limitMs = (STREAK_TIMERS.FREEZE_THRESHOLD_HOURS + STREAK_TIMERS.LIFE_LOSS_INTERVAL_HOURS) * 3600 * 1e3;
  const next = (key) => {
    const d = /* @__PURE__ */ new Date(`${key}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + 1);
    return d.toISOString().slice(0, 10);
  };
  const times = [...actionTimes].map((t) => t.getTime()).sort((a, b) => a - b);
  const grace = /* @__PURE__ */ new Set();
  const mark = (from, to, includeEnd) => {
    if (to - from >= limitMs) return;
    const endKey = dayKeyInTz(new Date(to), tz);
    for (let key = next(dayKeyInTz(new Date(from), tz)); key < endKey || includeEnd && key === endKey; key = next(key)) {
      if (!activeDays.has(key)) grace.add(key);
    }
  };
  for (let i = 1; i < times.length; i++) mark(times[i - 1], times[i], false);
  if (times.length > 0 && now.getTime() > times[times.length - 1]) mark(times[times.length - 1], now.getTime(), true);
  return grace;
}

// src/league-rank.ts
function compareLeagueMembers(a, b) {
  if (b.weeklyXp !== a.weeklyXp) return b.weeklyXp - a.weeklyXp;
  if (b.streakDays !== a.streakDays) return b.streakDays - a.streakDays;
  return (a.lastActionMs ?? 0) - (b.lastActionMs ?? 0);
}
function rankLeagueMembers(members) {
  return [...members].sort(compareLeagueMembers).map((m, i) => ({ ...m, rank: i + 1 }));
}
function decideLeagueZone(rank, currentTier) {
  if (rank <= LEAGUE_ZONES.PROMOTION.max) {
    return currentTier < 5 ? { newTier: currentTier + 1, promoted: true } : { newTier: currentTier, promoted: null };
  }
  if (rank >= LEAGUE_ZONES.DEMOTION.min) {
    return currentTier > 1 ? { newTier: currentTier - 1, promoted: false } : { newTier: currentTier, promoted: null };
  }
  return { newTier: currentTier, promoted: null };
}
function decideSeasonZone(position, totalRanked, promoteCount, demoteCount) {
  if (position <= promoteCount) return true;
  if (position > totalRanked - demoteCount) return false;
  return null;
}

// src/course-unlock.ts
function delayToMs(amount, unit) {
  if (!amount || !unit) return 0;
  const HOUR = 60 * 60 * 1e3;
  const DAY = 24 * HOUR;
  switch (unit.toLowerCase()) {
    case "hour":
    case "hours":
      return amount * HOUR;
    case "day":
    case "days":
      return amount * DAY;
    case "week":
    case "weeks":
      return amount * 7 * DAY;
    case "month":
    case "months":
      return amount * 30 * DAY;
    default:
      return 0;
  }
}
function computeUnlockAt(item, flowStartAt, accessGrantedAt) {
  if (item.disableTimeLimits) return null;
  const candidates = [];
  if (item.flowTimeDelayActive && flowStartAt) {
    candidates.push(flowStartAt.getTime() + delayToMs(item.flowTimeDelay, item.flowTimeDelayMeasureType));
  }
  if (item.regularTimeDelayActive && accessGrantedAt) {
    candidates.push(accessGrantedAt.getTime() + delayToMs(item.regularTimeDelay, item.regularTimeDelayMeasureType));
  }
  if (item.dateDelayActive && item.dateDelay) {
    candidates.push(item.dateDelay.getTime());
  }
  if (candidates.length === 0) return null;
  return new Date(Math.max(...candidates));
}
function maxDate(a, b) {
  if (!a) return b;
  if (!b) return a;
  return a.getTime() >= b.getTime() ? a : b;
}
function resolveStepState(status2, isCurrent, unlockAt, now) {
  if (status2 === "completed") return "completed";
  if (isCurrent) return "current";
  if (!unlockAt || unlockAt.getTime() <= now) return "available";
  return "locked";
}

// src/achievement-eval.ts
function evaluateAchievementCondition(condition, stats) {
  switch (condition.type) {
    case "first_action":
      return stats.actionsCount > 0;
    case "streak_days":
      return stats.streakDays >= (condition.days ?? 0);
    case "total_tucoin":
      return stats.tucoin >= (condition.amount ?? 0);
    case "level_reached":
      return stats.level >= (condition.level ?? 0);
    case "lectures_completed":
      return stats.lecturesCompleted >= (condition.count ?? 0);
    case "challenges_completed":
      return stats.challengesCompleted >= (condition.count ?? 0);
    case "survival_winner":
      return stats.survivalWins > 0;
    case "league_reached":
      return stats.league === condition.league || (stats.legacyLeagues ?? []).includes(condition.league);
    default:
      return false;
  }
}

// src/invariants.ts
function clientInvariantViolations(c) {
  const v = [];
  if (c.lives < 0 || c.lives > STREAK_TIMERS.MAX_LIVES) {
    v.push(`lives out of range [0, ${STREAK_TIMERS.MAX_LIVES}]: ${c.lives}`);
  }
  if (c.streakDays < 0) v.push(`streakDays negative: ${c.streakDays}`);
  if (c.xp < 0) v.push(`xp negative: ${c.xp}`);
  if (c.tucoin < 0) v.push(`tucoin negative: ${c.tucoin}`);
  const expectedLevel = calculateLevel(c.xp, c.product);
  if (c.level !== expectedLevel) {
    v.push(`level ${c.level} != calculateLevel(xp=${c.xp}, product=${c.product ?? "none"}) = ${expectedLevel}`);
  }
  return v;
}
function assertClientInvariants(c) {
  const v = clientInvariantViolations(c);
  if (v.length > 0) {
    throw new Error(`Client invariant violation(s): ${v.join("; ")}`);
  }
}

// src/survival.ts
var SURVIVAL_LIVES_PER_GAME = 3;
var SURVIVAL_INACTIVITY_HOURS = 24;
function decideSurvivalLifeLoss(lives) {
  const newLives = lives - 1;
  return { lives: Math.max(0, newLives), eliminated: newLives <= 0 };
}
function shouldLoseSurvivalLife(lastActionMs, nowMs) {
  if (lastActionMs == null) return false;
  const hoursSince = (nowMs - lastActionMs) / (1e3 * 60 * 60);
  return hoursSince >= SURVIVAL_INACTIVITY_HOURS;
}
function splitSurvivalPrize(prizePool, aliveCount) {
  if (aliveCount <= 0) return 0;
  return Math.floor(prizePool / aliveCount);
}

// src/scenarios.ts
var HOUR_MS = 60 * 60 * 1e3;
function materializeScenarioState(state, now) {
  const lastActionAt = state.lastActionAtHoursAgo == null ? null : new Date(now.getTime() - state.lastActionAtHoursAgo * HOUR_MS);
  let freezeStart = null;
  let freezeEnd = null;
  if (state.freezeWindow === "active") {
    freezeStart = new Date(now.getTime() - 1 * HOUR_MS);
    freezeEnd = new Date(now.getTime() + 23 * HOUR_MS);
  } else if (state.freezeWindow === "expired") {
    freezeStart = new Date(now.getTime() - 30 * HOUR_MS);
    freezeEnd = new Date(now.getTime() - 1 * HOUR_MS);
  }
  let globalFreezeUsedAt = null;
  let globalFreezeUntil = null;
  if (state.globalFreezeWindow === "active") {
    globalFreezeUsedAt = new Date(now.getTime() - 2 * 24 * HOUR_MS);
    globalFreezeUntil = new Date(now.getTime() + 5 * 24 * HOUR_MS);
  } else if (state.globalFreezeWindow === "ended-recently") {
    globalFreezeUsedAt = new Date(now.getTime() - (7 * 24 + 1) * HOUR_MS);
    globalFreezeUntil = new Date(now.getTime() - 1 * HOUR_MS);
  }
  return {
    mode: state.mode,
    level: state.level,
    xp: state.xp,
    streakDays: state.streakDays,
    lives: state.lives,
    freezeAvailable: state.freezeAvailable,
    lastActionAt,
    freezeStart,
    freezeEnd,
    globalFreezeUsedAt,
    globalFreezeUntil
  };
}
var STREAK_SCENARIOS = [
  {
    id: "streak-freeze-active",
    title: "Active freeze \u2192 status reports frozen and Mini App shows the freeze chip",
    mechanic: "streak",
    state: {
      mode: "ACTIVE",
      level: 3,
      xp: 60,
      streakDays: 5,
      lives: 3,
      freezeAvailable: false,
      lastActionAtHoursAgo: 35,
      freezeWindow: "active"
    },
    timerAction: "NONE",
    streakStatus: { freezeActive: true, lives: 3, streakDays: 5 },
    afterTimer: { freezeActiveExpected: true, livesDelta: 0 },
    ui: { freezeChipVisible: true }
  },
  {
    id: "streak-freeze-activates",
    title: "Past 34h with a freeze available \u2192 timer activates the freeze",
    mechanic: "streak",
    state: {
      mode: "ACTIVE",
      level: 3,
      xp: 60,
      streakDays: 5,
      lives: 3,
      freezeAvailable: true,
      lastActionAtHoursAgo: 35,
      freezeWindow: "none"
    },
    timerAction: "ACTIVATE_FREEZE",
    afterTimer: { freezeActiveExpected: true, freezeAvailableExpected: false, livesDelta: 0 }
  },
  {
    id: "streak-life-lost",
    title: "Past 58h after freeze expired \u2192 timer takes one life",
    mechanic: "streak",
    state: {
      mode: "ACTIVE",
      level: 3,
      xp: 60,
      streakDays: 5,
      lives: 3,
      freezeAvailable: false,
      lastActionAtHoursAgo: 59,
      freezeWindow: "expired"
    },
    timerAction: "LOSE_LIFE",
    afterTimer: { livesDelta: -1 }
  },
  {
    // #410: клиент купил глобальную заморозку («отпуск/болезнь»), магазин прямо
    // обещает «жизни не снимаются» — а таймер знал только про личную 24-часовую
    // заморозку и продолжал списывать. На проде так потеряли жизни 5 клиентов
    // из 9, воспользовавшихся заморозкой.
    id: "streak-global-freeze-active",
    title: "Global freeze in effect \u2192 timer takes no life however long the pause",
    mechanic: "streak",
    state: {
      mode: "ACTIVE",
      level: 3,
      xp: 60,
      streakDays: 5,
      lives: 3,
      freezeAvailable: false,
      lastActionAtHoursAgo: 59,
      freezeWindow: "none",
      globalFreezeWindow: "active"
    },
    timerAction: "NONE",
    afterTimer: { livesDelta: 0 }
  },
  {
    // #410, вторая половина: заморозка кончилась — нельзя списывать жизнь сразу
    // за дни паузы. Отсчёт простоя начинается заново с конца заморозки, у
    // клиента снова полные 34 часа.
    id: "streak-global-freeze-just-ended",
    title: "Global freeze just ended \u2192 inactivity clock restarts, no instant penalty",
    mechanic: "streak",
    state: {
      mode: "ACTIVE",
      level: 3,
      xp: 60,
      streakDays: 5,
      lives: 3,
      freezeAvailable: false,
      lastActionAtHoursAgo: 8 * 24,
      freezeWindow: "none",
      globalFreezeWindow: "ended-recently"
    },
    timerAction: "NONE",
    afterTimer: { livesDelta: 0 }
  },
  {
    id: "streak-healthy",
    title: "Recent action \u2192 no freeze, Mini App hides the freeze chip",
    mechanic: "streak",
    state: {
      mode: "ACTIVE",
      level: 3,
      xp: 60,
      streakDays: 5,
      lives: 3,
      freezeAvailable: true,
      lastActionAtHoursAgo: 5,
      freezeWindow: "none"
    },
    timerAction: "NONE",
    streakStatus: { freezeActive: false, lives: 3, streakDays: 5 },
    ui: { freezeChipVisible: false }
  }
];
var TUCOIN_SCENARIOS = [
  {
    id: "tucoin-idempotent-same-reason",
    title: "Repeated grant with the same reason credits exactly once",
    mechanic: "tucoin",
    startBalance: 0,
    grants: [
      { amount: 10, reason: "LEVELUP:5" },
      { amount: 10, reason: "LEVELUP:5" }
    ],
    expect: { balance: 10, ledgerRows: 1, lastGranted: false }
  },
  {
    id: "tucoin-distinct-reasons-accumulate",
    title: "Distinct reasons accumulate independently",
    mechanic: "tucoin",
    startBalance: 0,
    grants: [
      { amount: 5, reason: "STREAK_DAY:7" },
      { amount: 3, reason: "LEVELUP:5" }
    ],
    expect: { balance: 8, ledgerRows: 2, lastGranted: true }
  },
  {
    id: "tucoin-zero-noop",
    title: "Zero-amount grant is a no-op and writes no ledger row",
    mechanic: "tucoin",
    startBalance: 4,
    grants: [{ amount: 0, reason: "NOOP:1" }],
    expect: { balance: 4, ledgerRows: 0, lastGranted: false }
  }
];
var LEVEL_SCENARIOS = [
  {
    id: "level-up-single",
    title: "Crossing one threshold levels up once and grants its LEVELUP bonus",
    mechanic: "level",
    product: "TFA_STEP2",
    startLevel: 1,
    startXp: 0,
    addXp: 20,
    expect: { newLevel: 2, leveledUp: true, tucoinBonus: 1, finalXp: 20, phase: "PHASE_1" }
  },
  {
    id: "level-up-multi",
    title: "Crossing two thresholds at once grants both LEVELUP bonuses",
    mechanic: "level",
    product: "TFA_STEP2",
    startLevel: 1,
    startXp: 0,
    addXp: 60,
    expect: { newLevel: 3, leveledUp: true, tucoinBonus: 2, finalXp: 60, phase: "PHASE_1" }
  },
  {
    id: "level-xp-banks-above-cap",
    title: "XP above the product cap banks; level stays capped, no bonus",
    mechanic: "level",
    product: "TFA_STEP1",
    startLevel: 10,
    startXp: 1200,
    addXp: 500,
    expect: { newLevel: 10, leveledUp: false, tucoinBonus: 0, finalXp: 1700, phase: "PHASE_1" }
  },
  {
    id: "level-cap-blocks-levelup",
    title: "Reaching the next threshold under a cap does NOT level up",
    mechanic: "level",
    product: "TFA_STEP1",
    startLevel: 10,
    startXp: 1200,
    addXp: 200,
    expect: { newLevel: 10, leveledUp: false, tucoinBonus: 0, finalXp: 1400, phase: "PHASE_1" }
  },
  {
    id: "level-phase2-transition",
    title: "Same XP under a higher cap crosses into level 11 / phase 2",
    mechanic: "level",
    product: "TFA_STEP2",
    startLevel: 10,
    startXp: 1200,
    addXp: 200,
    expect: { newLevel: 11, leveledUp: true, tucoinBonus: 2, finalXp: 1400, phase: "PHASE_2" }
  }
];
var LEAGUE_SCENARIOS = [
  {
    id: "league-tiebreak-order",
    title: "Tie-break: equal XP \u2192 higher streak, then earlier last action",
    mechanic: "league",
    members: [
      { clientId: "A", weeklyXp: 100, streakDays: 5, lastActionMs: 100 },
      { clientId: "B", weeklyXp: 100, streakDays: 5, lastActionMs: 50 },
      { clientId: "C", weeklyXp: 100, streakDays: 9, lastActionMs: 999 },
      { clientId: "D", weeklyXp: 250, streakDays: 0, lastActionMs: 0 }
    ],
    // D (top XP), then C (higher streak), then B (earlier action), then A.
    expectOrder: ["D", "C", "B", "A"]
  },
  {
    id: "league-zones-mid-tier",
    title: "Mid tier (3): rank 1\u201310 promote, 11\u201316 stay, 17\u201320 demote",
    mechanic: "league",
    currentTier: 3,
    expectZones: [
      { rank: 1, newTier: 4, promoted: true },
      { rank: 10, newTier: 4, promoted: true },
      { rank: 11, newTier: 3, promoted: null },
      { rank: 16, newTier: 3, promoted: null },
      { rank: 17, newTier: 2, promoted: false },
      { rank: 20, newTier: 2, promoted: false }
    ]
  },
  {
    id: "league-bounds",
    title: "Top tier cannot promote; bottom tier cannot demote",
    mechanic: "league",
    currentTier: 5,
    expectZones: [{ rank: 1, newTier: 5, promoted: null }]
  },
  {
    id: "league-bottom-floor",
    title: "Bottom tier (1) demotion zone stays at 1",
    mechanic: "league",
    currentTier: 1,
    expectZones: [{ rank: 20, newTier: 1, promoted: null }]
  }
];
var SEASON_ZONE_SCENARIOS = [
  {
    id: "season-zones-standard",
    title: "Full room of 20 (10 up / 4 down): boundaries on both sides",
    mechanic: "league-season",
    totalRanked: 20,
    promoteCount: 10,
    demoteCount: 4,
    expect: [
      { position: 1, promoted: true },
      { position: 10, promoted: true },
      { position: 11, promoted: null },
      { position: 16, promoted: null },
      { position: 17, promoted: false },
      { position: 20, promoted: false }
    ]
  },
  {
    id: "season-zones-underfilled",
    title: "Under-filled room: demote zone counts from the actual bottom",
    mechanic: "league-season",
    totalRanked: 5,
    promoteCount: 1,
    demoteCount: 1,
    expect: [
      { position: 1, promoted: true },
      { position: 2, promoted: null },
      { position: 4, promoted: null },
      { position: 5, promoted: false }
    ]
  },
  {
    id: "season-zones-overlap-promotes",
    title: "Tiny room where zones overlap: promotion wins",
    mechanic: "league-season",
    totalRanked: 2,
    promoteCount: 2,
    demoteCount: 2,
    expect: [
      { position: 1, promoted: true },
      { position: 2, promoted: true }
    ]
  }
];
var SURVIVAL_SCENARIOS = [
  {
    id: "survival-life-lost",
    title: "Losing a life at 3 lives keeps the participant alive with 2",
    mechanic: "survival",
    lifeLoss: { livesBefore: 3, expectLives: 2, expectEliminated: false }
  },
  {
    id: "survival-eliminated-at-zero",
    title: "Losing the last life eliminates the participant",
    mechanic: "survival",
    lifeLoss: { livesBefore: 1, expectLives: 0, expectEliminated: true }
  },
  {
    id: "survival-daily-inactive",
    title: "24h+ without an action \u2192 the daily check takes a life",
    mechanic: "survival",
    dailyCheck: { lastActionHoursAgo: 25, expectLosesLife: true }
  },
  {
    id: "survival-daily-active",
    title: "Recent action \u2192 the daily check leaves the participant alone",
    mechanic: "survival",
    dailyCheck: { lastActionHoursAgo: 1, expectLosesLife: false }
  },
  {
    id: "survival-daily-never-acted",
    title: "Never acted (no lastActionAt) \u2192 not punished",
    mechanic: "survival",
    dailyCheck: { lastActionHoursAgo: null, expectLosesLife: false }
  },
  {
    id: "survival-prize-split-floor",
    title: "Prize pool splits equally between survivors with integer floor",
    mechanic: "survival",
    prize: { prizePool: 100, aliveCount: 3, expectPerSurvivor: 33 }
  },
  {
    id: "survival-prize-no-survivors",
    title: "Nobody survived \u2192 nobody is paid",
    mechanic: "survival",
    prize: { prizePool: 100, aliveCount: 0, expectPerSurvivor: 0 }
  }
];
var ZERO_STATS = {
  actionsCount: 0,
  streakDays: 0,
  tucoin: 0,
  level: 1,
  lecturesCompleted: 0,
  challengesCompleted: 0,
  survivalWins: 0,
  league: null,
  legacyLeagues: []
};
function ach(id, condition, patch, expectUnlocked, title) {
  return { id, title, mechanic: "achievement", condition, stats: { ...ZERO_STATS, ...patch }, expectUnlocked };
}
var ACHIEVEMENT_SCENARIOS = [
  ach("ach-first-action-meet", { type: "first_action" }, { actionsCount: 1 }, true, "first_action with an action"),
  ach("ach-first-action-miss", { type: "first_action" }, { actionsCount: 0 }, false, "first_action with none"),
  ach("ach-streak-meet", { type: "streak_days", days: 7 }, { streakDays: 7 }, true, "streak exactly at threshold"),
  ach("ach-streak-miss", { type: "streak_days", days: 7 }, { streakDays: 6 }, false, "streak below threshold"),
  ach("ach-tucoin-meet", { type: "total_tucoin", amount: 100 }, { tucoin: 100 }, true, "tucoin at threshold"),
  ach("ach-level-meet", { type: "level_reached", level: 10 }, { level: 10 }, true, "level at threshold"),
  ach("ach-level-miss", { type: "level_reached", level: 10 }, { level: 9 }, false, "level below threshold"),
  ach("ach-lectures-meet", { type: "lectures_completed", count: 10 }, { lecturesCompleted: 10 }, true, "lectures at threshold"),
  ach("ach-challenges-meet", { type: "challenges_completed", count: 1 }, { challengesCompleted: 1 }, true, "challenges at threshold"),
  ach("ach-survival-meet", { type: "survival_winner" }, { survivalWins: 1 }, true, "survival winner"),
  ach("ach-survival-miss", { type: "survival_winner" }, { survivalWins: 0 }, false, "no survival win"),
  ach("ach-league-meet", { type: "league_reached", league: "GOLD" }, { league: "GOLD" }, true, "current league matches"),
  ach("ach-league-legacy-meet", { type: "league_reached", league: "GOLD" }, { legacyLeagues: ["GOLD"] }, true, "legacy league matches"),
  ach("ach-league-miss", { type: "league_reached", league: "GOLD" }, { league: "SILVER" }, false, "league below target")
];
var baseStatusInput = {
  mode: "DEMO",
  onboardingCompleted: false,
  curatorAssignmentStatus: null,
  flowStartDate: null,
  completedAt: null
};
function status(id, patch, expect, title) {
  return { id, title, mechanic: "client-status", input: { ...baseStatusInput, ...patch }, expect };
}
var CLIENT_STATUS_SCENARIOS = [
  status("status-completed-wins", { completedAt: /* @__PURE__ */ new Date(), mode: "DEMO", onboardingCompleted: false }, "COMPLETED", "completedAt overrides everything"),
  status("status-active-in-progress", { mode: "ACTIVE", completedAt: null }, "IN_PROGRESS", "ACTIVE \u2192 IN_PROGRESS"),
  status("status-testweek-in-progress", { mode: "TEST_WEEK" }, "IN_PROGRESS", "TEST_WEEK \u2192 IN_PROGRESS"),
  status("status-demo-no-questionnaire", { mode: "DEMO", onboardingCompleted: false }, "AWAITING_QUESTIONNAIRE", "DEMO + not onboarded"),
  status("status-demo-assigned", { mode: "DEMO", onboardingCompleted: true, curatorAssignmentStatus: "ASSIGNED" }, "AWAITING_START", "DEMO + onboarded + curator bound"),
  status("status-demo-unassigned", { mode: "DEMO", onboardingCompleted: true, curatorAssignmentStatus: "UNASSIGNED" }, "AWAITING_CURATOR", "DEMO + onboarded + no curator")
];
function pay(id, violations, inactiveDays, expect, title) {
  return { id, title, mechanic: "curator-payment", violations, inactiveDays, expect };
}
var CURATOR_PAYMENT_SCENARIOS = [
  pay("pay-perfect", 0, 0, 2700, "no violations, fully active \u2192 max"),
  pay("pay-perfect-edge-active", 0, 13, 2700, "active boundary (13 < 14)"),
  pay("pay-active-to-moderate", 0, 14, 1250, "inactivity 14 drops to moderate"),
  pay("pay-moderate-edge", 0, 22, 1250, "moderate boundary (22)"),
  pay("pay-inactive", 0, 23, 0, "inactivity \u226523 \u2192 0"),
  pay("pay-one-violation", 1, 0, 2500, "one violation \u2192 2500"),
  pay("pay-two-violations", 2, 0, 2e3, "systematic violations cap at 2000"),
  pay("pay-violations-and-inactive", 2, 23, 0, "violations + inactive \u2192 0")
];

// src/linkify.ts
var LINK_RE = /(https?:\/\/[^\s<>"']+)|(\bwww\.[^\s<>"']+)|(\bt\.me\/[^\s<>"']+)|(@[A-Za-z][A-Za-z0-9_]{3,31})/gi;
var TRAILING = /[.,!?;:»"'…]+$/;
var isTelegramHost = (url) => /^(?:https?:\/\/)?(?:www\.)?(?:t\.me|telegram\.me)\b/i.test(url) || url.startsWith("tg://");
function tokenizeLinks(input) {
  const text = input ?? "";
  if (!text) return [];
  const tokens = [];
  let lastIndex = 0;
  LINK_RE.lastIndex = 0;
  let m;
  while ((m = LINK_RE.exec(text)) !== null) {
    const [full, schemeUrl, wwwUrl, tmeUrl, mention] = m;
    const start = m.index;
    if (mention) {
      const prev = start > 0 ? text[start - 1] : "";
      if (prev && /[\w@./]/.test(prev)) {
        continue;
      }
    }
    let value = full;
    let trailing = "";
    const trail = value.match(TRAILING);
    if (trail) {
      trailing = trail[0];
      value = value.slice(0, value.length - trailing.length);
    }
    while (value.endsWith(")") && !value.includes("(")) {
      trailing = ")" + trailing;
      value = value.slice(0, -1);
    }
    if (!value) {
      continue;
    }
    if (start > lastIndex) {
      tokens.push({ type: "text", value: text.slice(lastIndex, start) });
    }
    let href;
    let telegram;
    if (schemeUrl) {
      href = value;
      telegram = isTelegramHost(value);
    } else if (wwwUrl) {
      href = "https://" + value;
      telegram = isTelegramHost(value);
    } else if (tmeUrl) {
      href = "https://" + value;
      telegram = true;
    } else {
      href = "https://t.me/" + value.slice(1);
      telegram = true;
    }
    tokens.push({ type: "link", value, href, telegram });
    lastIndex = start + value.length;
    LINK_RE.lastIndex = lastIndex;
  }
  if (lastIndex < text.length) {
    tokens.push({ type: "text", value: text.slice(lastIndex) });
  }
  return tokens;
}
function hasLink(input) {
  return tokenizeLinks(input).some((t) => t.type === "link");
}
function fileIdFromEzActions(raw) {
  if (!raw) return null;
  try {
    const actions = JSON.parse(raw);
    if (!Array.isArray(actions)) return null;
    const file = actions.find((a) => a?.type === "file" && typeof a?.data === "string");
    return file?.data || null;
  } catch {
    return null;
  }
}

// src/technique.ts
function weekStartKey(dateYYYYMMDD) {
  const d = /* @__PURE__ */ new Date(`${dateYYYYMMDD}T00:00:00Z`);
  const dow = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - dow);
  return d.toISOString().slice(0, 10);
}
function techniqueWeeklyLimit(programDaysCount) {
  return Math.max(1, programDaysCount ?? 3);
}

// src/xl-link.ts
var XL_ID_RE = /^[A-Za-z0-9_-]{16,64}$/;
var XL_CONTACT_URL_RE = /\/crm\/contacts\/([A-Za-z0-9_-]{16,64})/;
function parseXlContactRef(input) {
  const raw = input.trim().replace(/^[<"']+|[>"'.,;/]+$/g, "");
  if (!raw) return null;
  const fromUrl = raw.match(XL_CONTACT_URL_RE);
  if (fromUrl) return fromUrl[1];
  return XL_ID_RE.test(raw) ? raw : null;
}

// src/garbled-name.ts
function looksLikeToken(value) {
  if (value.length < 16 || value.length > 64) return false;
  if (!/^[A-Za-z0-9_-]+$/.test(value)) return false;
  return /[a-z]/.test(value) && /[A-Z]/.test(value) && /\d/.test(value);
}
function looksLikeGarbledName(value) {
  const v = (value || "").trim();
  if (!v) return false;
  if (v.startsWith("@")) return true;
  return looksLikeToken(v);
}
function needsNameResync(firstName, lastName) {
  const hasAny = Boolean((firstName || "").trim() || (lastName || "").trim());
  if (!hasAny) return true;
  return looksLikeGarbledName(firstName) || looksLikeGarbledName(lastName);
}

// src/client-name.ts
function clientFirstName(firstName, lastName) {
  const full = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  if (!full) return "";
  return full.split(/\s+/)[0];
}

// src/daily-tips.ts
var DAILY_TIPS = [
  { icon: "\u{1F4CA}", text: "\u041D\u0435 \u043E\u0431\u0440\u0430\u0449\u0430\u0439 \u043C\u043D\u043E\u0433\u043E \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u044F \u043D\u0430 \u0442\u043E, \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0442\u044B \u0432\u0435\u0441\u0438\u0448\u044C \u0441\u0435\u0433\u043E\u0434\u043D\u044F. \u0421\u043C\u043E\u0442\u0440\u0438 \u0441\u0440\u0435\u0434\u043D\u0438\u0439 \u0432\u0435\u0441 \u0437\u0430 \u044D\u0442\u0443 \u0438 \u043F\u0440\u043E\u0448\u043B\u0443\u044E \u043D\u0435\u0434\u0435\u043B\u044E." },
  { icon: "\u{1F4CA}", text: "\u041D\u0435 \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u0439 \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441 \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443 \u0432\u0437\u0432\u0435\u0448\u0438\u0432\u0430\u043D\u0438\u044E: \u0432\u0435\u0441 \u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C \u0438\u0437-\u0437\u0430 \u0432\u043E\u0434\u044B, \u0441\u043E\u043B\u0438, \u0443\u0433\u043B\u0435\u0432\u043E\u0434\u043E\u0432 \u0438 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E \u0416\u041A\u0422." },
  { icon: "\u{1F37D}", text: "\u0411\u0435\u043B\u043E\u043A \u2014 \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u043F\u0440\u0438\u0451\u043C\u0435 \u043F\u0438\u0449\u0438." },
  { icon: "\u{1F37D}", text: "\u0427\u0435\u043C \u0447\u0430\u0449\u0435 \u0440\u0430\u0446\u0438\u043E\u043D \u0441\u043E\u0441\u0442\u043E\u0438\u0442 \u0438\u0437 \u043F\u0440\u043E\u0441\u0442\u044B\u0445 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432, \u0442\u0435\u043C \u043B\u0435\u0433\u0447\u0435 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0438\u0442\u0430\u043D\u0438\u0435." },
  { icon: "\u{1F37D}", text: "\u041E\u0432\u043E\u0449\u0438 \u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0432\u0430\u044E\u0442 \u043E\u0431\u044A\u0451\u043C \u0440\u0430\u0446\u0438\u043E\u043D\u0430 \u043F\u043E\u0447\u0442\u0438 \u0431\u0435\u0437 \u043B\u0438\u0448\u043D\u0438\u0445 \u043A\u0430\u043B\u043E\u0440\u0438\u0439." },
  { icon: "\u{1F4AA}", text: "\u041B\u0443\u0447\u0448\u0435 \u043A\u043E\u0440\u043E\u0442\u043A\u0430\u044F \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F, \u0447\u0435\u043C \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u0430\u044F \u043D\u0438\u043A\u043E\u0433\u0434\u0430." },
  { icon: "\u{1F4AA}", text: "\u041E\u0434\u043D\u043E\u0439 \u0442\u044F\u0436\u0451\u043B\u043E\u0439 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u2014 \u0432\u0430\u0436\u043D\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0441\u0442\u044C." },
  { icon: "\u{1F9EC}", text: "80% \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430 \u2014 \u044D\u0442\u043E \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0441\u0442\u044C, \u0430 \u043D\u0435 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C." },
  { icon: "\u{1F9EC}", text: "\u041B\u043E\u0436\u0438\u0441\u044C \u0441\u043F\u0430\u0442\u044C \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0432 \u043E\u0434\u043D\u043E \u0438 \u0442\u043E \u0436\u0435 \u0432\u0440\u0435\u043C\u044F." },
  { icon: "\u{1F9EC}", text: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u043A \u0441\u043D\u0430 \u043C\u043E\u0436\u0435\u0442 \u0443\u0441\u0438\u043B\u0438\u0432\u0430\u0442\u044C \u0447\u0443\u0432\u0441\u0442\u0432\u043E \u0433\u043E\u043B\u043E\u0434\u0430." },
  { icon: "\u{1F9EC}", text: "\u0411\u043E\u043B\u044C\u0448\u0435 \u0448\u0430\u0433\u043E\u0432 \u2014 \u0431\u043E\u043B\u044C\u0448\u0435 \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439 \u0440\u0430\u0441\u0445\u043E\u0434 \u043A\u0430\u043B\u043E\u0440\u0438\u0439, \u0431\u0435\u0437 \u0442\u044F\u0436\u0451\u043B\u044B\u0445 \u043D\u0430\u0433\u0440\u0443\u0437\u043E\u043A." },
  { icon: "\u{1F9EC}", text: "\u041C\u0430\u043B\u0435\u043D\u044C\u043A\u043E\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0443\u043C\u0435\u043D\u044C\u0448\u0430\u0435\u0442 \u0442\u0440\u0435\u0432\u043E\u0433\u0443 \u043B\u0443\u0447\u0448\u0435 \u0434\u043E\u043B\u0433\u0438\u0445 \u0440\u0430\u0437\u043C\u044B\u0448\u043B\u0435\u043D\u0438\u0439." },
  { icon: "\u{1F9EC}", text: "\u0421\u043E\u0441\u0440\u0435\u0434\u043E\u0442\u043E\u0447\u044C\u0441\u044F \u043D\u0430 \u0442\u043E\u043C, \u0447\u0442\u043E \u043C\u043E\u0436\u0435\u0448\u044C \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C." }
];
function hashString(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = hash * 31 + value.charCodeAt(i) | 0;
  }
  return Math.abs(hash);
}
function pickDailyTip(dayKey, seed = "") {
  if (DAILY_TIPS.length === 0) throw new Error("DAILY_TIPS \u043F\u0443\u0441\u0442");
  const dayNumber = hashString(dayKey);
  const index = (dayNumber + hashString(seed)) % DAILY_TIPS.length;
  return DAILY_TIPS[index];
}

// src/character-level.ts
var PRETTY_CHARACTER_LEVEL = 15;
function effectiveCharacterLevel(level, minLevel) {
  const real = Number.isFinite(level) ? Math.trunc(level) : 1;
  if (minLevel == null || !Number.isFinite(minLevel)) return real;
  return Math.max(real, Math.trunc(minLevel));
}

// src/sales-analytics.ts
var ANALYTICS_PRODUCTS = ["TFA_STEP1", "TFA_STEP2", "PROGRAM", "TRAINING", "CLUB"];
var OTHER_PRODUCT = "OTHER";
var ANALYTICS_PRODUCT_LABELS = {
  TFA_STEP1: "\u0422\u0424\u0410 1",
  TFA_STEP2: "\u0422\u0424\u0410 2",
  PROGRAM: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u043A",
  TRAINING: "\u0422\u0424\u0410-\u0442\u0440\u0435\u043D\u0438\u043D\u0433",
  CLUB: "\u041A\u043B\u0443\u0431",
  OTHER: "\u041F\u0440\u043E\u0447\u0435\u0435 (\u043C\u0435\u0442\u043E\u0434\u0438\u0447\u043A\u0438 \u0438 \u0434\u0440.)"
};
function isAnalyticsProduct(v) {
  return typeof v === "string" && ANALYTICS_PRODUCTS.includes(v);
}
function revenueProductOf(product) {
  return isAnalyticsProduct(product) ? product : OTHER_PRODUCT;
}
var PAID_ORDER_PAYMENTS = ["FULL", "PARTIAL"];
function isPaidOrder(payment) {
  return PAID_ORDER_PAYMENTS.includes(payment ?? "");
}
function summarize(orders) {
  const paid = orders.filter((o) => o.amount > 0);
  const byClient = /* @__PURE__ */ new Map();
  for (const o of paid) byClient.set(o.clientId, (byClient.get(o.clientId) ?? 0) + o.amount);
  const totals = [...byClient.values()].sort((a, b) => a - b);
  const revenue = totals.reduce((a, b) => a + b, 0);
  const payingClients = totals.length;
  return {
    revenue,
    payingClients,
    ltv: payingClients > 0 ? Math.round(revenue / payingClients) : 0,
    medianClientRevenue: payingClients > 0 ? totals[Math.floor(payingClients / 2)] : 0,
    avgCheck: paid.length > 0 ? Math.round(revenue / paid.length) : 0,
    purchases: paid.length
  };
}
function summarizeRevenue(orders) {
  const groups = /* @__PURE__ */ new Map();
  for (const o of orders) {
    const key = revenueProductOf(o.product);
    const list = groups.get(key) ?? [];
    list.push(o);
    groups.set(key, list);
  }
  const byProduct = [];
  for (const [product, list] of groups) {
    const perClient = /* @__PURE__ */ new Map();
    for (const o of list) if (o.amount > 0) perClient.set(o.clientId, (perClient.get(o.clientId) ?? 0) + 1);
    const s = summarize(list);
    if (s.purchases === 0) continue;
    byProduct.push({ product, ...s, repeatBuyers: [...perClient.values()].filter((n) => n > 1).length });
  }
  byProduct.sort((a, b) => b.revenue - a.revenue);
  return { ...summarize(orders), byProduct };
}
var RENEWAL_FAMILY_PRODUCTS = {
  TFA: ["TFA_STEP1", "TFA_STEP2"],
  PROGRAM: ["PROGRAM", "TRAINING"]
};
function renewalFamilyOf(product) {
  if (product === "TFA_STEP1" || product === "TFA_STEP2") return "TFA";
  if (product === "PROGRAM" || product === "TRAINING") return "PROGRAM";
  return null;
}
var PROGRAM_RENEWAL_GRACE_DAYS = 30;
var PROGRAM_RENEWAL_PRODUCTS = ["PROGRAM", "TRAINING", "TFA_STEP1", "TFA_STEP2"];
var DAY_MS = 24 * 60 * 60 * 1e3;
var rate = (renewed, decided) => decided > 0 ? Number((renewed / decided * 100).toFixed(1)) : null;
function cohortKey(d) {
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}
function computeRenewal(family, orders, now = /* @__PURE__ */ new Date(), onlyProduct) {
  const familyProducts = RENEWAL_FAMILY_PRODUCTS[family];
  const byClient = /* @__PURE__ */ new Map();
  for (const o of orders) {
    const list2 = byClient.get(o.clientId) ?? [];
    list2.push(o);
    byClient.set(o.clientId, list2);
  }
  const cohorts = /* @__PURE__ */ new Map();
  let unlimited = 0;
  let totalClients = 0;
  for (const list2 of byClient.values()) {
    const sorted = [...list2].sort((a, b) => a.at.getTime() - b.at.getTime());
    const first = sorted.find((o) => familyProducts.includes(o.product ?? ""));
    if (!first || onlyProduct && first.product !== onlyProduct) continue;
    const firstMs = first.at.getTime();
    let renewed2;
    let decisionDue;
    if (family === "TFA") {
      renewed2 = sorted.some(
        (o) => familyProducts.includes(o.product ?? "") && o.at.getTime() - firstMs >= RENEWAL_MIN_GAP_DAYS * DAY_MS
      );
      decisionDue = firstMs + STREAM_LENGTH_DAYS * DAY_MS <= now.getTime();
    } else {
      if (firstMs < PROGRAM_TERM_CUTOFF.getTime()) {
        unlimited += 1;
        continue;
      }
      const termEnd = addMonthsUtc(first.at, first.months && first.months > 0 ? first.months : 4).getTime();
      const deadline = termEnd + PROGRAM_RENEWAL_GRACE_DAYS * DAY_MS;
      renewed2 = sorted.some((o) => {
        const t = o.at.getTime();
        return PROGRAM_RENEWAL_PRODUCTS.includes(o.product ?? "") && t - firstMs >= RENEWAL_MIN_GAP_DAYS * DAY_MS && t <= deadline;
      });
      decisionDue = deadline <= now.getTime();
    }
    totalClients += 1;
    const key = cohortKey(first.at);
    const acc = cohorts.get(key) ?? { cohort: key, clients: 0, renewed: 0, tooEarly: 0 };
    acc.clients += 1;
    if (!decisionDue) acc.tooEarly += 1;
    else if (renewed2) acc.renewed += 1;
    cohorts.set(key, acc);
  }
  const list = [...cohorts.values()].sort((a, b) => a.cohort.localeCompare(b.cohort)).map((c) => {
    const decided2 = c.clients - c.tooEarly;
    return { ...c, decided: decided2, renewalRate: rate(c.renewed, decided2) };
  });
  const decided = list.reduce((a, c) => a + c.decided, 0);
  const renewed = list.reduce((a, c) => a + c.renewed, 0);
  return { family, cohorts: list, totalClients, renewed, decided, renewalRate: rate(renewed, decided), unlimited };
}

// src/startup-window.ts
var STARTUP_WINDOW_SANDBOX = "allow-scripts";
var STARTUP_WINDOW_HTML_MAX = 2e5;
var STARTUP_WINDOW_MESSAGE_TYPE = "tfa-window";
var STARTUP_WINDOW_VARS = ["clientName", "firstName", "level", "streak", "tucoin"];
var STARTUP_WINDOW_SAMPLE_VARS = {
  clientName: "\u0410\u043D\u043D\u0430",
  firstName: "\u0410\u043D\u043D\u0430",
  level: "3",
  streak: "12",
  tucoin: "45"
};
var escapeHtml = (v) => v.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
function interpolateStartupWindowVars(html, vars) {
  if (!html) return "";
  const known = new Set(STARTUP_WINDOW_VARS);
  return html.replace(/\{(\w+)\}/g, (match, key) => {
    if (!known.has(key)) return match;
    const raw = vars[key];
    if (raw === null || raw === void 0) return "";
    return escapeHtml(String(raw));
  });
}
function splitStartupWindowHtml(html) {
  const looksLikeDocument = /<(html|body)[\s>]/i.test(html);
  if (!looksLikeDocument) return { head: "", body: html };
  const headMatch = html.match(/<head[^>]*>([\s\S]*?)<\/head>/i);
  const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  const head = (headMatch?.[1] ?? "").replace(/<meta\b[^>]*>/gi, "").replace(/<title\b[^>]*>[\s\S]*?<\/title>/gi, "").trim();
  let body;
  if (bodyMatch) body = bodyMatch[1];
  else {
    body = html.replace(/<head[^>]*>[\s\S]*?<\/head>/i, "").replace(/<\/?html[^>]*>/gi, "").replace(/<!doctype[^>]*>/gi, "");
  }
  return { head, body: body.trim() };
}
var CSP = "default-src 'none'; img-src https: data: blob:; media-src https: data: blob:; style-src 'unsafe-inline' https:; font-src https: data:; script-src 'unsafe-inline'; connect-src 'none'; frame-src 'none'; form-action 'none'; base-uri 'none'";
var THEMES = {
  dark: { bg: "#1a1530", text: "#ffffff", muted: "rgba(255,255,255,0.7)", accent: "#6C5CE7" },
  light: { bg: "#ffffff", text: "#1C2D41", muted: "#6B7B8D", accent: "#4A6CF7" }
};
function bridgeScript(parentOrigin) {
  const origin = JSON.stringify(parentOrigin);
  return "(function(){var P=" + origin + ";var T=" + JSON.stringify(STARTUP_WINDOW_MESSAGE_TYPE) + ';function post(m){m.type=T;try{parent.postMessage(m,P)}catch(e){}}document.addEventListener("click",function(e){var t=e.target;if(!t||!t.closest)return;var el=t.closest("[data-action],a[href]");if(!el)return;var a=el.getAttribute("data-action");if(a==="close"){e.preventDefault();post({action:"close"});return}if(a==="screen"){e.preventDefault();post({action:"screen",screen:el.getAttribute("data-screen")||""});return}if(el.tagName==="A"){var h=el.getAttribute("href")||"";if(!h||h.charAt(0)==="#")return;e.preventDefault();post({action:"link",href:h})}},true);window.addEventListener("load",function(){post({action:"ready"})});})();';
}
function buildStartupWindowDocument(html, vars, opts) {
  const theme = THEMES[opts.theme ?? "dark"];
  const { head, body } = splitStartupWindowHtml(interpolateStartupWindowVars(html ?? "", vars));
  return `<!doctype html>
<html lang="ru" data-theme="${opts.theme ?? "dark"}">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover">
<meta name="referrer" content="no-referrer">
<meta http-equiv="Content-Security-Policy" content="${CSP}">
<style>
:root{--tg-bg:${theme.bg};--tg-text:${theme.text};--tg-muted:${theme.muted};--tg-accent:${theme.accent};color-scheme:${opts.theme ?? "dark"}}
html,body{margin:0;min-height:100%;background:var(--tg-bg);color:var(--tg-text);font-family:Roboto,-apple-system,system-ui,sans-serif;-webkit-text-size-adjust:100%}
body{padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);box-sizing:border-box}
img,video{max-width:100%} a{color:inherit}
</style>
` + (head ? head + "\n" : "") + "</head>\n<body>\n" + body + "\n<script>" + bridgeScript(opts.parentOrigin) + "</script>\n</body>\n</html>";
}
function parseStartupWindowMessage(data) {
  if (!data || typeof data !== "object") return null;
  const m = data;
  if (m.type !== STARTUP_WINDOW_MESSAGE_TYPE) return null;
  switch (m.action) {
    case "ready":
    case "close":
      return { type: STARTUP_WINDOW_MESSAGE_TYPE, action: m.action };
    case "link":
      return typeof m.href === "string" && m.href ? { type: STARTUP_WINDOW_MESSAGE_TYPE, action: "link", href: m.href } : null;
    case "screen":
      return typeof m.screen === "string" ? { type: STARTUP_WINDOW_MESSAGE_TYPE, action: "screen", screen: m.screen } : null;
    default:
      return null;
  }
}
function isAllowedStartupWindowHref(href) {
  return /^(https?:\/\/|tg:\/\/|mailto:)/i.test(href.trim());
}

// src/measurement-window.ts
var MEASUREMENT_WINDOW_DAYS = 3;
var MEASUREMENT_CYCLE_ANCHOR_DOW = 6;
function startOfLocalDay(d) {
  const s = new Date(d);
  s.setHours(0, 0, 0, 0);
  return s;
}
function measurementCycleStart(d) {
  const s = startOfLocalDay(d);
  const offset = (s.getDay() + 1) % 7;
  s.setDate(s.getDate() - offset);
  return s;
}
function nextMeasurementCycleStart(d) {
  const next = measurementCycleStart(d);
  next.setDate(next.getDate() + 7);
  return next;
}
function measurementWindowEnd(d) {
  const end = measurementCycleStart(d);
  end.setDate(end.getDate() + MEASUREMENT_WINDOW_DAYS - 1);
  end.setHours(23, 59, 59, 999);
  return end;
}
function isMeasurementWindowOpen(d) {
  return d.getTime() <= measurementWindowEnd(d).getTime();
}
function isSameMeasurementCycle(a, b) {
  return measurementCycleStart(a).getTime() === measurementCycleStart(b).getTime();
}

// src/search-stems.ts
var SOFT_ENDING = /[аеёиоуыэюяйь]$/;
function normalizeSearchText(text) {
  return text.toLowerCase().replace(/ё/g, "\u0435");
}
function searchStems(query) {
  return normalizeSearchText(query).split(/[^a-zа-я0-9]+/i).filter(Boolean).map((word) => {
    let stem = word;
    for (let cut = 0; cut < 2 && stem.length > 3 && SOFT_ENDING.test(stem); cut++) stem = stem.slice(0, -1);
    return stem;
  });
}
function matchesSearch(text, query) {
  const stems = searchStems(query);
  if (stems.length === 0) return true;
  const hay = normalizeSearchText(text);
  return stems.every((s) => hay.includes(s));
}

// src/admin-nav.ts
var ADMIN_NAV_GROUPS = [
  {
    title: "\u041E\u0431\u0437\u043E\u0440",
    items: [
      { to: "/dashboard", label: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F" },
      { to: "/analytics", label: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430" }
    ]
  },
  {
    title: "\u041B\u044E\u0434\u0438",
    items: [
      { to: "/clients", label: "\u041A\u043B\u0438\u0435\u043D\u0442\u044B" },
      { to: "/curators", label: "\u041A\u0443\u0440\u0430\u0442\u043E\u0440\u044B" },
      { to: "/curator-payments", label: "\u0412\u044B\u043F\u043B\u0430\u0442\u044B \u043A\u0443\u0440\u0430\u0442\u043E\u0440\u0430\u043C" },
      { to: "/admins", label: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u044B" }
    ]
  },
  {
    title: "\u0413\u0435\u0439\u043C\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
    items: [
      { to: "/workouts", label: "\u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438" },
      { to: "/challenges", label: "\u0427\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0438" },
      { to: "/shop", label: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D" },
      { to: "/leagues", label: "\u041B\u0438\u0433\u0438" },
      { to: "/tariffs", label: "\u0422\u0430\u0440\u0438\u0444\u044B" },
      { to: "/guides", label: "\u0413\u0430\u0439\u0434\u044B" }
    ]
  },
  {
    title: "\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u0438",
    items: [
      { to: "/notifications", label: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F" },
      { to: "/startup-windows", label: "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0435 \u043E\u043A\u043D\u0430" },
      { to: "/streams", label: "\u041F\u043E\u0442\u043E\u043A\u0438" },
      { to: "/agent-prompt", label: "\u0418\u0418 \u041F\u0430\u0432\u0435\u043B" },
      { to: "/admin-bot", label: "\u0410\u0434\u043C\u0438\u043D-\u0411\u043E\u0442" }
    ]
  },
  {
    title: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430",
    items: [
      { to: "/xl-sync", label: "XL Sync" },
      { to: "/bug-reports", label: "\u0411\u0430\u0433\u0438" }
    ]
  }
];
function adminNavItemFor(pathname) {
  if (!pathname) return null;
  for (const group of ADMIN_NAV_GROUPS) {
    for (const item of group.items) {
      if (pathname === item.to || pathname.startsWith(`${item.to}/`)) return { ...item, group: group.title };
    }
  }
  return null;
}

// src/strength-gain.ts
function strengthGain(current, base, unit) {
  if (typeof current !== "number" || !Number.isFinite(current)) return null;
  if (typeof base !== "number" || !Number.isFinite(base)) return null;
  if (unit === "pct") {
    if (base <= 0) return null;
    return Math.round((current - base) / base * 1e3) / 10;
  }
  return Math.round((current - base) * 10) / 10;
}
function formatStrengthGain(value, unit) {
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  const sign = value > 0 ? "+" : "";
  if (unit === "pct") return `${sign}${value}%`;
  return `${sign}${formatWeight(value)} \u043A\u0433`;
}
function firstWorkingSet(sets) {
  for (const s of sets) {
    if (typeof s.weight === "number" && s.weight > 0 && typeof s.reps === "number" && s.reps > 0) {
      return { reps: s.reps, weight: s.weight };
    }
  }
  return null;
}
function formatSet(s) {
  if (!s || !Number.isFinite(s.reps) || !Number.isFinite(s.weight)) return null;
  if (s.weight <= 0) return `${s.reps} \u043F\u043E\u0432\u0442.`;
  return `${s.reps} \xD7 ${Math.round(s.weight * 10) / 10} \u043A\u0433`;
}

// src/exercise-progress.ts
function hasReps(s) {
  return typeof s.reps === "number" && Number.isFinite(s.reps) && s.reps > 0;
}
function isWeighted(s) {
  return typeof s.weight === "number" && Number.isFinite(s.weight) && s.weight > 0 && hasReps(s);
}
function isBodyweight(s) {
  return !(typeof s.weight === "number" && s.weight > 0) && hasReps(s);
}
function progressMetric(sets) {
  if (sets.some(isWeighted)) return "e1rm";
  if (sets.some(isBodyweight)) return "reps";
  return null;
}
function setProgressScore(s, metric) {
  if (metric === "e1rm") return isWeighted(s) ? estimate1RM(s.weight, s.reps, s.rir) : null;
  return isBodyweight(s) ? s.reps : null;
}
function bestProgressSet(sets, metric = progressMetric(sets)) {
  if (!metric) return null;
  let best = null;
  for (const s of sets) {
    const score = setProgressScore(s, metric);
    if (score == null || !(score > 0)) continue;
    if (!best || score > best.score) best = { set: s, score, metric };
  }
  return best;
}
function progressGainPct(current, base) {
  if (typeof current !== "number" || !Number.isFinite(current) || !(current > 0)) return null;
  if (typeof base !== "number" || !Number.isFinite(base) || !(base > 0)) return null;
  return Math.round((current - base) / base * 1e3) / 10;
}

// src/index.ts
var AdminRole = /* @__PURE__ */ ((AdminRole2) => {
  AdminRole2["ADMIN"] = "ADMIN";
  AdminRole2["OWNER"] = "OWNER";
  return AdminRole2;
})(AdminRole || {});
var CuratorAssignmentStatus = /* @__PURE__ */ ((CuratorAssignmentStatus2) => {
  CuratorAssignmentStatus2["UNASSIGNED"] = "UNASSIGNED";
  CuratorAssignmentStatus2["PENDING"] = "PENDING";
  CuratorAssignmentStatus2["ASSIGNED"] = "ASSIGNED";
  return CuratorAssignmentStatus2;
})(CuratorAssignmentStatus || {});
var CuratorRequestStatus = /* @__PURE__ */ ((CuratorRequestStatus2) => {
  CuratorRequestStatus2["PENDING"] = "PENDING";
  CuratorRequestStatus2["APPROVED"] = "APPROVED";
  CuratorRequestStatus2["REJECTED"] = "REJECTED";
  return CuratorRequestStatus2;
})(CuratorRequestStatus || {});
var ScheduleType = /* @__PURE__ */ ((ScheduleType2) => {
  ScheduleType2["RECURRING"] = "RECURRING";
  ScheduleType2["SPECIFIC_DATE"] = "SPECIFIC_DATE";
  ScheduleType2["EVENT"] = "EVENT";
  return ScheduleType2;
})(ScheduleType || {});
var StartupWindowFrequency = /* @__PURE__ */ ((StartupWindowFrequency2) => {
  StartupWindowFrequency2["ONCE"] = "ONCE";
  StartupWindowFrequency2["EVERY_OPEN"] = "EVERY_OPEN";
  StartupWindowFrequency2["INTERVAL"] = "INTERVAL";
  return StartupWindowFrequency2;
})(StartupWindowFrequency || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["MALE"] = "MALE";
  Gender2["FEMALE"] = "FEMALE";
  return Gender2;
})(Gender || {});
var Goal = /* @__PURE__ */ ((Goal2) => {
  Goal2["LOSE_WEIGHT"] = "LOSE_WEIGHT";
  Goal2["GAIN_MUSCLE"] = "GAIN_MUSCLE";
  Goal2["RECOMPOSITION"] = "RECOMPOSITION";
  return Goal2;
})(Goal || {});
var Product = /* @__PURE__ */ ((Product2) => {
  Product2["TFA_STEP1"] = "TFA_STEP1";
  Product2["TFA_STEP2"] = "TFA_STEP2";
  Product2["CLUB"] = "CLUB";
  Product2["PROGRAM"] = "PROGRAM";
  Product2["TRAINING"] = "TRAINING";
  Product2["NONE"] = "NONE";
  return Product2;
})(Product || {});
var CharacterMood = /* @__PURE__ */ ((CharacterMood2) => {
  CharacterMood2["HAPPY"] = "HAPPY";
  CharacterMood2["SAD"] = "SAD";
  CharacterMood2["ANGRY"] = "ANGRY";
  CharacterMood2["SLEEPY"] = "SLEEPY";
  CharacterMood2["EXCITED"] = "EXCITED";
  return CharacterMood2;
})(CharacterMood || {});
var CharacterPhase = /* @__PURE__ */ ((CharacterPhase2) => {
  CharacterPhase2["PHASE_1"] = "PHASE_1";
  CharacterPhase2["PHASE_2"] = "PHASE_2";
  CharacterPhase2["PHASE_3"] = "PHASE_3";
  return CharacterPhase2;
})(CharacterPhase || {});
function getCharacterPhase(level) {
  if (level <= 10) return "PHASE_1" /* PHASE_1 */;
  if (level <= 17) return "PHASE_2" /* PHASE_2 */;
  return "PHASE_3" /* PHASE_3 */;
}
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["TRAINING_REPORT"] = "TRAINING_REPORT";
  ActionType2["NUTRITION_REPORT"] = "NUTRITION_REPORT";
  ActionType2["MEASUREMENTS"] = "MEASUREMENTS";
  ActionType2["PHOTO"] = "PHOTO";
  ActionType2["LECTURE_WATCHED"] = "LECTURE_WATCHED";
  ActionType2["CHALLENGE_DAY"] = "CHALLENGE_DAY";
  ActionType2["SLEEP_LOG"] = "SLEEP_LOG";
  ActionType2["STEPS_LOG"] = "STEPS_LOG";
  ActionType2["WEIGHT_LOG"] = "WEIGHT_LOG";
  return ActionType2;
})(ActionType || {});
var StreakEventType = /* @__PURE__ */ ((StreakEventType2) => {
  StreakEventType2["FREEZE_ACTIVATED"] = "FREEZE_ACTIVATED";
  StreakEventType2["LIFE_LOST"] = "LIFE_LOST";
  StreakEventType2["LAST_CHANCE_STARTED"] = "LAST_CHANCE_STARTED";
  StreakEventType2["LAST_CHANCE_COMPLETED"] = "LAST_CHANCE_COMPLETED";
  StreakEventType2["STREAK_RESET"] = "STREAK_RESET";
  return StreakEventType2;
})(StreakEventType || {});
var MealType = /* @__PURE__ */ ((MealType2) => {
  MealType2["BREAKFAST"] = "BREAKFAST";
  MealType2["LUNCH"] = "LUNCH";
  MealType2["DINNER"] = "DINNER";
  MealType2["SNACK"] = "SNACK";
  return MealType2;
})(MealType || {});
var NutritionDayType = /* @__PURE__ */ ((NutritionDayType2) => {
  NutritionDayType2["REGULAR"] = "REGULAR";
  NutritionDayType2["TRAINING"] = "TRAINING";
  return NutritionDayType2;
})(NutritionDayType || {});
var NUTRITION_DAY_TYPE_LABELS = {
  ["REGULAR" /* REGULAR */]: "\u041E\u0431\u044B\u0447\u043D\u044B\u0439 \u0434\u0435\u043D\u044C",
  ["TRAINING" /* TRAINING */]: "\u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u0439 \u0434\u0435\u043D\u044C"
};
var NUTRITION_DAY_TYPE_EMOJI = {
  ["REGULAR" /* REGULAR */]: "\u{1F319}",
  ["TRAINING" /* TRAINING */]: "\u{1F525}"
};
var SurvivalStatus = /* @__PURE__ */ ((SurvivalStatus2) => {
  SurvivalStatus2["RECRUITING"] = "RECRUITING";
  SurvivalStatus2["ACTIVE"] = "ACTIVE";
  SurvivalStatus2["FINISHED"] = "FINISHED";
  return SurvivalStatus2;
})(SurvivalStatus || {});
var LeagueType = /* @__PURE__ */ ((LeagueType2) => {
  LeagueType2["OFFICE_PLANKTON"] = "OFFICE_PLANKTON";
  LeagueType2["CITY_WALKER"] = "CITY_WALKER";
  LeagueType2["MARATHONER"] = "MARATHONER";
  LeagueType2["CYBORG"] = "CYBORG";
  return LeagueType2;
})(LeagueType || {});
var League = /* @__PURE__ */ ((League2) => {
  League2["BEGINNERS"] = "BEGINNERS";
  League2["BRONZE"] = "BRONZE";
  League2["SILVER"] = "SILVER";
  League2["GOLD"] = "GOLD";
  League2["ELITE"] = "ELITE";
  return League2;
})(League || {});
var LEAGUE_TIERS = {
  ["BEGINNERS" /* BEGINNERS */]: 1,
  ["BRONZE" /* BRONZE */]: 2,
  ["SILVER" /* SILVER */]: 3,
  ["GOLD" /* GOLD */]: 4,
  ["ELITE" /* ELITE */]: 5
};
var LEAGUE_ROOM_SIZE = 20;
var LEAGUE_ZONES = {
  PROMOTION: { min: 1, max: 10 },
  // Ranks 1-10: league +1
  SAFE: { min: 11, max: 16 },
  // Ranks 11-16: stay
  DEMOTION: { min: 17, max: 20 }
  // Ranks 17-20: league -1
};
function getLeagueByTier(tier) {
  const entries = Object.entries(LEAGUE_TIERS);
  const found = entries.find(([_, t]) => t === tier);
  return found ? found[0] : "BEGINNERS" /* BEGINNERS */;
}
var MessageRole = /* @__PURE__ */ ((MessageRole2) => {
  MessageRole2["USER"] = "USER";
  MessageRole2["ASSISTANT"] = "ASSISTANT";
  return MessageRole2;
})(MessageRole || {});
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["STREAK_REMINDER"] = "STREAK_REMINDER";
  NotificationType2["FREEZE_ACTIVATED"] = "FREEZE_ACTIVATED";
  NotificationType2["FREEZE_EXPIRED"] = "FREEZE_EXPIRED";
  NotificationType2["LIFE_LOST"] = "LIFE_LOST";
  NotificationType2["LAST_LIFE"] = "LAST_LIFE";
  NotificationType2["LAST_CHANCE"] = "LAST_CHANCE";
  NotificationType2["DAILY_MINIMUM"] = "DAILY_MINIMUM";
  NotificationType2["WEEKLY_MEASUREMENTS"] = "WEEKLY_MEASUREMENTS";
  NotificationType2["PHOTO_REMINDER"] = "PHOTO_REMINDER";
  NotificationType2["EVENT_TODAY"] = "EVENT_TODAY";
  NotificationType2["EVENT_TOMORROW"] = "EVENT_TOMORROW";
  NotificationType2["RETURN_AFTER_ABSENCE"] = "RETURN_AFTER_ABSENCE";
  NotificationType2["ONBOARDING_INCOMPLETE"] = "ONBOARDING_INCOMPLETE";
  NotificationType2["QUESTIONNAIRE_MISSING"] = "QUESTIONNAIRE_MISSING";
  NotificationType2["SUBSCRIPTION_EXPIRED"] = "SUBSCRIPTION_EXPIRED";
  NotificationType2["RENEWAL_REMINDER"] = "RENEWAL_REMINDER";
  NotificationType2["GENERAL"] = "GENERAL";
  NotificationType2["WELCOME"] = "WELCOME";
  NotificationType2["LEVEL_UP"] = "LEVEL_UP";
  NotificationType2["ACHIEVEMENT_UNLOCKED"] = "ACHIEVEMENT_UNLOCKED";
  NotificationType2["STREAK_MILESTONE"] = "STREAK_MILESTONE";
  NotificationType2["RED_ZONE_WARNING"] = "RED_ZONE_WARNING";
  NotificationType2["NEW_CHALLENGE"] = "NEW_CHALLENGE";
  NotificationType2["DIARY_REMINDER"] = "DIARY_REMINDER";
  NotificationType2["NEW_LECTURE"] = "NEW_LECTURE";
  NotificationType2["LECTURE_REMINDER"] = "LECTURE_REMINDER";
  NotificationType2["WEEKLY_RESULTS"] = "WEEKLY_RESULTS";
  NotificationType2["CHALLENGE_COMPLETED"] = "CHALLENGE_COMPLETED";
  NotificationType2["DAILY_SUMMARY"] = "DAILY_SUMMARY";
  NotificationType2["REWARD"] = "REWARD";
  NotificationType2["ACCESS_GRANTED"] = "ACCESS_GRANTED";
  NotificationType2["BUG_REPORT_UPDATE"] = "BUG_REPORT_UPDATE";
  NotificationType2["SHOP_ORDER"] = "SHOP_ORDER";
  return NotificationType2;
})(NotificationType || {});
var ShopItemType = /* @__PURE__ */ ((ShopItemType2) => {
  ShopItemType2["LIFE_RESTORE"] = "LIFE_RESTORE";
  ShopItemType2["FREEZE_PURCHASE"] = "FREEZE_PURCHASE";
  ShopItemType2["AVATAR_FRAME"] = "AVATAR_FRAME";
  ShopItemType2["NICKNAME_COLOR"] = "NICKNAME_COLOR";
  ShopItemType2["LOOTBOX"] = "LOOTBOX";
  ShopItemType2["MODULE_UNLOCK"] = "MODULE_UNLOCK";
  ShopItemType2["EXTRA_BREAKDOWN"] = "EXTRA_BREAKDOWN";
  ShopItemType2["CLUB_MONTH"] = "CLUB_MONTH";
  ShopItemType2["TFA_DISCOUNT"] = "TFA_DISCOUNT";
  ShopItemType2["MERCH_SHIPPING"] = "MERCH_SHIPPING";
  ShopItemType2["MERCH_SHAKER"] = "MERCH_SHAKER";
  ShopItemType2["MERCH_TSHIRT"] = "MERCH_TSHIRT";
  ShopItemType2["MERCH_HOODIE"] = "MERCH_HOODIE";
  ShopItemType2["MERCH_ZOOM"] = "MERCH_ZOOM";
  return ShopItemType2;
})(ShopItemType || {});
var ShopCategory = /* @__PURE__ */ ((ShopCategory2) => {
  ShopCategory2["BONUSES"] = "BONUSES";
  ShopCategory2["COSMETICS"] = "COSMETICS";
  ShopCategory2["MERCH"] = "MERCH";
  ShopCategory2["SPECIAL"] = "SPECIAL";
  return ShopCategory2;
})(ShopCategory || {});
var SHOP_ITEM_CATEGORY = {
  ["LIFE_RESTORE" /* LIFE_RESTORE */]: "BONUSES" /* BONUSES */,
  ["FREEZE_PURCHASE" /* FREEZE_PURCHASE */]: "BONUSES" /* BONUSES */,
  ["MODULE_UNLOCK" /* MODULE_UNLOCK */]: "BONUSES" /* BONUSES */,
  ["EXTRA_BREAKDOWN" /* EXTRA_BREAKDOWN */]: "BONUSES" /* BONUSES */,
  ["AVATAR_FRAME" /* AVATAR_FRAME */]: "COSMETICS" /* COSMETICS */,
  ["NICKNAME_COLOR" /* NICKNAME_COLOR */]: "COSMETICS" /* COSMETICS */,
  ["MERCH_SHIPPING" /* MERCH_SHIPPING */]: "MERCH" /* MERCH */,
  ["MERCH_SHAKER" /* MERCH_SHAKER */]: "MERCH" /* MERCH */,
  ["MERCH_TSHIRT" /* MERCH_TSHIRT */]: "MERCH" /* MERCH */,
  ["MERCH_HOODIE" /* MERCH_HOODIE */]: "MERCH" /* MERCH */,
  ["MERCH_ZOOM" /* MERCH_ZOOM */]: "MERCH" /* MERCH */,
  ["CLUB_MONTH" /* CLUB_MONTH */]: "SPECIAL" /* SPECIAL */,
  ["TFA_DISCOUNT" /* TFA_DISCOUNT */]: "SPECIAL" /* SPECIAL */,
  ["LOOTBOX" /* LOOTBOX */]: "SPECIAL" /* SPECIAL */
};
var COMING_SOON_SHOP_ITEMS = /* @__PURE__ */ new Set([
  // #540: CLUB_MONTH открыт к покупке — месяц Клуба за монеты продаётся.
]);
var CLUB_MONTH_DAYS = 30;
function canBuyClubMonth(product) {
  return product === "CLUB" /* CLUB */;
}
var ShopOrderStatus = /* @__PURE__ */ ((ShopOrderStatus2) => {
  ShopOrderStatus2["NEW"] = "NEW";
  ShopOrderStatus2["PACKED"] = "PACKED";
  ShopOrderStatus2["SHIPPED"] = "SHIPPED";
  ShopOrderStatus2["DELIVERED"] = "DELIVERED";
  ShopOrderStatus2["CANCELLED"] = "CANCELLED";
  return ShopOrderStatus2;
})(ShopOrderStatus || {});
var SHOP_ORDER_STATUS_LABELS = {
  ["NEW" /* NEW */]: "\u041D\u043E\u0432\u044B\u0439",
  ["PACKED" /* PACKED */]: "\u0421\u043E\u0431\u0440\u0430\u043D",
  ["SHIPPED" /* SHIPPED */]: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D",
  ["DELIVERED" /* DELIVERED */]: "\u0412\u044B\u0434\u0430\u043D",
  ["CANCELLED" /* CANCELLED */]: "\u041E\u0442\u043C\u0435\u043D\u0451\u043D"
};
function isShopProductPurchasable(p, now = /* @__PURE__ */ new Date()) {
  if (p.isHidden) return false;
  const t = now.getTime();
  if (p.availableFrom != null && t < new Date(p.availableFrom).getTime()) return false;
  if (p.availableTo != null && t > new Date(p.availableTo).getTime()) return false;
  return true;
}
function nextPrizeShipmentDate(anchor, intervalMonths, now = /* @__PURE__ */ new Date()) {
  if (anchor == null) return null;
  const a = new Date(anchor);
  if (isNaN(a.getTime())) return null;
  const step = intervalMonths && intervalMonths > 0 ? Math.floor(intervalMonths) : 3;
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const d = new Date(a);
  d.setHours(0, 0, 0, 0);
  for (let i = 0; i < 1e3 && d.getTime() < today.getTime(); i++) {
    d.setMonth(d.getMonth() + step);
  }
  return d;
}
var ClientMode = /* @__PURE__ */ ((ClientMode2) => {
  ClientMode2["DEMO"] = "DEMO";
  ClientMode2["TEST_WEEK"] = "TEST_WEEK";
  ClientMode2["ACTIVE"] = "ACTIVE";
  return ClientMode2;
})(ClientMode || {});
function computeClientStatus(c, _now = /* @__PURE__ */ new Date()) {
  if (c.completedAt) return "COMPLETED";
  if (c.mode !== "DEMO") return "IN_PROGRESS";
  if (!c.onboardingCompleted) return "AWAITING_QUESTIONNAIRE";
  if (c.curatorAssignmentStatus === "ASSIGNED") return "AWAITING_START";
  return "AWAITING_CURATOR";
}
function isGamificationEnabled(mode, completedAt, product, access) {
  if (!(mode === "ACTIVE" /* ACTIVE */ && !completedAt)) return false;
  if (product === void 0 || product === null) return true;
  return isFeatureOpen(product, "gamification", access);
}
function nearestFridayOnOrAfter(d) {
  const r = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
  let i = 0;
  while (r.getUTCDay() !== 5 && i < 8) {
    r.setUTCDate(r.getUTCDate() + 1);
    i++;
  }
  return r;
}
function computeTestWeekStart(acceptDate, requestedStartDate) {
  const floor = nearestFridayOnOrAfter(acceptDate);
  if (requestedStartDate && requestedStartDate.getTime() > floor.getTime()) return requestedStartDate;
  return floor;
}
var SUBSCRIPTION_MONTHS = {
  ["CLUB" /* CLUB */]: 1,
  ["TFA_STEP1" /* TFA_STEP1 */]: 3,
  ["TFA_STEP2" /* TFA_STEP2 */]: 3
};
function subscriptionEndFrom(start, product, extraDays = 0) {
  const months = product ? SUBSCRIPTION_MONTHS[product] ?? 3 : 3;
  const end = new Date(start);
  end.setMonth(end.getMonth() + months);
  if (extraDays) end.setDate(end.getDate() + extraDays);
  return end;
}
var CURATOR_WORK_TERM_PRODUCTS = ["TFA_STEP1", "TFA_STEP2"];
var DAY_MS2 = 24 * 60 * 60 * 1e3;
function pauseDaysAfter(from, pauses) {
  return pauses.reduce((sum, p) => {
    const ms = p.endsAt.getTime() - Math.max(p.startedAt.getTime(), from.getTime());
    return ms > 0 ? sum + Math.round(ms / DAY_MS2) : sum;
  }, 0);
}
function curatorWorkEndFrom(flowStart, pauses = [], suspendedDaysGiven = 0) {
  return subscriptionEndFrom(flowStart, "TFA_STEP1", pauseDaysAfter(flowStart, pauses) + Math.max(0, suspendedDaysGiven));
}
var STEP2_FLOW_STALE_DAYS = 30;
function curatorWorkEndFor(input) {
  const pauses = input.pauses ?? [];
  const suspended = Math.max(0, input.suspendedDaysGiven ?? 0);
  if (input.product === "TFA_STEP2") {
    const stepFlows = (input.groupNames ?? []).flatMap((g) => flowDatesForGroup(g, input.flows ?? [])).filter((f) => /2\s*ступен/i.test(f.flowTitle) && f.endDate).filter((f) => !input.flowStart || !f.beginDate || input.flowStart.getTime() <= new Date(f.beginDate).getTime() + STEP2_FLOW_STALE_DAYS * DAY_MS2);
    if (stepFlows.length > 0) {
      const latest = stepFlows.reduce((a, b) => new Date(b.endDate).getTime() > new Date(a.endDate).getTime() ? b : a);
      const end = new Date(latest.endDate);
      const endDay = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate()));
      const begin = latest.beginDate ? new Date(latest.beginDate) : endDay;
      return new Date(endDay.getTime() + (pauseDaysAfter(begin, pauses) + suspended) * DAY_MS2);
    }
  }
  if (input.product !== "TFA_STEP1" && input.product !== "TFA_STEP2") return null;
  return input.flowStart ? curatorWorkEndFrom(input.flowStart, pauses, suspended) : null;
}
var START_DATE_MAX_AHEAD_DAYS = 92;
function maxStartDate(now = /* @__PURE__ */ new Date()) {
  const max = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59, 59, 999));
  max.setUTCDate(max.getUTCDate() + START_DATE_MAX_AHEAD_DAYS);
  return max;
}
function accessStartFrom(now, requestedStartDate, hasFlowStart) {
  if (!hasFlowStart || !requestedStartDate) return now;
  return requestedStartDate.getTime() > now.getTime() ? requestedStartDate : now;
}
function latestLicenseEnd(dates, now = /* @__PURE__ */ new Date()) {
  const parsed = dates.filter((d) => d != null).map((d) => d instanceof Date ? d : new Date(d)).filter((d) => !Number.isNaN(d.getTime()));
  if (parsed.length === 0) return null;
  const active = parsed.filter((d) => d.getTime() > now.getTime());
  const pool = active.length > 0 ? active : parsed;
  return pool.reduce((a, b) => b.getTime() > a.getTime() ? b : a);
}
function activeLicenseEnd(dates, now = /* @__PURE__ */ new Date()) {
  const latest = latestLicenseEnd(dates, now);
  return latest && latest.getTime() > now.getTime() ? latest : null;
}
function flowMarker(groupName) {
  const m = String(groupName ?? "").match(/(\d+)\s*поток/i);
  return m ? `${m[1]} \u043F\u043E\u0442\u043E\u043A` : null;
}
var normFlowText = (s) => s.toLowerCase().replace(/ё/g, "\u0435").replace(/[^a-zа-я0-9]+/g, " ").trim();
function flowDatesForGroup(groupName, flows) {
  const marker = flowMarker(groupName);
  if (!marker) return [];
  const group = normFlowText(String(groupName));
  const candidates = flows.filter((f) => normFlowText(f.name) === normFlowText(marker));
  const titled = candidates.filter((f) => normFlowText(f.flowTitle) && group.includes(normFlowText(f.flowTitle)));
  if (titled.length > 0) return titled;
  if (/ступен/.test(group)) return [];
  return candidates.filter((f) => !/ступен/.test(normFlowText(f.flowTitle)));
}
function canPerformActions(mode, completedAt) {
  return (mode === "TEST_WEEK" /* TEST_WEEK */ || mode === "ACTIVE" /* ACTIVE */) && !completedAt;
}
function isReadOnly(completedAt) {
  return !!completedAt;
}
function postProgramAccessMonths(product) {
  return product === "CLUB" /* CLUB */ ? 0 : READ_ONLY_PERIOD_MONTHS;
}
function postProgramAccessUntil(completedAt, product) {
  if (!completedAt) return null;
  const months = postProgramAccessMonths(product);
  if (months <= 0) return null;
  const until = new Date(completedAt);
  if (Number.isNaN(until.getTime())) return null;
  until.setUTCMonth(until.getUTCMonth() + months);
  return until;
}
function hasPostProgramAccess(completedAt, product, now = /* @__PURE__ */ new Date()) {
  const until = postProgramAccessUntil(completedAt, product);
  return until !== null && now.getTime() <= until.getTime();
}
function canLogWorkouts(mode, completedAt, product, now = /* @__PURE__ */ new Date()) {
  return canPerformActions(mode, completedAt) || hasPostProgramAccess(completedAt, product, now);
}
function isSuspended(suspendedAt) {
  return !!suspendedAt;
}
function suspensionDays(suspendedAt, now = /* @__PURE__ */ new Date()) {
  if (!suspendedAt) return 0;
  const from = suspendedAt instanceof Date ? suspendedAt : new Date(suspendedAt);
  if (Number.isNaN(from.getTime())) return 0;
  const days = Math.floor((now.getTime() - from.getTime()) / (24 * 60 * 60 * 1e3));
  return days > 0 ? days : 0;
}
function isDayInsideLastSuspension(dayKey, lastSuspendedFrom, lastResumedAt, timezone) {
  if (!lastSuspendedFrom || !lastResumedAt) return false;
  return dayKey > dayKeyInTz(lastSuspendedFrom, timezone) && dayKey < dayKeyInTz(lastResumedAt, timezone);
}
var SystemEvent = /* @__PURE__ */ ((SystemEvent2) => {
  SystemEvent2["BOT_START"] = "BOT_START";
  SystemEvent2["CLIENT_REGISTERED"] = "CLIENT_REGISTERED";
  SystemEvent2["QUESTIONNAIRE_FILLED"] = "QUESTIONNAIRE_FILLED";
  SystemEvent2["ONBOARDING_COMPLETED"] = "ONBOARDING_COMPLETED";
  SystemEvent2["ACTION_COMPLETED"] = "ACTION_COMPLETED";
  SystemEvent2["LEVEL_UP"] = "LEVEL_UP";
  SystemEvent2["ACHIEVEMENT_UNLOCKED"] = "ACHIEVEMENT_UNLOCKED";
  SystemEvent2["STREAK_MILESTONE"] = "STREAK_MILESTONE";
  SystemEvent2["STREAK_LOST"] = "STREAK_LOST";
  SystemEvent2["FREEZE_ACTIVATED"] = "FREEZE_ACTIVATED";
  SystemEvent2["FREEZE_EXPIRED"] = "FREEZE_EXPIRED";
  SystemEvent2["LIFE_LOST"] = "LIFE_LOST";
  SystemEvent2["LAST_CHANCE_STARTED"] = "LAST_CHANCE_STARTED";
  SystemEvent2["LAST_CHANCE_COMPLETED"] = "LAST_CHANCE_COMPLETED";
  SystemEvent2["LIFE_RESTORED"] = "LIFE_RESTORED";
  SystemEvent2["LECTURE_COMPLETED"] = "LECTURE_COMPLETED";
  SystemEvent2["DIARY_ENTRY"] = "DIARY_ENTRY";
  SystemEvent2["MEASUREMENT_ADDED"] = "MEASUREMENT_ADDED";
  SystemEvent2["PHOTO_UPLOADED"] = "PHOTO_UPLOADED";
  SystemEvent2["FATSECRET_CONNECTED"] = "FATSECRET_CONNECTED";
  SystemEvent2["CURATOR_ASSIGNED"] = "CURATOR_ASSIGNED";
  SystemEvent2["SUBSCRIPTION_EXPIRED"] = "SUBSCRIPTION_EXPIRED";
  SystemEvent2["NUTRITION_REPORT"] = "NUTRITION_REPORT";
  SystemEvent2["TRAINING_REPORT"] = "TRAINING_REPORT";
  SystemEvent2["CHALLENGE_DAY"] = "CHALLENGE_DAY";
  SystemEvent2["CHALLENGE_STARTED"] = "CHALLENGE_STARTED";
  SystemEvent2["CURATOR_COMMENT"] = "CURATOR_COMMENT";
  SystemEvent2["PROGRAM_ASSIGNED"] = "PROGRAM_ASSIGNED";
  SystemEvent2["TEST_WEEK_ENDED"] = "TEST_WEEK_ENDED";
  SystemEvent2["FATSECRET_TOKEN_EXPIRED"] = "FATSECRET_TOKEN_EXPIRED";
  SystemEvent2["NUTRITION_GOAL_UPDATED"] = "NUTRITION_GOAL_UPDATED";
  SystemEvent2["PRODUCT_ACCESS_GRANTED"] = "PRODUCT_ACCESS_GRANTED";
  return SystemEvent2;
})(SystemEvent || {});
var CommentTargetType = /* @__PURE__ */ ((CommentTargetType2) => {
  CommentTargetType2["WORKOUT_EXERCISE"] = "WORKOUT_EXERCISE";
  CommentTargetType2["WORKOUT_ENTRY"] = "WORKOUT_ENTRY";
  CommentTargetType2["DIARY_ENTRY"] = "DIARY_ENTRY";
  CommentTargetType2["DIARY_MEAL"] = "DIARY_MEAL";
  CommentTargetType2["MEASUREMENT"] = "MEASUREMENT";
  CommentTargetType2["PROGRESS_PHOTO"] = "PROGRESS_PHOTO";
  CommentTargetType2["DIARY_METRICS"] = "DIARY_METRICS";
  return CommentTargetType2;
})(CommentTargetType || {});
var ConversationMode = /* @__PURE__ */ ((ConversationMode2) => {
  ConversationMode2["CURATOR"] = "CURATOR";
  ConversationMode2["AI_AGENT"] = "AI_AGENT";
  return ConversationMode2;
})(ConversationMode || {});
var CuratorTrackingType = /* @__PURE__ */ ((CuratorTrackingType2) => {
  CuratorTrackingType2["QUESTION"] = "QUESTION";
  CuratorTrackingType2["VIDEO"] = "VIDEO";
  CuratorTrackingType2["FOOD_REPORT"] = "FOOD_REPORT";
  return CuratorTrackingType2;
})(CuratorTrackingType || {});
var CuratorTrackingStatus = /* @__PURE__ */ ((CuratorTrackingStatus2) => {
  CuratorTrackingStatus2["PENDING"] = "PENDING";
  CuratorTrackingStatus2["RESOLVED"] = "RESOLVED";
  CuratorTrackingStatus2["EXPIRED"] = "EXPIRED";
  return CuratorTrackingStatus2;
})(CuratorTrackingStatus || {});
var PaymentReviewStatus = /* @__PURE__ */ ((PaymentReviewStatus2) => {
  PaymentReviewStatus2["PENDING"] = "PENDING";
  PaymentReviewStatus2["APPROVED"] = "APPROVED";
  PaymentReviewStatus2["REJECTED"] = "REJECTED";
  return PaymentReviewStatus2;
})(PaymentReviewStatus || {});
var BugStatus = /* @__PURE__ */ ((BugStatus2) => {
  BugStatus2["NEW"] = "NEW";
  BugStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  BugStatus2["DEPLOYED"] = "DEPLOYED";
  BugStatus2["VERIFYING"] = "VERIFYING";
  BugStatus2["DONE"] = "DONE";
  BugStatus2["REOPENED"] = "REOPENED";
  BugStatus2["RESOLVED"] = "RESOLVED";
  BugStatus2["WONT_FIX"] = "WONT_FIX";
  BugStatus2["DUPLICATE"] = "DUPLICATE";
  return BugStatus2;
})(BugStatus || {});
var BugPriority = /* @__PURE__ */ ((BugPriority2) => {
  BugPriority2["CRITICAL"] = "CRITICAL";
  BugPriority2["HIGH"] = "HIGH";
  BugPriority2["MEDIUM"] = "MEDIUM";
  BugPriority2["LOW"] = "LOW";
  return BugPriority2;
})(BugPriority || {});
var BugEnvironment = /* @__PURE__ */ ((BugEnvironment2) => {
  BugEnvironment2["PROD"] = "PROD";
  BugEnvironment2["DEV"] = "DEV";
  BugEnvironment2["LOCAL"] = "LOCAL";
  return BugEnvironment2;
})(BugEnvironment || {});
var BugAuthorType = /* @__PURE__ */ ((BugAuthorType2) => {
  BugAuthorType2["REPORTER"] = "REPORTER";
  BugAuthorType2["DEV"] = "DEV";
  BugAuthorType2["SYSTEM"] = "SYSTEM";
  return BugAuthorType2;
})(BugAuthorType || {});
var BugMediaType = /* @__PURE__ */ ((BugMediaType2) => {
  BugMediaType2["PHOTO"] = "PHOTO";
  BugMediaType2["VIDEO"] = "VIDEO";
  BugMediaType2["AUDIO"] = "AUDIO";
  BugMediaType2["VOICE"] = "VOICE";
  BugMediaType2["DOCUMENT"] = "DOCUMENT";
  return BugMediaType2;
})(BugMediaType || {});
var BUG_STATUS_ACTIVE = [
  "NEW" /* NEW */,
  "IN_PROGRESS" /* IN_PROGRESS */,
  "DEPLOYED" /* DEPLOYED */,
  "VERIFYING" /* VERIFYING */,
  "REOPENED" /* REOPENED */
];
var BUG_STATUS_CLOSED = [
  "DONE" /* DONE */,
  "RESOLVED" /* RESOLVED */,
  "WONT_FIX" /* WONT_FIX */,
  "DUPLICATE" /* DUPLICATE */
];
var BUG_STATUS_AWAITING_REPORTER = ["VERIFYING" /* VERIFYING */];
var BUG_STATUS_LABEL = {
  ["NEW" /* NEW */]: "\u{1F41B} \u041D\u043E\u0432\u044B\u0439",
  ["IN_PROGRESS" /* IN_PROGRESS */]: "\u{1F527} \u0412 \u0440\u0430\u0431\u043E\u0442\u0435",
  ["DEPLOYED" /* DEPLOYED */]: "\u{1F680} \u0416\u0434\u0451\u0442 \u0432\u044B\u043A\u0430\u0442\u0430",
  ["VERIFYING" /* VERIFYING */]: "\u{1F440} \u041D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435",
  ["DONE" /* DONE */]: "\u2705 \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E",
  ["REOPENED" /* REOPENED */]: "\u21A9\uFE0F \u0412\u0435\u0440\u043D\u0443\u043B\u0438 \u043D\u0430 \u0434\u043E\u0440\u0430\u0431\u043E\u0442\u043A\u0443",
  ["RESOLVED" /* RESOLVED */]: "\u2705 \u0418\u0441\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
  ["WONT_FIX" /* WONT_FIX */]: "\u{1F6AB} \u041D\u0435 \u0431\u0430\u0433",
  ["DUPLICATE" /* DUPLICATE */]: "\u{1F501} \u0414\u0443\u0431\u043B\u0438\u043A\u0430\u0442"
};
var BUG_ENV_LABEL = {
  ["PROD" /* PROD */]: "prod",
  ["DEV" /* DEV */]: "dev",
  ["LOCAL" /* LOCAL */]: "local"
};
var BUG_PRIORITY_ORDER = [
  "CRITICAL" /* CRITICAL */,
  "HIGH" /* HIGH */,
  "MEDIUM" /* MEDIUM */,
  "LOW" /* LOW */
];
var BUG_PRIORITY_LABEL = {
  ["CRITICAL" /* CRITICAL */]: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u044B\u0439",
  ["HIGH" /* HIGH */]: "\u0412\u044B\u0441\u043E\u043A\u0438\u0439",
  ["MEDIUM" /* MEDIUM */]: "\u0421\u0440\u0435\u0434\u043D\u0438\u0439",
  ["LOW" /* LOW */]: "\u041D\u0438\u0437\u043A\u0438\u0439"
};
var CURATOR_PAYMENT = {
  // Criterion 1: Reaction speed (by 🚩 violation count)
  REACTION: {
    PERFECT: { maxViolations: 0, amount: 2700 },
    // 🚩 = 0
    MINOR: { maxViolations: 2, amount: 2500 },
    // 🚩 < 2
    SYSTEMATIC: { amount: 2e3 }
    // 🚩 > 2
  },
  // Criterion 2: Client activity (by inactive days out of 30)
  ACTIVITY: {
    ACTIVE: { maxInactiveDays: 14, amount: 2500 },
    // < 14/30
    MODERATE: { maxInactiveDays: 22, amount: 1250 },
    // 15–22/30
    INACTIVE: { amount: 0 }
    // > 23/30
  },
  PERIOD_DAYS: 30
};
function calculateCuratorPayment(violationCount, inactiveDays) {
  let reactionAmount;
  if (violationCount === 0) {
    reactionAmount = CURATOR_PAYMENT.REACTION.PERFECT.amount;
  } else if (violationCount < 2) {
    reactionAmount = CURATOR_PAYMENT.REACTION.MINOR.amount;
  } else {
    reactionAmount = CURATOR_PAYMENT.REACTION.SYSTEMATIC.amount;
  }
  let activityAmount;
  if (inactiveDays < 14) {
    activityAmount = Math.max(2500, reactionAmount);
  } else if (inactiveDays <= 22) {
    activityAmount = CURATOR_PAYMENT.ACTIVITY.MODERATE.amount;
  } else {
    activityAmount = CURATOR_PAYMENT.ACTIVITY.INACTIVE.amount;
  }
  return Math.min(reactionAmount, activityAmount);
}
var SettlementPeriodStatus = /* @__PURE__ */ ((SettlementPeriodStatus2) => {
  SettlementPeriodStatus2["OPEN"] = "OPEN";
  SettlementPeriodStatus2["CLOSED"] = "CLOSED";
  SettlementPeriodStatus2["PAID"] = "PAID";
  return SettlementPeriodStatus2;
})(SettlementPeriodStatus || {});
var DEFAULT_CURATOR_RATE = {
  perfectAmount: CURATOR_PAYMENT.REACTION.PERFECT.amount,
  minorAmount: CURATOR_PAYMENT.REACTION.MINOR.amount,
  systematicAmount: CURATOR_PAYMENT.REACTION.SYSTEMATIC.amount,
  moderateAmount: CURATOR_PAYMENT.ACTIVITY.MODERATE.amount,
  inactiveAmount: CURATOR_PAYMENT.ACTIVITY.INACTIVE.amount,
  inactiveThreshold1: CURATOR_PAYMENT.ACTIVITY.ACTIVE.maxInactiveDays,
  inactiveThreshold2: CURATOR_PAYMENT.ACTIVITY.MODERATE.maxInactiveDays
};
function calculateCuratorPaymentConfigurable(violationCount, inactiveDays, periodDays = 30, rate2 = DEFAULT_CURATOR_RATE) {
  const t1 = Math.ceil(rate2.inactiveThreshold1 * periodDays / 30);
  const t2 = Math.ceil(rate2.inactiveThreshold2 * periodDays / 30);
  let amount;
  if (inactiveDays < t1) {
    if (violationCount === 0) amount = rate2.perfectAmount;
    else if (violationCount < 2) amount = rate2.minorAmount;
    else amount = rate2.systematicAmount;
  } else if (inactiveDays <= t2) {
    amount = rate2.moderateAmount;
  } else {
    amount = rate2.inactiveAmount;
  }
  return Math.round(amount * Math.min(periodDays, 30) / 30);
}
function calculateSettlementShiftDays(freeze, vacation) {
  const MS_DAY = 24 * 60 * 60 * 1e3;
  const len = (i) => i ? Math.max(0, Math.round((i.end.getTime() - i.start.getTime()) / MS_DAY)) : 0;
  const freezeDays = len(freeze);
  const vacationDays = len(vacation);
  let overlap = 0;
  if (freeze && vacation) {
    const start = Math.max(freeze.start.getTime(), vacation.start.getTime());
    const end = Math.min(freeze.end.getTime(), vacation.end.getTime());
    overlap = Math.max(0, Math.round((end - start) / MS_DAY));
  }
  return freezeDays + vacationDays - overlap;
}
var CHALLENGE_COMPLETION_TUCOIN = 1;
var STREAK_TUCOIN_BONUSES = {
  // ТФА-1 (мес 1–3): ударный режим (×2) + лояльность (×3)
  7: 2,
  14: 2,
  21: 2,
  30: 3,
  37: 2,
  44: 2,
  51: 2,
  60: 3,
  67: 2,
  74: 2,
  81: 2,
  90: 3,
  // ТФА-2 (мес 4–6)
  97: 2,
  104: 2,
  111: 2,
  120: 3,
  127: 2,
  134: 2,
  141: 2,
  150: 3,
  157: 2,
  164: 2,
  171: 2,
  180: 3,
  // Клуб (мес 7–12)
  187: 2,
  194: 2,
  201: 2,
  210: 3,
  217: 2,
  224: 2,
  231: 2,
  240: 3,
  247: 2,
  254: 2,
  261: 2,
  270: 3,
  277: 2,
  284: 2,
  291: 2,
  300: 3,
  307: 2,
  314: 2,
  321: 2,
  330: 3,
  337: 2,
  344: 2,
  351: 2,
  360: 3
};
function nextStreakMilestone(streakDays, claimedDays = []) {
  const claimed = new Set(claimedDays);
  const days = Object.keys(STREAK_TUCOIN_BONUSES).map(Number).sort((a, b) => a - b);
  for (const d of days) {
    if (d > streakDays && !claimed.has(d)) return { day: d, reward: STREAK_TUCOIN_BONUSES[d] };
  }
  return null;
}
var CHARACTER_STAGE_FOR_LEVEL = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 11,
  12: 12,
  13: 13,
  14: 14,
  15: 15,
  16: 16,
  17: 17,
  18: 18,
  19: 19,
  20: 20,
  21: 21,
  22: 22,
  23: 23,
  24: 24,
  25: 25,
  26: 26,
  27: 27,
  28: 28,
  29: 29,
  30: 30
};
var CHARACTER_DEGRADATION_DAYS = 3;
var CONTROL_POINTS = [
  { id: "month_1", weekNumber: 4, xp: 50, label: "\u041A\u043E\u043D\u0435\u0446 \u043C\u0435\u0441\u044F\u0446\u0430 1" },
  { id: "month_2", weekNumber: 8, xp: 100, label: "\u041A\u043E\u043D\u0435\u0446 \u043C\u0435\u0441\u044F\u0446\u0430 2" },
  { id: "final", weekNumber: 12, xp: 200, label: "\u0424\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u0435\u0437" }
];
var PRODUCT_ACCESS = Object.fromEntries(
  PRODUCTS_IN_MATRIX.map((p) => {
    const map = DEFAULT_PRODUCT_FEATURES[p];
    const flags = Object.fromEntries(PRODUCT_FEATURES.map((f) => [f, map[f] === "open"]));
    const tabCount = map.app === "open" ? 2 + ["lectures", "diary", "leaderboard"].filter((f) => map[f] === "open").length : 0;
    return [p, { ...flags, tabCount }];
  })
);
function hasProductAccess(product, feature, access) {
  return isFeatureOpen(product, feature, access);
}
function hasAppAccess(product, access) {
  return isFeatureOpen(product, "app", access);
}
function requiresCurator(product, access) {
  return hasProductAccess(product, "curator", access);
}
function canSelfEditProgram(product, access) {
  return hasAppAccess(product, access) && !requiresCurator(product ?? null, access);
}
var TARIFF_STEP2_RE = /2\s*ступ/i;
var TARIFF_CLUB_RE = /комьюнити|community|клуб|club/i;
var TARIFF_TFA_RE = /тфа|tfa/i;
var TARIFF_TRAINING_RE = /тренинг|training/i;
var TARIFF_PROGRAM_RE = /программ[а-яё]*\s+трениров/i;
var PRODUCT_RANK = {
  TFA_STEP2: 5,
  TFA_STEP1: 4,
  CLUB: 3,
  TRAINING: 2,
  PROGRAM: 1,
  NONE: 0
};
function pickStrongestProduct(products) {
  let best = null;
  for (const p of products) {
    if (!p || !(p in PRODUCT_RANK)) continue;
    if (best === null || PRODUCT_RANK[p] > PRODUCT_RANK[best]) best = p;
  }
  return best;
}
var COMMUNITY_APPROVE_PRODUCTS = ["PROGRAM", "TRAINING", "TFA_STEP1", "TFA_STEP2"];
var COMMUNITY_KEEP_PRODUCTS = [...COMMUNITY_APPROVE_PRODUCTS, "CLUB"];
var COMMUNITY_AUDIENCES = ["PROGRAM_BUYERS", "METHODICHKA"];
function communityAccess(input, now = /* @__PURE__ */ new Date(), audience = "PROGRAM_BUYERS") {
  const approves = (product) => !!product && (audience === "METHODICHKA" ? product === "TRAINING" || product === "PROGRAM" && !!input.hasMethodichka : COMMUNITY_APPROVE_PRODUCTS.includes(product));
  if (input.rows.length === 0) {
    return { approve: approves(input.product) && (!!input.lifetime || !input.completedAt), remove: false };
  }
  const live = input.lifetime ? input.rows : input.rows.filter((r) => !r.endsAt || new Date(r.endsAt).getTime() > now.getTime());
  return {
    approve: live.some((r) => approves(r.product)),
    remove: !live.some((r) => COMMUNITY_KEEP_PRODUCTS.includes(r.product))
  };
}
function effectiveClientProduct(rows, now = /* @__PURE__ */ new Date()) {
  const t = now.getTime();
  const isActive = (r) => (!r.endsAt || new Date(r.endsAt).getTime() > t) && (!r.startsAt || new Date(r.startsAt).getTime() <= t);
  const pick = (list) => {
    let best = null;
    for (const r of list) {
      if (!(r.product in PRODUCT_RANK) || r.product === "NONE" /* NONE */) continue;
      if (!best || PRODUCT_RANK[r.product] > PRODUCT_RANK[best.product]) best = r;
    }
    return best;
  };
  const active = pick(rows.filter(isActive));
  if (active) return { product: active.product, row: active, active: true };
  const ended = rows.filter((r) => r.endsAt && r.product in PRODUCT_RANK && r.product !== "NONE" /* NONE */);
  if (ended.length > 0) {
    const latest = ended.reduce((a, b) => new Date(b.endsAt).getTime() > new Date(a.endsAt).getTime() ? b : a);
    return { product: latest.product, row: latest, active: false };
  }
  const any = pick(rows);
  return any ? { product: any.product, row: any, active: false } : { product: null, row: null, active: false };
}
function classifyTariffName(name) {
  if (!name) return null;
  if (TARIFF_TRAINING_RE.test(name)) return "TRAINING" /* TRAINING */;
  if (TARIFF_PROGRAM_RE.test(name)) return "PROGRAM" /* PROGRAM */;
  if (TARIFF_STEP2_RE.test(name)) return "TFA_STEP2" /* TFA_STEP2 */;
  if (TARIFF_CLUB_RE.test(name)) return "CLUB" /* CLUB */;
  if (TARIFF_TFA_RE.test(name)) return "TFA_STEP1" /* TFA_STEP1 */;
  return null;
}
var XL_PURCHASE_FIELD = "_xlPurchase";
var XL_ORDER_PAYMENTS = ["FULL", "PARTIAL", "CREATED", "CANCELED"];
function xlOrderPayment(status2, fullyPaid) {
  const s = (status2 ?? "").toLowerCase();
  if (s === "refund" || s === "refunded" || s === "canceled" || s === "cancelled") return "CANCELED";
  if (fullyPaid === true || s === "paid" || s === "fulfilled") return "FULL";
  if (s === "partiallypaid") return "PARTIAL";
  return "CREATED";
}
function normalizeXlPurchaseFilter(value) {
  const v = value && typeof value === "object" ? value : {};
  const strings = (x) => Array.isArray(x) ? x.filter((s) => typeof s === "string") : [];
  const productSet = new Set(Object.values(Product));
  const products = strings(v.products).filter((p) => productSet.has(p));
  const payments = strings(v.payments).filter((p) => XL_ORDER_PAYMENTS.includes(p));
  const minCount = Math.max(1, Math.floor(Number(v.minCount) || 1));
  const days = Math.floor(Number(v.withinDays));
  const sinceDate = typeof v.sinceDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v.sinceDate) ? v.sinceDate : null;
  return { products, payments, minCount, withinDays: days > 0 ? days : null, sinceDate };
}
function xlPurchaseSince(f, now = /* @__PURE__ */ new Date()) {
  const bounds = [];
  if (f.withinDays) bounds.push(now.getTime() - f.withinDays * 24 * 60 * 60 * 1e3);
  if (f.sinceDate) bounds.push((/* @__PURE__ */ new Date(`${f.sinceDate}T00:00:00Z`)).getTime());
  return bounds.length > 0 ? new Date(Math.max(...bounds)) : null;
}
var TFA_FAMILY = /* @__PURE__ */ new Set(["TFA_STEP1" /* TFA_STEP1 */, "TFA_STEP2" /* TFA_STEP2 */, "CLUB" /* CLUB */]);
function pickHighestProduct(names) {
  return pickStrongestProduct(names.map(classifyTariffName).filter((p) => !!p && TFA_FAMILY.has(p)));
}
function resolveGrantedProducts(input) {
  if (input.internalProduct) return [input.internalProduct];
  const names = input.orderProductNames ?? [];
  const has = (p) => names.some((n) => classifyTariffName(n) === p);
  const granted = [];
  if (input.hasTfaCourseAccess) granted.push(pickHighestProduct(input.cohortGroupNames ?? []) ?? "TFA_STEP1" /* TFA_STEP1 */);
  if (input.hasTrainingCourseAccess || has("TRAINING" /* TRAINING */)) granted.push("TRAINING" /* TRAINING */);
  if (input.hasProgramCourseAccess || has("PROGRAM" /* PROGRAM */)) granted.push("PROGRAM" /* PROGRAM */);
  if (has("CLUB" /* CLUB */)) granted.push("CLUB" /* CLUB */);
  return granted;
}
function resolveExpectedProduct(input) {
  const granted = resolveGrantedProducts(input);
  if (granted.length > 0) return pickStrongestProduct(granted);
  const hasTfaFootprint = pickHighestProduct(input.cohortGroupNames ?? []) !== null || pickHighestProduct(input.orderProductNames ?? []) !== null;
  return hasTfaFootprint ? "NONE" /* NONE */ : null;
}
var NOTIFICATION_ONBOARDING_ONLY_TYPES = /* @__PURE__ */ new Set([
  "QUESTIONNAIRE_MISSING",
  "ONBOARDING_INCOMPLETE"
]);
var NOTIFICATION_TYPE_FEATURE = {
  PHOTO_REMINDER: "photos",
  NEW_LECTURE: "lectures",
  LECTURE_REMINDER: "lectures",
  CURATOR_COMMENT: "curator",
  // Три тарифа (этап 3): у Программы тренировок нет баллов, серии, лиг и
  // челленджей — пуши про них не уходят.
  STREAK_REMINDER: "gamification",
  FREEZE_ACTIVATED: "gamification",
  FREEZE_EXPIRED: "gamification",
  LIFE_LOST: "gamification",
  LAST_LIFE: "gamification",
  LAST_CHANCE: "gamification",
  LEVEL_UP: "gamification",
  ACHIEVEMENT_UNLOCKED: "gamification",
  STREAK_MILESTONE: "gamification",
  RED_ZONE_WARNING: "gamification",
  WEEKLY_RESULTS: "leaderboard",
  NEW_CHALLENGE: "challenges",
  CHALLENGE_COMPLETED: "challenges",
  WEEKLY_MEASUREMENTS: "measurements"
};
var READ_ONLY_PERIOD_MONTHS = 3;
var SurveyType = /* @__PURE__ */ ((SurveyType2) => {
  SurveyType2["FEEDBACK"] = "FEEDBACK";
  SurveyType2["NPS"] = "NPS";
  return SurveyType2;
})(SurveyType || {});
var EXTRA_SLOTS = {
  // #442: ступень идёт 13 недель и включает ЧЕТЫРЕ фото — тестовая неделя,
  // 5-я, 9-я и 13-я (схема согласована с продуктом 15.08.2026). Раньше слотов
  // было три (4/8/12) и фото тестовой недели не существовало вовсе.
  //
  // За фото тестовой недели TuCoin НЕ начисляется: на тестовой неделе награды
  // не даём, дальше — по ТЗ.
  //
  // #639: недели здесь — базовые, для ступени БЕЗ тестовой недели. Если ступень
  // началась тестовой неделей, фото месяца 1/2 и финальное отсчитываются от
  // старта основной программы и сдвигаются на неделю (6/10/14 по неделям
  // ступени = 5/9/13 основной программы). Реальное окно слота — только через
  // getExtraSlotWeeks, напрямую openWeek/closeWeek фото-слотов не читать.
  PHOTO_START: { openWeek: 1, closeWeek: 2, tucoin: 0, kind: "PHOTO", label: "\u0424\u043E\u0442\u043E \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u0435" },
  PHOTO_MONTH1: { openWeek: 5, closeWeek: 6, tucoin: 1, kind: "PHOTO", label: "\u0424\u043E\u0442\u043E \u043C\u0435\u0441\u044F\u0446\u0430 1" },
  PHOTO_MONTH2: { openWeek: 9, closeWeek: 10, tucoin: 2, kind: "PHOTO", label: "\u0424\u043E\u0442\u043E \u043C\u0435\u0441\u044F\u0446\u0430 2" },
  PHOTO_FINAL: { openWeek: 13, closeWeek: 14, tucoin: 10, kind: "PHOTO", label: "\u0424\u0438\u043D\u0430\u043B\u044C\u043D\u043E\u0435 \u0444\u043E\u0442\u043E \u0414\u043E/\u041F\u043E\u0441\u043B\u0435" },
  FEEDBACK: { openWeek: 6, closeWeek: 8, tucoin: 2, kind: "FEEDBACK", label: "\u0410\u043D\u043A\u0435\u0442\u0430 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438" },
  NPS: { openWeek: 12, closeWeek: 14, tucoin: 10, kind: "NPS", label: "\u0418\u0442\u043E\u0433\u043E\u0432\u0430\u044F \u0430\u043D\u043A\u0435\u0442\u0430 NPS" }
};
function getStageEpoch(client) {
  if (client.stageStartedAt) return new Date(client.stageStartedAt);
  const flow = client.flowStartDate ? new Date(client.flowStartDate) : null;
  const sub = client.subscriptionStart ? new Date(client.subscriptionStart) : null;
  if (!flow) return sub;
  if (!sub) return flow;
  return flow.getTime() > sub.getTime() ? flow : sub;
}
function getStageWeek(client, now = /* @__PURE__ */ new Date()) {
  const epoch = getStageEpoch(client);
  if (!epoch) return 0;
  const ms = now.getTime() - epoch.getTime();
  if (ms < 0) return 0;
  return Math.max(1, Math.ceil(ms / (7 * 24 * 60 * 60 * 1e3)));
}
function pausedMsBetween(pauses, from, to) {
  const lo = from.getTime();
  const hi = to.getTime();
  if (hi <= lo) return 0;
  const clipped = pauses.map((p) => [Math.max(lo, new Date(p.startDate).getTime()), Math.min(hi, new Date(p.endDate).getTime())]).filter(([a, b]) => Number.isFinite(a) && Number.isFinite(b) && b > a).sort((x, y) => x[0] - y[0]);
  let total = 0;
  let curA = 0;
  let curB = -Infinity;
  for (const [a, b] of clipped) {
    if (a > curB) {
      if (curB > curA) total += curB - curA;
      curA = a;
      curB = b;
    } else if (b > curB) {
      curB = b;
    }
  }
  if (curB > curA) total += curB - curA;
  return total;
}
function getStageWeekExcludingPauses(client, pauses, now = /* @__PURE__ */ new Date()) {
  const epoch = getStageEpoch(client);
  if (!epoch) return 0;
  const ms = now.getTime() - epoch.getTime();
  if (ms < 0) return 0;
  const active = ms - pausedMsBetween(pauses, epoch, now);
  return Math.max(1, Math.ceil(active / (7 * 24 * 60 * 60 * 1e3)));
}
function stageStartsWithTestWeek(client) {
  if (!client.testWeekEndDate) return false;
  const epoch = getStageEpoch(client);
  if (!epoch) return false;
  const end = new Date(client.testWeekEndDate).getTime();
  return Number.isFinite(end) && end > epoch.getTime();
}
var SLOTS_AFTER_TEST_WEEK = /* @__PURE__ */ new Set(["PHOTO_MONTH1", "PHOTO_MONTH2", "PHOTO_FINAL"]);
function getExtraSlotWeeks(client, slot) {
  const { openWeek, closeWeek } = EXTRA_SLOTS[slot];
  const shift = SLOTS_AFTER_TEST_WEEK.has(slot) && stageStartsWithTestWeek(client) ? 1 : 0;
  return { openWeek: openWeek + shift, closeWeek: closeWeek + shift };
}
function getExtraSlotOpensAt(client, slot) {
  const epoch = getStageEpoch(client);
  if (!epoch) return null;
  return new Date(epoch.getTime() + (getExtraSlotWeeks(client, slot).openWeek - 1) * 7 * 24 * 60 * 60 * 1e3);
}
function getExtraSlotClosesAt(client, slot) {
  const epoch = getStageEpoch(client);
  if (!epoch) return null;
  return new Date(epoch.getTime() + getExtraSlotWeeks(client, slot).closeWeek * 7 * 24 * 60 * 60 * 1e3);
}
var PHOTO_REMINDER_MIN_DAYS_SINCE_LAST = 21;
function getPhotoReminderSlotOpensAt(client, now = /* @__PURE__ */ new Date()) {
  const openPhotoSlots = getOpenExtraSlots(client, now).filter((s) => EXTRA_SLOTS[s].kind === "PHOTO");
  if (openPhotoSlots.length === 0) return null;
  return openPhotoSlots.map((s) => getExtraSlotOpensAt(client, s)).filter((d) => d != null).sort((a, b) => a.getTime() - b.getTime())[0] ?? null;
}
function getPhotoReminderDedupSince(client, now = /* @__PURE__ */ new Date()) {
  const epoch = getStageEpoch(client);
  if (!epoch) return null;
  const openPhotoSlots = getOpenExtraSlots(client, now).filter((s) => EXTRA_SLOTS[s].kind === "PHOTO");
  if (openPhotoSlots.length === 0) return null;
  const baseOpenWeek = Math.min(...openPhotoSlots.map((s) => EXTRA_SLOTS[s].openWeek));
  return new Date(epoch.getTime() + (baseOpenWeek - 1) * 7 * 24 * 60 * 60 * 1e3);
}
function isPhotoReminderDue(client, photoTakenAt, now = /* @__PURE__ */ new Date()) {
  const opensAt = getPhotoReminderSlotOpensAt(client, now);
  if (!opensAt) return false;
  const freshestPhoto = photoTakenAt.map((t) => new Date(t).getTime()).filter((t) => Number.isFinite(t)).sort((a, b) => b - a)[0];
  if (freshestPhoto !== void 0 && now.getTime() - freshestPhoto < PHOTO_REMINDER_MIN_DAYS_SINCE_LAST * 24 * 60 * 60 * 1e3) {
    return false;
  }
  return !photoTakenAt.some((t) => new Date(t).getTime() >= opensAt.getTime());
}
function getOpenExtraSlots(client, now = /* @__PURE__ */ new Date()) {
  if (!client.product || client.product === "CLUB" /* CLUB */) return [];
  const w = getStageWeek(client, now);
  if (w <= 0) return [];
  return Object.keys(EXTRA_SLOTS).filter((s) => {
    const { openWeek, closeWeek } = getExtraSlotWeeks(client, s);
    return w >= openWeek && w <= closeWeek;
  });
}
var FEEDBACK_SURVEY = [
  { id: "course_rating", label: "\u041A\u0430\u043A \u0442\u044B \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u0435\u0448\u044C \u043A\u0443\u0440\u0441 TFA \u0432 \u0446\u0435\u043B\u043E\u043C?", type: "scale_1_10", icon: "star", hint: "1 \u2014 \u0441\u043E\u0432\u0441\u0435\u043C \u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F, 10 \u2014 \u043E\u0447\u0435\u043D\u044C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F", lowScoreAlert: true },
  { id: "course_why", label: "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u044B \u043E\u0446\u0435\u043D\u0438\u043B \u043A\u0443\u0440\u0441 \u0438\u043C\u0435\u043D\u043D\u043E \u0442\u0430\u043A?", type: "text" },
  { id: "curator_rating", label: "\u041E\u0446\u0435\u043D\u0438 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0440\u0430\u0431\u043E\u0442\u044B \u0438 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u043A\u0443\u0440\u0430\u0442\u043E\u0440\u0430", type: "scale_1_10", icon: "user", hint: "1 \u2014 \u0441\u043E\u0432\u0441\u0435\u043C \u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F, 10 \u2014 \u043E\u0447\u0435\u043D\u044C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F", lowScoreAlert: true, isCurator: true },
  { id: "curator_why", label: "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u0442\u0430\u043A\u0443\u044E \u043E\u0446\u0435\u043D\u043A\u0443? \u0416\u0435\u043B\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441 \u043F\u0440\u0438\u043C\u0435\u0440\u043E\u043C \u0438\u043B\u0438 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u0435\u0439.", type: "text" },
  { id: "nps", label: "\u041D\u0430\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0435\u0440\u043E\u044F\u0442\u043D\u043E, \u0447\u0442\u043E \u043F\u043E\u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0448\u044C TFA \u0434\u0440\u0443\u0433\u0443 \u0438\u043B\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0435?", type: "scale_1_10", icon: "heart", hint: "1 \u2014 \u0442\u043E\u0447\u043D\u043E \u043D\u0435\u0442, 10 \u2014 \u0442\u043E\u0447\u043D\u043E \u043F\u043E\u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u044E", lowScoreAlert: true },
  { id: "improve", label: "\u0427\u0442\u043E \u043C\u044B \u043C\u043E\u0433\u043B\u0438 \u0431\u044B \u0443\u043B\u0443\u0447\u0448\u0438\u0442\u044C, \u0447\u0442\u043E\u0431\u044B \u0442\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u0431\u043E\u043B\u0435\u0435 \u0432\u044B\u0441\u043E\u043A\u0438\u0439 \u0431\u0430\u043B\u043B?", type: "text", optional: true }
];
var FEEDBACK_ALERT_THRESHOLD = 6;
function surveyLowScores(questions, responses) {
  const out = [];
  for (const q of questions) {
    if (!q.lowScoreAlert) continue;
    const v = responses?.[q.id];
    if (typeof v === "number" && v < FEEDBACK_ALERT_THRESHOLD) {
      out.push({ id: q.id, label: q.label, score: v });
    }
  }
  return out;
}
function feedbackLowScores(responses) {
  return surveyLowScores(FEEDBACK_SURVEY, responses);
}
var NPS_SURVEY = [
  { id: "course_rating", label: "\u041A\u0430\u043A \u0442\u044B \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u0435\u0448\u044C \u043A\u0443\u0440\u0441 TFA \u0432 \u0446\u0435\u043B\u043E\u043C?", type: "scale_1_10", icon: "star", hint: "1 \u2014 \u0441\u043E\u0432\u0441\u0435\u043C \u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F, 10 \u2014 \u043E\u0447\u0435\u043D\u044C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F", lowScoreAlert: true },
  { id: "course_why", label: "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u044B \u043E\u0446\u0435\u043D\u0438\u043B \u043A\u0443\u0440\u0441 \u0438\u043C\u0435\u043D\u043D\u043E \u0442\u0430\u043A?", type: "text" },
  { id: "curator_rating", label: "\u041E\u0446\u0435\u043D\u0438 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0440\u0430\u0431\u043E\u0442\u044B \u0438 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u043A\u0443\u0440\u0430\u0442\u043E\u0440\u0430", type: "scale_1_10", icon: "user", hint: "1 \u2014 \u0441\u043E\u0432\u0441\u0435\u043C \u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F, 10 \u2014 \u043E\u0447\u0435\u043D\u044C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F", lowScoreAlert: true, isCurator: true },
  { id: "curator_why", label: "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u0442\u0430\u043A\u0443\u044E \u043E\u0446\u0435\u043D\u043A\u0443? \u0416\u0435\u043B\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441 \u043F\u0440\u0438\u043C\u0435\u0440\u043E\u043C.", type: "text" },
  { id: "nps", label: "\u041D\u0430\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0435\u0440\u043E\u044F\u0442\u043D\u043E, \u0447\u0442\u043E \u043F\u043E\u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0448\u044C TFA \u0434\u0440\u0443\u0433\u0443 \u0438\u043B\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0435?", type: "scale_1_10", icon: "heart", hint: "1 \u2014 \u0442\u043E\u0447\u043D\u043E \u043D\u0435\u0442, 10 \u2014 \u0442\u043E\u0447\u043D\u043E \u043F\u043E\u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u044E", lowScoreAlert: true },
  { id: "improve", label: "\u0427\u0442\u043E \u043C\u044B \u043C\u043E\u0433\u043B\u0438 \u0431\u044B \u0443\u043B\u0443\u0447\u0448\u0438\u0442\u044C, \u0447\u0442\u043E\u0431\u044B \u0442\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u0431\u043E\u043B\u0435\u0435 \u0432\u044B\u0441\u043E\u043A\u0438\u0439 \u0431\u0430\u043B\u043B?", type: "text", optional: true },
  { id: "r1", label: "\u0421 \u043A\u0430\u043A\u043E\u0439 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u043E\u0439 \u0442\u044B \u043F\u0440\u0438\u0448\u0451\u043B \u043D\u0430 TFA?", type: "text", icon: "message" },
  { id: "r2", label: "\u0427\u0435\u043C \u0442\u0435\u0431\u0435 \u044D\u0442\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043C\u0435\u0448\u0430\u043B\u0430 \u0432 \u043F\u043E\u0432\u0441\u0435\u0434\u043D\u0435\u0432\u043D\u043E\u0439 \u0436\u0438\u0437\u043D\u0438?", type: "text", icon: "message" },
  { id: "r3", label: "\u0427\u0442\u043E \u043F\u043E\u0431\u0443\u0434\u0438\u043B\u043E \u0442\u0435\u0431\u044F \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0435\u0448\u0430\u0442\u044C \u044D\u0442\u0443 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443? \u041A\u0430\u043A\u0430\u044F \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044F \u0441\u0442\u0430\u043B\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0439 \u0442\u043E\u0447\u043A\u043E\u0439 \u043A\u0438\u043F\u0435\u043D\u0438\u044F?", type: "text", icon: "message" },
  { id: "r4", label: "\u0411\u044B\u043B\u0438 \u043B\u0438 \u0441\u043E\u043C\u043D\u0435\u043D\u0438\u044F \u0438\u0434\u0442\u0438 \u043D\u0430 TFA? \u0415\u0441\u043B\u0438 \u0434\u0430, \u0442\u043E \u043A\u0430\u043A\u0438\u0435?", type: "text", icon: "message" },
  { id: "r5", label: "\u0414\u0443\u043C\u0430\u043B \u043B\u0438 \u0442\u044B \u043F\u0440\u043E \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u0435\u0440\u0435\u0434 TFA? \u0415\u0441\u043B\u0438 \u0434\u0430 \u2014 \u043A\u0430\u043A\u0438\u0435 \u0438 \u043F\u043E\u0447\u0435\u043C\u0443 \u0438\u043C\u0435\u043D\u043D\u043E \u043E\u043D\u0438?", type: "text", icon: "message" },
  { id: "r6", label: "\u041F\u043E\u0447\u0435\u043C\u0443 \u0432 \u0438\u0442\u043E\u0433\u0435 \u043F\u0440\u0438\u0448\u0451\u043B \u0438\u043C\u0435\u043D\u043D\u043E \u043D\u0430 TFA?", type: "text", icon: "message" },
  { id: "r7", label: "\u0427\u0442\u043E \u0442\u044B \u043F\u0440\u043E\u0431\u043E\u0432\u0430\u043B \u0440\u0430\u043D\u044C\u0448\u0435? \u041F\u043E\u0447\u0435\u043C\u0443 \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u043B\u043E\u0441\u044C?", type: "text", icon: "message" },
  { id: "r8", label: "\u041A\u0430\u043A \u0431\u044B\u043B\u043E \u0432 \u043F\u0435\u0440\u0432\u044B\u0435 \u0434\u043D\u0438 \u0432 \u0422\u0424\u0410? \u0427\u0442\u043E \u0434\u0430\u0432\u0430\u043B\u043E\u0441\u044C \u043B\u0435\u0433\u043A\u043E, \u0430 \u0433\u0434\u0435 \u0431\u044B\u043B\u0438 \u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438?", type: "text", icon: "message" },
  { id: "r9", label: "\u0422\u044F\u0436\u0435\u043B\u043E \u043B\u0438 \u0431\u044B\u043B\u043E \u0441\u043E\u0432\u043C\u0435\u0449\u0430\u0442\u044C \u0441 \u0440\u0430\u0431\u043E\u0442\u043E\u0439/\u0434\u043E\u043C\u0430\u0448\u043D\u0438\u043C\u0438 \u0434\u0435\u043B\u0430\u043C\u0438? \u0415\u0441\u043B\u0438 \u0434\u0430 \u2014 \u043A\u0430\u043A \u0443\u0434\u0430\u043B\u043E\u0441\u044C?", type: "text", icon: "message" },
  { id: "r10", label: "\u041A\u0430\u043A\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043E\u043A\u0430\u0437\u0430\u043B\u0441\u044F \u0441\u0430\u043C\u044B\u043C \u0442\u0440\u0443\u0434\u043D\u044B\u043C? \u0427\u0442\u043E \u043F\u043E\u043C\u043E\u0433\u043B\u043E \u0435\u0433\u043E \u043F\u0440\u043E\u0439\u0442\u0438?", type: "text", icon: "message" },
  { id: "r11", label: "\u041A\u0430\u043A \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0438\u0437\u043C\u0435\u043D\u0438\u043B\u0430 \u0442\u0432\u043E\u0451 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043A \u043F\u0438\u0442\u0430\u043D\u0438\u044E \u0438 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0430\u043C? \u0427\u0442\u043E \u043D\u043E\u0432\u043E\u0433\u043E \u043E\u0441\u043E\u0437\u043D\u0430\u043B?", type: "text", icon: "message" },
  { id: "r12", label: "\u041A\u0430\u043A\u043E\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u043B, \u0447\u0442\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u043B\u043E\u0441\u044C \u043F\u043E\u0441\u043B\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B? \u0420\u0435\u0448\u0438\u043B\u0430\u0441\u044C \u043B\u0438 \u0442\u0432\u043E\u044F \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430?", type: "text", icon: "message" },
  { id: "r13", label: "\u041A\u0430\u043A\u0438\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0441\u0442\u0430\u043B\u0438 \u0441\u0430\u043C\u044B\u043C\u0438 \u0432\u0430\u0436\u043D\u044B\u043C\u0438 \u043B\u0438\u0447\u043D\u043E \u0434\u043B\u044F \u0442\u0435\u0431\u044F?", type: "text", icon: "message" },
  { id: "r14", label: "\u041A\u0430\u043A \u0442\u044B \u0441\u0435\u0431\u044F \u043E\u0449\u0443\u0449\u0430\u0435\u0448\u044C \u0441\u0435\u0439\u0447\u0430\u0441? \u0427\u0442\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u043B\u043E\u0441\u044C \u0432 \u0442\u0435\u043B\u0435, \u0433\u043E\u043B\u043E\u0432\u0435, \u0436\u0438\u0437\u043D\u0438?", type: "text", icon: "message" },
  { id: "r15", label: "\u0421\u0442\u043E\u0438\u043B\u043E \u043B\u0438 \u0422\u0424\u0410 \u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432, \u0443\u0441\u0438\u043B\u0438\u0439 \u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u0438?", type: "text", icon: "message" },
  { id: "r16", label: "\u041A\u0430\u043A\u0438\u0435 \u043F\u043B\u0430\u043D\u044B \u0434\u0430\u043B\u044C\u0448\u0435? \u0411\u0443\u0434\u0435\u0448\u044C \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0442\u044C \u0442\u043E, \u0447\u0442\u043E \u0443\u0437\u043D\u0430\u043B, \u0438\u043B\u0438 \u0435\u0441\u0442\u044C \u043D\u043E\u0432\u044B\u0435 \u0446\u0435\u043B\u0438?", type: "text", icon: "message" },
  { id: "r17", label: "\u0427\u0442\u043E \u043F\u043E\u0441\u043E\u0432\u0435\u0442\u0443\u0435\u0448\u044C \u0442\u0435\u043C, \u043A\u0442\u043E \u0434\u0443\u043C\u0430\u0435\u0442, \u043D\u043E \u043F\u043E\u043A\u0430 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442\u0441\u044F \u0437\u0430\u0439\u0442\u0438 \u0432 \u0422\u0424\u0410?", type: "text", icon: "message" },
  { id: "r18", label: "\u0425\u043E\u0447\u0435\u0448\u044C \u0447\u0442\u043E-\u0442\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C?", type: "text", optional: true, icon: "message" },
  { id: "content_consent", label: "\u041C\u043E\u0436\u043D\u043E \u043B\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0442\u0432\u043E\u0439 \u043E\u0442\u0437\u044B\u0432 \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430?", type: "choice", options: ["\u0421 \u0438\u043C\u0435\u043D\u0435\u043C", "\u0410\u043D\u043E\u043D\u0438\u043C\u043D\u043E", "\u041D\u0435\u043B\u044C\u0437\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C"], icon: "message" }
];
var STREAK_TIMERS = {
  FREEZE_THRESHOLD_HOURS: 34,
  LIFE_LOSS_INTERVAL_HOURS: 24,
  FREEZE_GRACE_HOURS: 24,
  MAX_LIVES: 3,
  STARTING_LIVES: 3,
  STARTING_FREEZES: 1
};
var STREAK_MILESTONES = [7, 14, 30, 60, 90, 180, 365];
var NOTIFICATION_RULES = {
  MAX_PUSH_PER_DAY: 8,
  // Max non-critical, non-transactional pushes per day
  QUIET_HOURS_START: 23,
  // 23:00 user timezone
  QUIET_HOURS_END: 7,
  // 07:00 user timezone
  PRIORITY_CRITICAL: 0,
  // Always sent, not aggregated
  PRIORITY_HIGH: 1,
  PRIORITY_MEDIUM: 2,
  PRIORITY_LOW: 3,
  PRIORITY_INFO: 4
};
var NOTIFICATION_TYPE_COOLDOWN_HOURS = {
  LAST_CHANCE: 24,
  LAST_LIFE: 24,
  LIFE_LOST: 24,
  STREAK_REMINDER: 12,
  FREEZE_ACTIVATED: 24,
  RED_ZONE_WARNING: 24,
  RETURN_AFTER_ABSENCE: 24,
  DAILY_MINIMUM: 24,
  WEEKLY_MEASUREMENTS: 24,
  PHOTO_REMINDER: 24,
  RENEWAL_REMINDER: 24,
  DIARY_REMINDER: 24,
  SUBSCRIPTION_EXPIRED: 24,
  QUESTIONNAIRE_MISSING: 24,
  ONBOARDING_INCOMPLETE: 24
};
var NOTIFICATION_TRANSACTIONAL_TYPES = /* @__PURE__ */ new Set([
  "REWARD",
  "LEVEL_UP",
  "ACHIEVEMENT_UNLOCKED",
  "STREAK_MILESTONE",
  "CHALLENGE_COMPLETED",
  "WELCOME",
  "PROGRAM_ASSIGNED",
  "CURATOR_COMMENT",
  // «Доступ открыт» — разовая квитанция о том, что XL подтвердил тариф и
  // блокирующий экран снят. Ночью уходит беззвучно, но НЕ дропается: иначе
  // клиент, зарегистрировавшийся вечером, узнаёт об этом только сам зайдя в апп.
  "ACCESS_GRANTED",
  // Ответ на собственное обращение клиента в поддержку — см. BUG_REPORT_UPDATE.
  "BUG_REPORT_UPDATE",
  // #342: квитанция о заказе в магазине — человек только что оформил заказ.
  "SHOP_ORDER"
]);
var TUCOIN_LIMITS = {
  TRAINING_REPORT: { points: 0, maxPerWeek: 2, maxPerMonth: 12 },
  NUTRITION_REPORT: { points: 0, maxPerWeek: 7, maxPerMonth: 30 },
  MEASUREMENTS: { points: 0, maxPerWeek: 1, maxPerMonth: 4 },
  PHOTO: { points: 0, maxPerMonth: 1 },
  LECTURE_WATCHED_STEP1: { points: 0, maxTotal: 56 },
  LECTURE_WATCHED_STEP2: { points: 0, maxTotal: 9 },
  CHALLENGE_DAY: { points: 0, maxPerChallenge: 7 }
};
var XP_REWARDS = {
  // Daily reports (max 13 XP/day)
  NUTRITION_REPORT: { xp: 10, maxPerDay: 1 },
  SLEEP: { xp: 1, maxPerDay: 1 },
  STEPS: { xp: 1, maxPerDay: 1 },
  WEIGHT: { xp: 1, maxPerDay: 1 },
  // Training & education
  TRAINING_VIDEO: { xp: 10, maxPerWeek: 3 },
  TRAINING_TEXT: { xp: 5, maxPerWeek: 3 },
  // Отдельная кардио-активность (кнопка «Кардио/активность»): любая активность
  // от 20 минут даёт +5 XP, максимум 2 раза за тренировочную неделю.
  TRAINING_CARDIO: { xp: 5, maxPerWeek: 2, minMinutes: 20 },
  LECTURE_WATCHED: { xp: 1, maxTotal: 50 },
  // Weekly
  MEASUREMENTS: { xp: 10, maxPerWeek: 1 },
  CHALLENGE_COMPLETED: { xp: 15, maxPerMonth: 2 },
  // #432: фото прогресса. Сторис онбординга обещали +10 XP («решение
  // владельца», 1/мес) с самого начала, но записи здесь не было и
  // getXpForAction('PHOTO') возвращал 0 — фото фиксировалось без начисления.
  PHOTO: { xp: 10, maxPerMonth: 1 },
  // Control points (progressive)
  CONTROL_POINT_MONTH_1: { xp: 50 },
  CONTROL_POINT_MONTH_2: { xp: 100 },
  CONTROL_POINT_FINAL: { xp: 200 }
};
var REALISTIC_MAX_WEEKLY_XP = 160;
var BOT_MAX_WEEKLY_XP_CEILING = 150;
var BOT_MIN_WEEKLY_XP_FLOOR = 5;
function clampBotWeeklyXp(rawMin, rawMax) {
  const max = Math.min(rawMax ?? 130, BOT_MAX_WEEKLY_XP_CEILING);
  const min = Math.max(BOT_MIN_WEEKLY_XP_FLOOR, Math.min(rawMin ?? 10, max - 1));
  return { min, max };
}
var TUCOIN_LEVEL_BONUSES = {
  // ТФА-1 «Похудение» (ур 2–10) = 25
  2: 1,
  3: 1,
  4: 1,
  5: 2,
  6: 2,
  7: 2,
  8: 3,
  9: 3,
  10: 10,
  // ТФА-2 «Спортивное» (ур 11–17) = 25
  11: 2,
  12: 2,
  13: 2,
  14: 3,
  15: 3,
  16: 3,
  17: 10,
  // Клуб «Легенда» (ур 18–30) = 50
  18: 2,
  19: 2,
  20: 2,
  21: 2,
  22: 2,
  23: 3,
  24: 3,
  25: 3,
  26: 3,
  27: 4,
  28: 4,
  29: 4,
  30: 16
};
var LEVEL_CAP = {
  TFA_STEP1: 10,
  TFA_STEP2: 17,
  CLUB: 30,
  // У программы и тренинга геймификации нет; кап — как у первой ступени, чтобы
  // расчёт уровня не ломался на нуле, пока баллы не отключены по тарифу.
  PROGRAM: 10,
  TRAINING: 10,
  NONE: 0
};
var LEVEL_XP_REQUIREMENTS = {
  // Phase 1: TFA 1 — levels 1-10, cap 1200 XP (doc 05)
  1: 0,
  2: 20,
  3: 60,
  4: 120,
  5: 200,
  6: 320,
  7: 480,
  8: 680,
  9: 920,
  10: 1200,
  // Phase 2: TFA 2 — levels 11-17, cap 2600 XP (doc 05)
  11: 1400,
  12: 1600,
  13: 1800,
  14: 2e3,
  15: 2200,
  16: 2400,
  17: 2600,
  // Phase 3: TFA Meta/Club — levels 18-30 (doc 05)
  18: 2900,
  19: 3200,
  20: 3500,
  21: 3800,
  22: 4100,
  23: 4400,
  24: 4700,
  25: 5e3,
  26: 5400,
  27: 5800,
  28: 6200,
  29: 6600,
  30: 7e3
};
var SLEEP_QUALITY_OPTIONS = [
  { value: "GOOD", emoji: "\u{1F7E2}", shortLabel: "\u0412\u044B\u0441\u043F\u0430\u043B\u0441\u044F", fullLabel: "\u0432\u044B\u0441\u043F\u0430\u043B\u0441\u044F, \u044D\u043D\u0435\u0440\u0433\u0438\u044F \u043D\u043E\u0440\u043C", color: "#34C759" },
  { value: "SO_SO", emoji: "\u{1F7E1}", shortLabel: "\u041D\u0435\u0434\u043E\u0441\u043F\u0430\u043B", fullLabel: "\u043D\u0435\u0434\u043E\u0441\u043F\u0430\u043B \u0438\u043B\u0438 \u0441\u043E\u043D \u0442\u0430\u043A \u0441\u0435\u0431\u0435", color: "#FFCC00" },
  { value: "BAD", emoji: "\u{1F534}", shortLabel: "\u041D\u0435 \u0432\u044B\u0441\u043F\u0430\u043B\u0441\u044F", fullLabel: "\u043D\u0435 \u0432\u044B\u0441\u043F\u0430\u043B\u0441\u044F, \u0441\u0438\u043B\u044C\u043D\u0430\u044F \u0441\u043E\u043D\u043B\u0438\u0432\u043E\u0441\u0442\u044C", color: "#FF3B30" }
];
var LEAGUE_STEP_THRESHOLDS = {
  OFFICE_PLANKTON: { min: 0, max: 6e3, target: 8e3 },
  CITY_WALKER: { min: 6e3, max: 12e3, target: 12e3 },
  MARATHONER: { min: 12e3, max: 2e4, target: 2e4 },
  CYBORG: { min: 2e4, max: Infinity, target: 25e3 }
};
function calculateLevel(xp, product) {
  const levels = Object.entries(LEVEL_XP_REQUIREMENTS).map(([level2, xpRequired]) => ({ level: parseInt(level2), xpRequired })).sort((a, b) => b.xpRequired - a.xpRequired);
  let level = 1;
  for (const { level: lvl, xpRequired } of levels) {
    if (xp >= xpRequired) {
      level = lvl;
      break;
    }
  }
  if (product && LEVEL_CAP[product]) {
    return Math.min(level, LEVEL_CAP[product]);
  }
  return level;
}
function getXpForNextLevel(currentLevel) {
  const nextLevel = currentLevel + 1;
  return LEVEL_XP_REQUIREMENTS[nextLevel] ?? Infinity;
}
function isLevelCapped(level, product) {
  if (!product || !LEVEL_CAP[product]) return false;
  return level >= LEVEL_CAP[product];
}
function getXpForAction(actionType, metadata) {
  switch (actionType) {
    case "NUTRITION_REPORT":
      return XP_REWARDS.NUTRITION_REPORT.xp;
    case "TRAINING_REPORT": {
      const subtype = metadata?.subtype;
      if (subtype === "VIDEO") return XP_REWARDS.TRAINING_VIDEO.xp;
      if (subtype === "CARDIO") return XP_REWARDS.TRAINING_CARDIO.xp;
      return XP_REWARDS.TRAINING_TEXT.xp;
    }
    case "MEASUREMENTS":
      return XP_REWARDS.MEASUREMENTS.xp;
    case "LECTURE_WATCHED":
      return XP_REWARDS.LECTURE_WATCHED.xp;
    case "CHALLENGE_DAY":
      return 0;
    // XP from challenge is awarded on completion, not per day
    case "PHOTO":
      return XP_REWARDS.PHOTO.xp;
    // #432: месячный кап (1/мес) применяет recordAction
    case "SLEEP_LOG":
      return XP_REWARDS.SLEEP.xp;
    case "STEPS_LOG":
      return XP_REWARDS.STEPS.xp;
    case "WEIGHT_LOG":
      return XP_REWARDS.WEIGHT.xp;
    default:
      return 0;
  }
}
var PROGRAM_REPS_MAX_LENGTH = 60;
function estimate1RM(weight, reps, rir) {
  if (weight == null || weight <= 0 || reps == null) return 0;
  return weight * (1 + 0.025 * (reps + (rir ?? 0)));
}
var WEIGHT_EMA_ALPHA = 0.2;
function weightEmaSeries(points, alpha = WEIGHT_EMA_ALPHA) {
  const byDay = /* @__PURE__ */ new Map();
  for (const p of points) {
    const w = p.weight;
    if (typeof w !== "number" || !Number.isFinite(w) || w <= 0 || w >= 500) continue;
    const key = new Date(p.date).toISOString().slice(0, 10);
    byDay.set(key, w);
  }
  const daily = Array.from(byDay.entries()).map(([date, weight]) => ({ date, weight })).sort((a, b) => a.date.localeCompare(b.date));
  let ema = null;
  return daily.map((p) => {
    ema = ema == null ? p.weight : alpha * p.weight + (1 - alpha) * ema;
    return { date: p.date, weight: p.weight, smooth: Math.round(ema * 10) / 10 };
  });
}
function latestWeightEma(points, alpha = WEIGHT_EMA_ALPHA) {
  const series = weightEmaSeries(points, alpha);
  return series.length > 0 ? series[series.length - 1].smooth : null;
}
function formatWeight(kg) {
  if (typeof kg !== "number" || !Number.isFinite(kg)) return null;
  return (Math.round(kg * 10) / 10).toFixed(1);
}
function mergeWeightSources(diary, measurements) {
  const byDay = /* @__PURE__ */ new Map();
  const put = (p) => {
    const w = p.weight;
    if (typeof w !== "number" || !Number.isFinite(w) || w <= 0 || w >= 500) return;
    byDay.set(new Date(p.date).toISOString().slice(0, 10), w);
  };
  for (const m of measurements) put(m);
  for (const d of diary) put(d);
  return Array.from(byDay.entries()).map(([date, weight]) => ({ date, weight })).sort((a, b) => a.date.localeCompare(b.date));
}
var WEEKLY_WEIGHT_MIN_PER_WINDOW = 4;
var WEEKLY_WEIGHT_MIN_SPAN_DAYS = 14;
var RU_MONTHS_GEN = [
  "\u044F\u043D\u0432\u0430\u0440\u044F",
  "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
  "\u043C\u0430\u0440\u0442\u0430",
  "\u0430\u043F\u0440\u0435\u043B\u044F",
  "\u043C\u0430\u044F",
  "\u0438\u044E\u043D\u044F",
  "\u0438\u044E\u043B\u044F",
  "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
  "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
  "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
  "\u043D\u043E\u044F\u0431\u0440\u044F",
  "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
];
function formatRuDayRange(firstKey, lastKey) {
  const [, fm, fd] = firstKey.split("-").map(Number);
  const [, lm, ld] = lastKey.split("-").map(Number);
  if (fm === lm) return `${fd}\u2013${ld} ${RU_MONTHS_GEN[lm - 1]}`;
  return `${fd} ${RU_MONTHS_GEN[fm - 1]} \u2013 ${ld} ${RU_MONTHS_GEN[lm - 1]}`;
}
function weeklyWeightDeltaPct(points) {
  const byDay = /* @__PURE__ */ new Map();
  for (const p of points) {
    const w = p.weight;
    if (typeof w !== "number" || !Number.isFinite(w) || w <= 0 || w >= 500) continue;
    byDay.set(new Date(p.date).toISOString().slice(0, 10), w);
  }
  const daily = Array.from(byDay.entries()).map(([date, weight]) => ({ t: Date.parse(date + "T00:00:00Z"), weight })).sort((a, b) => a.t - b.t);
  if (daily.length < 2) return { status: "no-data" };
  const DAY = 864e5;
  const lastT = daily[daily.length - 1].t;
  const firstT = daily[0].t;
  const coveredDays = Math.round((lastT - firstT) / DAY) + 1;
  if (coveredDays < WEEKLY_WEIGHT_MIN_SPAN_DAYS) return { status: "too-early" };
  const cur = [];
  const prv = [];
  for (const d of daily) {
    const age = Math.round((lastT - d.t) / DAY);
    if (age <= 6) cur.push(d.weight);
    else if (age <= 13) prv.push(d.weight);
  }
  if (cur.length < WEEKLY_WEIGHT_MIN_PER_WINDOW || prv.length < WEEKLY_WEIGHT_MIN_PER_WINDOW) {
    return { status: "insufficient" };
  }
  const avg = (a) => a.reduce((s, v) => s + v, 0) / a.length;
  const pAvg = avg(prv);
  if (!pAvg) return { status: "insufficient" };
  const dayKey = (t) => new Date(t).toISOString().slice(0, 10);
  return {
    status: "ok",
    pct: (avg(cur) - pAvg) / pAvg * 100,
    // #485: те же границы, по которым посчитаны средние выше.
    window: {
      curFrom: dayKey(lastT - 6 * DAY),
      curTo: dayKey(lastT),
      prevFrom: dayKey(lastT - 13 * DAY),
      prevTo: dayKey(lastT - 7 * DAY)
    }
  };
}
var GOAL_LABELS = {
  ["LOSE_WEIGHT" /* LOSE_WEIGHT */]: "\u041F\u043E\u0445\u0443\u0434\u0435\u043D\u0438\u0435",
  ["GAIN_MUSCLE" /* GAIN_MUSCLE */]: "\u041D\u0430\u0431\u043E\u0440 \u043C\u0430\u0441\u0441\u044B",
  ["RECOMPOSITION" /* RECOMPOSITION */]: "\u0420\u0435\u043A\u043E\u043C\u043F\u043E\u0437\u0438\u0446\u0438\u044F"
};
var WEIGHT_TARGET_RATE_BY_GOAL = {
  ["LOSE_WEIGHT" /* LOSE_WEIGHT */]: -5e-3,
  ["GAIN_MUSCLE" /* GAIN_MUSCLE */]: 25e-4,
  ["RECOMPOSITION" /* RECOMPOSITION */]: 0
};
var WEIGHT_TARGET_RATE_DEFAULT = -5e-3;
var WEIGHT_TARGET_RATE_LIMIT = 0.02;
function clampWeightTargetRate(rate2) {
  if (rate2 == null || !Number.isFinite(rate2)) return null;
  return Math.max(-WEIGHT_TARGET_RATE_LIMIT, Math.min(WEIGHT_TARGET_RATE_LIMIT, rate2));
}
function resolveWeightTargetRate(goal, override) {
  const own = clampWeightTargetRate(override);
  if (own != null) return own;
  if (goal && goal in WEIGHT_TARGET_RATE_BY_GOAL) return WEIGHT_TARGET_RATE_BY_GOAL[goal];
  return WEIGHT_TARGET_RATE_DEFAULT;
}
function weightTrendTone(delta, goal) {
  if (delta == null || !Number.isFinite(delta) || delta === 0) return "neutral";
  if (goal === "RECOMPOSITION" /* RECOMPOSITION */) return "neutral";
  const wantUp = goal === "GAIN_MUSCLE" /* GAIN_MUSCLE */;
  return delta > 0 === wantUp ? "good" : "bad";
}
var NUTRITION_METRICS = [
  { key: "fiber", label: "\u041A\u043B\u0435\u0442\u0447\u0430\u0442\u043A\u0430", subtitle: "\u0423\u0433\u043B\u0435\u0432\u043E\u0434 \u0434\u043B\u044F \u0437\u0434\u043E\u0440\u043E\u0432\u044C\u044F \u043A\u0438\u0448\u0435\u0447\u043D\u0438\u043A\u0430", unit: "\u0433", color: "#20C997", badge: "\u{1F33E}", group: "recommended", max: 200, defaultEnabled: true, column: true },
  { key: "water", label: "\u0416\u0438\u0434\u043A\u043E\u0441\u0442\u044C", subtitle: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u043F\u043E\u0442\u0440\u0435\u0431\u043B\u0435\u043D\u0438\u044F \u0432\u043E\u0434\u044B", unit: "\u043C\u043B", color: "#4A9FE5", badge: "\u{1F4A7}", group: "recommended", max: 1e4, defaultEnabled: false },
  { key: "plants", label: "\u0420\u0430\u0441\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C", subtitle: "\u041E\u0432\u043E\u0449\u0438, \u044F\u0433\u043E\u0434\u044B, \u0444\u0440\u0443\u043A\u0442\u044B", unit: "\u0433", color: "#34C759", badge: "\u{1F33F}", group: "recommended", max: 5e3, defaultEnabled: false },
  { key: "sodium", label: "\u041D\u0430\u0442\u0440\u0438\u0439", subtitle: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u043F\u043E\u0442\u0440\u0435\u0431\u043B\u0435\u043D\u0438\u044F \u043D\u0430\u0442\u0440\u0438\u044F (\u0441\u043E\u043B\u0438)", unit: "\u043C\u0433", color: "#FF9500", badge: "Na", group: "recommended", max: 2e4, defaultEnabled: false },
  { key: "potassium", label: "\u041A\u0430\u043B\u0438\u0439", subtitle: "\u0412\u0430\u0436\u0435\u043D \u0434\u043B\u044F \u0441\u0435\u0440\u0434\u0446\u0430 \u0438 \u043C\u044B\u0448\u0446", unit: "\u043C\u0433", color: "#AF52DE", badge: "K", group: "recommended", max: 2e4, defaultEnabled: false },
  { key: "calcium", label: "\u041A\u0430\u043B\u044C\u0446\u0438\u0439", subtitle: "\u0414\u043B\u044F \u043A\u043E\u0441\u0442\u0435\u0439 \u0438 \u0437\u0443\u0431\u043E\u0432", unit: "\u043C\u0433", color: "#5AC8FA", badge: "\u{1F9B4}", group: "other", max: 1e4, defaultEnabled: false },
  { key: "magnesium", label: "\u041C\u0430\u0433\u043D\u0438\u0439", subtitle: "\u0414\u043B\u044F \u043D\u0435\u0440\u0432\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0438 \u043C\u044B\u0448\u0446", unit: "\u043C\u0433", color: "#30B0C7", badge: "Mg", group: "other", max: 5e3, defaultEnabled: false },
  { key: "iron", label: "\u0416\u0435\u043B\u0435\u0437\u043E", subtitle: "\u041F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u043A\u0430 \u0430\u043D\u0435\u043C\u0438\u0438", unit: "\u043C\u0433", color: "#FF453A", badge: "\u{1FA78}", group: "other", max: 1e3, defaultEnabled: false },
  { key: "vitaminD", label: "\u0412\u0438\u0442\u0430\u043C\u0438\u043D D", subtitle: "\u0414\u043B\u044F \u0438\u043C\u043C\u0443\u043D\u0438\u0442\u0435\u0442\u0430 \u0438 \u043A\u043E\u0441\u0442\u0435\u0439", unit: "\u043C\u043A\u0433", color: "#FFCC00", badge: "\u2600\uFE0F", group: "other", max: 1e3, defaultEnabled: false },
  { key: "omega3", label: "\u041E\u043C\u0435\u0433\u0430-3", subtitle: "\u0414\u043B\u044F \u0441\u0435\u0440\u0434\u0446\u0430 \u0438 \u043C\u043E\u0437\u0433\u0430", unit: "\u0433", color: "#0A84FF", badge: "\u{1F41F}", group: "other", max: 100, defaultEnabled: false }
];
var NUTRITION_METRIC_KEYS = NUTRITION_METRICS.map((m) => m.key);
var DEFAULT_NUTRITION_METRICS = NUTRITION_METRICS.filter((m) => m.defaultEnabled).map((m) => m.key);
var NUTRITION_METRIC_MAP = Object.fromEntries(NUTRITION_METRICS.map((m) => [m.key, m]));
function getNutritionMetric(key) {
  return NUTRITION_METRIC_MAP[key];
}
function normalizeNutritionMetrics(keys) {
  if (!Array.isArray(keys)) return [...DEFAULT_NUTRITION_METRICS];
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const k of keys) {
    if (typeof k === "string" && NUTRITION_METRIC_MAP[k] && !seen.has(k)) {
      seen.add(k);
      out.push(k);
    }
  }
  return out;
}
function getLeagueForSteps(avgSteps) {
  if (avgSteps >= LEAGUE_STEP_THRESHOLDS.CYBORG.min) {
    return "CYBORG" /* CYBORG */;
  }
  if (avgSteps >= LEAGUE_STEP_THRESHOLDS.MARATHONER.min) {
    return "MARATHONER" /* MARATHONER */;
  }
  if (avgSteps >= LEAGUE_STEP_THRESHOLDS.CITY_WALKER.min) {
    return "CITY_WALKER" /* CITY_WALKER */;
  }
  return "OFFICE_PLANKTON" /* OFFICE_PLANKTON */;
}
function isStreakFreezeNeeded(lastActionAt) {
  if (!lastActionAt) return false;
  const hoursSinceLastAction = (Date.now() - lastActionAt.getTime()) / (1e3 * 60 * 60);
  return hoursSinceLastAction >= STREAK_TIMERS.FREEZE_THRESHOLD_HOURS;
}
var ACHIEVEMENT_DEFINITIONS = [
  { id: "first_step", name: "\u041F\u0435\u0440\u0432\u044B\u0439 \u0448\u0430\u0433", description: "\u0412\u044B\u043F\u043E\u043B\u043D\u0438 \u043F\u0435\u0440\u0432\u043E\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435", icon: "\u{1F31F}", target: 1, field: "totalActions", requiredLevel: 1, condition: { type: "first_action" } },
  { id: "week_of_fire", name: "\u041D\u0435\u0434\u0435\u043B\u044F \u043E\u0433\u043D\u044F", description: "\u0421\u0442\u0440\u0438\u043A 7 \u0434\u043D\u0435\u0439", icon: "\u{1F525}", target: 7, field: "currentStreak", requiredLevel: 1, condition: { type: "streak_days", days: 7 } },
  { id: "month_of_steel", name: "\u041C\u0435\u0441\u044F\u0446 \u0441\u0442\u0430\u043B\u0438", description: "\u0421\u0442\u0440\u0438\u043A 30 \u0434\u043D\u0435\u0439", icon: "\u{1F4AA}", target: 30, field: "currentStreak", requiredLevel: 3, condition: { type: "streak_days", days: 30 } },
  { id: "centurion", name: "\u0426\u0435\u043D\u0442\u0443\u0440\u0438\u043E\u043D", description: "\u0421\u0442\u0440\u0438\u043A 100 \u0434\u043D\u0435\u0439", icon: "\u{1F451}", target: 100, field: "currentStreak", requiredLevel: 10, condition: { type: "streak_days", days: 100 } },
  { id: "challenger", name: "\u0427\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0435\u0440", description: "\u041F\u0440\u043E\u0439\u0434\u0438 1 \u0447\u0435\u043B\u043B\u0435\u043D\u0434\u0436", icon: "\u{1F3AF}", target: 1, field: "completedChallenges", requiredLevel: 6, condition: { type: "challenges_completed", count: 1 } },
  { id: "survivor", name: "\u0412\u044B\u0436\u0438\u0432\u0448\u0438\u0439", description: "\u041F\u043E\u0431\u0435\u0434\u0438 \u0432 \u0412\u044B\u0436\u0438\u0432\u0430\u043D\u0438\u0438", icon: "\u{1F3C6}", target: 1, field: "survivalWins", requiredLevel: 6, condition: { type: "survival_winner" } },
  { id: "marathoner", name: "\u041C\u0430\u0440\u0430\u0444\u043E\u043D\u0435\u0446", description: "\u0417\u043E\u043B\u043E\u0442\u0430\u044F \u0438\u043B\u0438 \u042D\u043B\u0438\u0442\u043D\u0430\u044F \u043B\u0438\u0433\u0430", icon: "\u{1F3C3}", target: 4, field: "leagueTier", requiredLevel: 10, condition: { type: "league_reached", league: "GOLD" } },
  { id: "scientist", name: "\u0423\u0447\u0451\u043D\u044B\u0439", description: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0438 10 \u043B\u0435\u043A\u0446\u0438\u0439", icon: "\u{1F4DA}", target: 10, field: "lecturesWatched", requiredLevel: 3, condition: { type: "lectures_completed", count: 10 } },
  { id: "graduate", name: "\u0412\u044B\u043F\u0443\u0441\u043A\u043D\u0438\u043A", description: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0438 \u0432\u0441\u0435 56 \u043B\u0435\u043A\u0446\u0438\u0439 (\u0422\u0424\u0410 1)", icon: "\u{1F393}", target: 56, field: "lecturesWatched", requiredLevel: 6, condition: { type: "lectures_completed", count: 56 } },
  { id: "level_10", name: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C 10", description: "\u0414\u043E\u0441\u0442\u0438\u0433\u043D\u0438 10 \u0443\u0440\u043E\u0432\u043D\u044F", icon: "\u2B50", target: 10, field: "currentLevel", requiredLevel: 10, condition: { type: "level_reached", level: 10 } }
];
var DESIGN_TOKENS = {
  colors: {
    background: "#F0F4F8",
    surface: "rgba(255, 255, 255, 0.75)",
    primary: "#1A3A5C",
    primaryGradient: ["#1A3A5C", "#4A6CF7"],
    secondary: "#4A9FE5",
    success: "#34C759",
    warning: "#FF9500",
    danger: "#FF3B30",
    xpAccent: "#FFD60A",
    tucoin: "#AF52DE",
    textPrimary: "#1C2D41",
    textSecondary: "#6B7B8D",
    textTertiary: "#A0AEC0",
    frostOverlay: "rgba(255, 255, 255, 0.6)"
  },
  spacing: {
    horizontalMargin: 16,
    cardGap: 12,
    cardPadding: 16,
    statusBarHeight: 48,
    tabBarHeight: 56
  },
  borderRadius: {
    card: 20,
    characterCard: 28,
    button: 16,
    pill: 24
  },
  animation: {
    cardAppear: 200,
    cardTap: 150,
    progressBar: 800,
    levelUp: 2e3,
    lifeShake: 300,
    tabSwitch: 200,
    demoShake: 300,
    confetti: 2e3
  }
};
var ChallengeType = /* @__PURE__ */ ((ChallengeType2) => {
  ChallengeType2["INDIVIDUAL"] = "INDIVIDUAL";
  ChallengeType2["GROUP"] = "GROUP";
  return ChallengeType2;
})(ChallengeType || {});
var DEFAULT_TIMEZONE = "Europe/Moscow";
var DAILY_STEPS_GOAL = 1e4;
var STEPS_GOAL_MIN = 100;
var STEPS_GOAL_MAX = 1e5;
function normalizeStepsGoal(value) {
  if (value === null || value === void 0 || value === "") return null;
  const n = typeof value === "string" ? Number(value.replace(/\s/g, "")) : Number(value);
  if (!Number.isFinite(n)) return null;
  const int = Math.round(n);
  if (int < STEPS_GOAL_MIN || int > STEPS_GOAL_MAX) return null;
  return int;
}
function effectiveStepsGoal(stepsGoal) {
  return normalizeStepsGoal(stepsGoal) ?? DAILY_STEPS_GOAL;
}
var TZ_FORMAT_OPTIONS = {
  day: { locale: "en-CA", opts: { year: "numeric", month: "2-digit", day: "2-digit" } },
  hour: { locale: "en-GB", opts: { hour: "2-digit", hour12: false } },
  minutes: { locale: "en-GB", opts: { hour: "2-digit", minute: "2-digit", hour12: false } },
  clock: {
    locale: "en-CA",
    opts: {
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }
  }
};
var tzFormatCache = /* @__PURE__ */ new Map();
function tzFormatter(kind, zone) {
  const key = `${kind}|${zone}`;
  let f = tzFormatCache.get(key);
  if (!f) {
    const { locale, opts } = TZ_FORMAT_OPTIONS[kind];
    f = new Intl.DateTimeFormat(locale, { ...opts, timeZone: zone });
    tzFormatCache.set(key, f);
  }
  return f;
}
function dayKeyInTz(d, tz) {
  const zone = tz || DEFAULT_TIMEZONE;
  try {
    return tzFormatter("day", zone).format(d);
  } catch {
    return tzFormatter("day", DEFAULT_TIMEZONE).format(d);
  }
}
function hourInTz(d, tz) {
  const zone = tz || DEFAULT_TIMEZONE;
  const hourIn = (z) => {
    const s = tzFormatter("hour", z).format(d);
    return parseInt(s, 10) % 24;
  };
  try {
    return hourIn(zone);
  } catch {
    return hourIn(DEFAULT_TIMEZONE);
  }
}
var LOCAL_SEND_WINDOW_MINUTES = 60;
function parseLocalSendTime(hhmm) {
  const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(hhmm ?? "");
  return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null;
}
function isLocalSendTimeQuiet(hhmm) {
  const min = parseLocalSendTime(hhmm);
  if (min == null) return false;
  const h = Math.floor(min / 60);
  return h >= NOTIFICATION_RULES.QUIET_HOURS_START || h < NOTIFICATION_RULES.QUIET_HOURS_END;
}
function minutesInTz(d, tz) {
  const minutesIn = (z) => {
    const parts = tzFormatter("minutes", z).formatToParts(d);
    const get = (t) => parseInt(parts.find((p) => p.type === t)?.value ?? "0", 10);
    return get("hour") % 24 * 60 + get("minute");
  };
  try {
    return minutesIn(tz || DEFAULT_TIMEZONE);
  } catch {
    return minutesIn(DEFAULT_TIMEZONE);
  }
}
function isInLocalSendWindow(now, tz, hhmm, windowMinutes = LOCAL_SEND_WINDOW_MINUTES) {
  const target = parseLocalSendTime(hhmm);
  if (target == null) return true;
  return (minutesInTz(now, tz) - target + 1440) % 1440 < windowMinutes;
}
function effectiveCampaignCooldown(cooldownMinutes, sendAtLocalTime) {
  if (parseLocalSendTime(sendAtLocalTime) == null) return cooldownMinutes;
  return Math.max(cooldownMinutes - LOCAL_SEND_WINDOW_MINUTES, LOCAL_SEND_WINDOW_MINUTES);
}
function tzClockAsUtc(d, zone) {
  const parts = tzFormatter("clock", zone).formatToParts(d);
  const get = (t) => parts.find((p) => p.type === t)?.value ?? "00";
  const hour = get("hour") === "24" ? "00" : get("hour");
  return /* @__PURE__ */ new Date(`${get("year")}-${get("month")}-${get("day")}T${hour}:${get("minute")}:${get("second")}Z`);
}
function tzMidnightUtc(dayKey, tz) {
  const naive = /* @__PURE__ */ new Date(`${dayKey}T00:00:00Z`);
  const resolve = (zone) => {
    let guess = naive;
    for (let i = 0; i < 2; i++) {
      const offsetMs = tzClockAsUtc(guess, zone).getTime() - guess.getTime();
      guess = new Date(naive.getTime() - offsetMs);
    }
    return guess;
  };
  try {
    return resolve(tz || DEFAULT_TIMEZONE);
  } catch {
    try {
      return resolve(DEFAULT_TIMEZONE);
    } catch {
      return naive;
    }
  }
}
var CURATOR_DAY_OFF_WEEKDAY = 0;
function isCuratorDayOff(d, tz = DEFAULT_TIMEZONE) {
  const key = dayKeyInTz(d, tz);
  return (/* @__PURE__ */ new Date(`${key}T00:00:00Z`)).getUTCDay() === CURATOR_DAY_OFF_WEEKDAY;
}
function addCuratorWorkingTime(from, ms, tz = DEFAULT_TIMEZONE) {
  const DAY = 24 * 60 * 60 * 1e3;
  const startOfNextDay = (d) => {
    const nextKey = new Date(Date.parse(`${dayKeyInTz(d, tz)}T00:00:00Z`) + DAY).toISOString().slice(0, 10);
    return tzMidnightUtc(nextKey, tz);
  };
  let cursor = from;
  let remaining = ms;
  for (let guard = 0; guard < 14 && remaining > 0; guard++) {
    if (isCuratorDayOff(cursor, tz)) {
      cursor = startOfNextDay(cursor);
      continue;
    }
    const dayEnd = startOfNextDay(cursor);
    const available = dayEnd.getTime() - cursor.getTime();
    if (available >= remaining) return new Date(cursor.getTime() + remaining);
    remaining -= available;
    cursor = dayEnd;
  }
  return cursor;
}
function shiftDeadlineOverCuratorDayOff(deadline, tz = DEFAULT_TIMEZONE) {
  const DAY = 24 * 60 * 60 * 1e3;
  let shifted = deadline;
  for (let i = 0; i < 7 && isCuratorDayOff(new Date(shifted.getTime() - 1), tz); i++) {
    shifted = new Date(shifted.getTime() + DAY);
  }
  return shifted;
}
function tzDayStartUtc(d, tz) {
  return tzMidnightUtc(dayKeyInTz(d, tz), tz);
}
function ceilToTzDayEnd(d, tz = DEFAULT_TIMEZONE) {
  const start = tzDayStartUtc(d, tz);
  if (start.getTime() === d.getTime()) return d;
  const nextKey = new Date(Date.parse(`${dayKeyInTz(d, tz)}T00:00:00Z`) + 24 * 60 * 60 * 1e3).toISOString().slice(0, 10);
  return tzMidnightUtc(nextKey, tz);
}
function tzWeekStartKey(d, tz) {
  const key = dayKeyInTz(d, tz);
  const asUtc = /* @__PURE__ */ new Date(`${key}T00:00:00Z`);
  const dow = (asUtc.getUTCDay() + 6) % 7;
  asUtc.setUTCDate(asUtc.getUTCDate() - dow);
  return asUtc.toISOString().slice(0, 10);
}
function tzMonthStartKey(d, tz) {
  return `${dayKeyInTz(d, tz).slice(0, 7)}-01`;
}
function lastCompletedWeekKeys(tz, now = /* @__PURE__ */ new Date()) {
  const todayKey = dayKeyInTz(now, tz);
  const [y, m, d] = todayKey.split("-").map(Number);
  const today = new Date(Date.UTC(y, m - 1, d));
  const dow = today.getUTCDay() || 7;
  const lastMonday = new Date(today.getTime() - (dow - 1 + 7) * 864e5);
  return Array.from(
    { length: 7 },
    (_, i) => new Date(lastMonday.getTime() + i * 864e5).toISOString().slice(0, 10)
  );
}
function completedDayKeys(n, tz, now = /* @__PURE__ */ new Date()) {
  const todayKey = dayKeyInTz(now, tz);
  const [y, m, d] = todayKey.split("-").map(Number);
  const keys = [];
  for (let i = n; i >= 1; i--) {
    keys.push(new Date(Date.UTC(y, m - 1, d - i)).toISOString().slice(0, 10));
  }
  return keys;
}
function buildReloadUrl(buildId, hash, nonce) {
  return `/?v=${encodeURIComponent(buildId)}&r=${encodeURIComponent(nonce)}${hash || ""}`;
}
function decideUpdate(input) {
  const { current, server, busy, reloadAttempted } = input;
  if (!server || !current) return "none";
  if (server === current) return "none";
  if (busy || reloadAttempted) return "banner";
  return "reload";
}
var TELEMETRY = {
  /// Как часто мини-апп отправляет накопленный буфер. Реже — экономнее по
  /// запросам, но при закрытии приложения теряется хвост до этого интервала
  /// (pagehide спасает не всегда: Telegram WebView умеет убивать вкладку молча).
  FLUSH_INTERVAL_SEC: 20,
  /// Шаг тикера активного времени. Должен делить FLUSH_INTERVAL_SEC нацело.
  TICK_SEC: 5,
  /// Пауза, после которой возвращение считается НОВОЙ сессией. 30 минут —
  /// отраслевой стандарт (GA), и он же разумен для мини-аппа: человек закрыл
  /// Telegram, вернулся через час — это второй визит, а не продолжение первого.
  SESSION_IDLE_TIMEOUT_MIN: 30,
  /// Предохранитель от бесконечного накопления, если вкладка «зависла»
  /// видимой: за один флаш не может прийти больше времени, чем прошло.
  MAX_SECONDS_PER_FLUSH: 120,
  /// Потолок событий в одной отправке — защита от раздутого буфера.
  MAX_EVENTS_PER_FLUSH: 200
};
var SCREEN_LABELS = {
  "/diary": "\u0414\u043D\u0435\u0432\u043D\u0438\u043A \u0434\u043D\u044F",
  "/diary/workout": "\u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0430",
  "/diary/workout/active": "\u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0430 (\u0438\u0434\u0451\u0442)",
  "/diary/workout/summary": "\u0418\u0442\u043E\u0433\u0438 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438",
  "/workout": "\u0422\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0430",
  "/workout/templates": "\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u043A",
  "/home": "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  "/lectures": "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435",
  "/lectures/:id": "\u041B\u0435\u043A\u0446\u0438\u044F",
  "/content": "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435",
  "/content/lecture/:id": "\u041B\u0435\u043A\u0446\u0438\u044F",
  "/leaderboard": "\u0420\u0435\u0439\u0442\u0438\u043D\u0433",
  "/leaderboard/challenges": "\u0427\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0438",
  "/leaderboard/survival": "\u0412\u044B\u0436\u0438\u0432\u0430\u043D\u0438\u0435",
  "/challenges": "\u0427\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0438",
  "/shop": "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
  "/measurements": "\u0417\u0430\u043C\u0435\u0440\u044B",
  "/progress-photos": "\u0424\u043E\u0442\u043E \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0430",
  "/analytics": "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "/chat": "\u0427\u0430\u0442",
  "/profile": "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
  "/character": "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u0436",
  "/settings": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
  "/curator/clients": "\u041A\u0443\u0440\u0430\u0442\u043E\u0440: \u043A\u043B\u0438\u0435\u043D\u0442\u044B",
  "/curator/clients/:id": "\u041A\u0443\u0440\u0430\u0442\u043E\u0440: \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "/curator/clients/:id/program": "\u041A\u0443\u0440\u0430\u0442\u043E\u0440: \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430",
  "/curator/clients/:id/program/new": "\u041A\u0443\u0440\u0430\u0442\u043E\u0440: \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B",
  "/curator/profile": "\u041A\u0443\u0440\u0430\u0442\u043E\u0440: \u043F\u0440\u043E\u0444\u0438\u043B\u044C"
};
function screenLabel(screen) {
  return SCREEN_LABELS[screen] ?? screen;
}
var PROGRAM_PURCHASE_MIN_AMOUNT = 2e4;
var RENEWAL_MIN_GAP_DAYS = 45;
var STREAM_LENGTH_DAYS = 90;
var PRODUCT_ANALYTICS_EPOCH = "2026-07-01";
function isProgramPurchase(input) {
  if (input.internalProduct === "NONE") return false;
  if (input.internalProduct) return true;
  return (input.totalAmount ?? 0) >= PROGRAM_PURCHASE_MIN_AMOUNT;
}
export {
  ACHIEVEMENT_DEFINITIONS,
  ACHIEVEMENT_SCENARIOS,
  ADMIN_NAV_GROUPS,
  ANALYTICS_PRODUCTS,
  ANALYTICS_PRODUCT_LABELS,
  ActionType,
  AdminRole,
  BOT_MAX_WEEKLY_XP_CEILING,
  BOT_MIN_WEEKLY_XP_FLOOR,
  BUG_ENV_LABEL,
  BUG_PRIORITY_LABEL,
  BUG_PRIORITY_ORDER,
  BUG_STATUS_ACTIVE,
  BUG_STATUS_AWAITING_REPORTER,
  BUG_STATUS_CLOSED,
  BUG_STATUS_LABEL,
  BugAuthorType,
  BugEnvironment,
  BugMediaType,
  BugPriority,
  BugStatus,
  CALC_ACTIVITY,
  CALC_GOAL,
  CHALLENGE_COMPLETION_TUCOIN,
  CHARACTER_DEGRADATION_DAYS,
  CHARACTER_STAGE_FOR_LEVEL,
  CLIENT_STATUS_SCENARIOS,
  CLUB_MONTH_DAYS,
  CLUB_PROGRAMS_SEED,
  COMING_SOON_SHOP_ITEMS,
  COMMUNITY_APPROVE_PRODUCTS,
  COMMUNITY_AUDIENCES,
  COMMUNITY_KEEP_PRODUCTS,
  CONTROL_POINTS,
  CURATOR_DAY_OFF_WEEKDAY,
  CURATOR_PAYMENT,
  CURATOR_PAYMENT_SCENARIOS,
  CURATOR_WORK_TERM_PRODUCTS,
  ChallengeType,
  CharacterMood,
  CharacterPhase,
  ClientMode,
  CommentTargetType,
  ConversationMode,
  CtaType,
  CuratorAssignmentStatus,
  CuratorRequestStatus,
  CuratorTrackingStatus,
  CuratorTrackingType,
  DAILY_STEPS_GOAL,
  DAILY_TIPS,
  DEFAULT_CURATOR_RATE,
  DEFAULT_NUTRITION_METRICS,
  DEFAULT_PRODUCT_FEATURES,
  DEFAULT_TIMEZONE,
  DESIGN_TOKENS,
  EXTRA_SLOTS,
  FEATURE_STATES,
  FEATURE_STATE_LABELS,
  FEEDBACK_ALERT_THRESHOLD,
  FEEDBACK_SURVEY,
  GOAL_LABELS,
  Gender,
  Goal,
  KBJU_INPUT_RANGES,
  LEAGUE_ROOM_SIZE,
  LEAGUE_SCENARIOS,
  LEAGUE_STEP_THRESHOLDS,
  LEAGUE_TIERS,
  LEAGUE_ZONES,
  LEVEL_CAP,
  LEVEL_SCENARIOS,
  LEVEL_XP_REQUIREMENTS,
  LOCAL_SEND_WINDOW_MINUTES,
  League,
  LeagueType,
  MEASUREMENT_CYCLE_ANCHOR_DOW,
  MEASUREMENT_WINDOW_DAYS,
  META_SHIELD_LEAGUES,
  META_SHIELD_PRODUCTS,
  MINI_APP_SCREENS,
  MINI_APP_SCREEN_KEYS,
  MealType,
  MessageRole,
  NOTIFICATION_ONBOARDING_ONLY_TYPES,
  NOTIFICATION_RULES,
  NOTIFICATION_TRANSACTIONAL_TYPES,
  NOTIFICATION_TYPE_COOLDOWN_HOURS,
  NOTIFICATION_TYPE_FEATURE,
  NPS_SURVEY,
  NUTRITION_DAY_TYPE_EMOJI,
  NUTRITION_DAY_TYPE_LABELS,
  NUTRITION_METRICS,
  NUTRITION_METRIC_KEYS,
  NotificationType,
  NutritionDayType,
  OTHER_PRODUCT,
  PAID_ORDER_PAYMENTS,
  PHOTO_REMINDER_MIN_DAYS_SINCE_LAST,
  PRETTY_CHARACTER_LEVEL,
  PRODUCTS_IN_MATRIX,
  PRODUCT_ACCESS,
  PRODUCT_ANALYTICS_EPOCH,
  PRODUCT_FEATURES,
  PRODUCT_FEATURE_LABELS,
  PRODUCT_RANK,
  PROGRAM_DEFAULT_ACCESS_MONTHS,
  PROGRAM_METHODICHKA_ACCESS_MONTHS,
  PROGRAM_PURCHASE_MIN_AMOUNT,
  PROGRAM_RENEWAL_GRACE_DAYS,
  PROGRAM_RENEWAL_WINDOW_DAYS,
  PROGRAM_REPS_MAX_LENGTH,
  PROGRAM_TARIFF_SEED,
  PROGRAM_TERM_CUTOFF,
  PaymentReviewStatus,
  Product,
  READ_ONLY_PERIOD_MONTHS,
  REALISTIC_MAX_WEEKLY_XP,
  RENEWAL_FAMILY_PRODUCTS,
  RENEWAL_MIN_GAP_DAYS,
  SCREEN_LABELS,
  SEASON_ZONE_SCENARIOS,
  SHOP_ITEM_CATEGORY,
  SHOP_ORDER_STATUS_LABELS,
  SLEEP_QUALITY_OPTIONS,
  STARTUP_WINDOW_HTML_MAX,
  STARTUP_WINDOW_MESSAGE_TYPE,
  STARTUP_WINDOW_SAMPLE_VARS,
  STARTUP_WINDOW_SANDBOX,
  STARTUP_WINDOW_VARS,
  START_DATE_MAX_AHEAD_DAYS,
  STEP2_FLOW_STALE_DAYS,
  STEPS_GOAL_MAX,
  STEPS_GOAL_MIN,
  STREAK_MILESTONES,
  STREAK_SCENARIOS,
  STREAK_TIMERS,
  STREAK_TUCOIN_BONUSES,
  STREAM_LENGTH_DAYS,
  SUBSCRIPTION_MONTHS,
  SURVIVAL_INACTIVITY_HOURS,
  SURVIVAL_LIVES_PER_GAME,
  SURVIVAL_SCENARIOS,
  ScheduleType,
  SettlementPeriodStatus,
  ShopCategory,
  ShopItemType,
  ShopOrderStatus,
  StartupWindowFrequency,
  StreakEventType,
  SurveyType,
  SurvivalStatus,
  SystemEvent,
  TELEMETRY,
  TFA_PURCHASE_HORIZON_MONTHS,
  TUCOIN_LEVEL_BONUSES,
  TUCOIN_LIMITS,
  TUCOIN_SCENARIOS,
  WEEKLY_WEIGHT_MIN_PER_WINDOW,
  WEEKLY_WEIGHT_MIN_SPAN_DAYS,
  WEIGHT_EMA_ALPHA,
  WEIGHT_TARGET_RATE_BY_GOAL,
  WEIGHT_TARGET_RATE_DEFAULT,
  WEIGHT_TARGET_RATE_LIMIT,
  XL_ORDER_PAYMENTS,
  XL_PURCHASE_FIELD,
  XP_REWARDS,
  accessStartFrom,
  activeLicenseEnd,
  addCuratorWorkingTime,
  addMonthsUtc,
  adminNavItemFor,
  assertClientInvariants,
  bestProgressSet,
  boughtBeforeProgramTerms,
  buildReloadUrl,
  buildStartupWindowDocument,
  calculateCuratorPayment,
  calculateCuratorPaymentConfigurable,
  calculateKbju,
  calculateLevel,
  calculateSettlementShiftDays,
  canBuyClubMonth,
  canLogWorkouts,
  canPerformActions,
  canSelfEditProgram,
  ceilToTzDayEnd,
  clampBotWeeklyXp,
  clampWeightTargetRate,
  classifyTariffName,
  clientFirstName,
  clientInvariantViolations,
  communityAccess,
  compareLeagueMembers,
  completedDayKeys,
  computeClientStatus,
  computeRenewal,
  computeTestWeekStart,
  computeUnlockAt,
  coursePlanIdsOf,
  curatorWorkEndFor,
  curatorWorkEndFrom,
  dayKeyInTz,
  decideLeagueZone,
  decideSeasonZone,
  decideStreakTimerAction,
  decideSurvivalLifeLoss,
  decideUpdate,
  delayToMs,
  effectiveCampaignCooldown,
  effectiveCharacterLevel,
  effectiveClientProduct,
  effectiveInactivityHours,
  effectiveProductFeatures,
  effectiveStepsGoal,
  estimate1RM,
  evaluateAchievementCondition,
  featureState,
  feedbackLowScores,
  fileIdFromEzActions,
  findMiniAppScreen,
  firstWorkingSet,
  flowDatesForGroup,
  flowMarker,
  formatRuDayRange,
  formatSet,
  formatStrengthGain,
  formatWeight,
  getCharacterPhase,
  getExtraSlotClosesAt,
  getExtraSlotOpensAt,
  getExtraSlotWeeks,
  getLeagueByTier,
  getLeagueForSteps,
  getNutritionMetric,
  getOpenExtraSlots,
  getPhotoReminderDedupSince,
  getPhotoReminderSlotOpensAt,
  getStageEpoch,
  getStageWeek,
  getStageWeekExcludingPauses,
  getXpForAction,
  getXpForNextLevel,
  graceGapDayKeys,
  hasAppAccess,
  hasLink,
  hasMetaShieldProduct,
  hasPostProgramAccess,
  hasProductAccess,
  hasPushContent,
  hourInTz,
  interpolateStartupWindowVars,
  isAllowedStartupWindowHref,
  isAnalyticsProduct,
  isBlankMessageTemplate,
  isCuratorDayOff,
  isDayInsideLastSuspension,
  isFeatureOpen,
  isGamificationEnabled,
  isInLocalSendWindow,
  isLevelCapped,
  isLocalSendTimeQuiet,
  isMeasurementWindowOpen,
  isPaidOrder,
  isPaidXlOrder,
  isPhotoReminderDue,
  isProgramPurchase,
  isProgramSectionVisible,
  isReadOnly,
  isRenewalWindow,
  isSameMeasurementCycle,
  isShopProductPurchasable,
  isStreakFreezeNeeded,
  isSuspended,
  isTemplateListedForClient,
  isTemplateOpenToClient,
  isValidKbjuInput,
  lastCompletedWeekKeys,
  latestLicenseEnd,
  latestWeightEma,
  lectureModulesProductFor,
  lecturesUnlockedAtOnce,
  looksLikeGarbledName,
  matchesSearch,
  materializeScenarioState,
  maxDate,
  maxStartDate,
  measurementCycleStart,
  measurementWindowEnd,
  mergeWeightSources,
  metaShieldStatus,
  minutesInTz,
  nearestFridayOnOrAfter,
  needsNameResync,
  nextMeasurementCycleStart,
  nextPrizeShipmentDate,
  nextStreakMilestone,
  normalizeNutritionMetrics,
  normalizeSearchText,
  normalizeStepsGoal,
  normalizeXlPurchaseFilter,
  ownLectureCourseFor,
  parseLocalSendTime,
  parseStartupWindowMessage,
  parseXlContactRef,
  pausedMsBetween,
  pickDailyTip,
  pickStrongestProduct,
  postProgramAccessMonths,
  postProgramAccessUntil,
  programAccessEnd,
  programGenderFromName,
  programKeyFromName,
  programKindFromName,
  programLevelFromName,
  programMatchesPurchase,
  programOrderMonths,
  progressGainPct,
  progressMetric,
  rankLeagueMembers,
  renewalFamilyOf,
  requiresCurator,
  resolveExpectedProduct,
  resolveGrantedProducts,
  resolvePurchasedPrograms,
  resolveStepState,
  resolveWeightTargetRate,
  revenueProductOf,
  screenLabel,
  searchStems,
  setProgressScore,
  shiftDeadlineOverCuratorDayOff,
  shouldLoseSurvivalLife,
  splitStartupWindowHtml,
  splitSurvivalPrize,
  stageStartsWithTestWeek,
  strengthGain,
  subscriptionEndFrom,
  summarizeRevenue,
  surveyLowScores,
  suspensionDays,
  techniqueWeeklyLimit,
  tfaCourseRoleFor,
  tfaEndByOrders,
  tokenizeLinks,
  tzDayStartUtc,
  tzMidnightUtc,
  tzMonthStartKey,
  tzWeekStartKey,
  weekStartKey,
  weeklyWeightDeltaPct,
  weightEmaSeries,
  weightTrendTone,
  xlOrderPayment,
  xlPurchaseSince
};
